export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _int4: any;
  _text: any;
  _uuid: any;
  bigint: any;
  date: any;
  jsonb: any;
  numeric: any;
  time: any;
  timestamptz: any;
  uuid: any;
};


/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: Maybe<Array<Scalars['Int']>>;
  /** does the array contain the given value */
  _contains?: Maybe<Array<Scalars['Int']>>;
  _eq?: Maybe<Array<Scalars['Int']>>;
  _gt?: Maybe<Array<Scalars['Int']>>;
  _gte?: Maybe<Array<Scalars['Int']>>;
  _in?: Maybe<Array<Array<Scalars['Int']>>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Array<Scalars['Int']>>;
  _lte?: Maybe<Array<Scalars['Int']>>;
  _neq?: Maybe<Array<Scalars['Int']>>;
  _nin?: Maybe<Array<Array<Scalars['Int']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: Maybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: Maybe<Array<Scalars['String']>>;
  _eq?: Maybe<Array<Scalars['String']>>;
  _gt?: Maybe<Array<Scalars['String']>>;
  _gte?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Array<Scalars['String']>>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Array<Scalars['String']>>;
  _lte?: Maybe<Array<Scalars['String']>>;
  _neq?: Maybe<Array<Scalars['String']>>;
  _nin?: Maybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};




/** columns and relationships of "area_status" */
export type Area_Status = {
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: Areas_Aggregate;
  display: Scalars['String'];
  value: Scalars['String'];
};


/** columns and relationships of "area_status" */
export type Area_StatusAreasArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "area_status" */
export type Area_StatusAreas_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};

/** aggregated selection of "area_status" */
export type Area_Status_Aggregate = {
  aggregate?: Maybe<Area_Status_Aggregate_Fields>;
  nodes: Array<Area_Status>;
};

/** aggregate fields of "area_status" */
export type Area_Status_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Area_Status_Max_Fields>;
  min?: Maybe<Area_Status_Min_Fields>;
};


/** aggregate fields of "area_status" */
export type Area_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Area_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "area_status". All fields are combined with a logical 'AND'. */
export type Area_Status_Bool_Exp = {
  _and?: Maybe<Array<Area_Status_Bool_Exp>>;
  _not?: Maybe<Area_Status_Bool_Exp>;
  _or?: Maybe<Array<Area_Status_Bool_Exp>>;
  areas?: Maybe<Areas_Bool_Exp>;
  areas_aggregate?: Maybe<Areas_Aggregate_Bool_Exp>;
  display?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "area_status" */
export enum Area_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  AreaStatusPkey = 'area_status_pkey'
}

export enum Area_Status_Enum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "area_status_enum". All fields are combined with logical 'AND'. */
export type Area_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Area_Status_Enum>;
  _in?: Maybe<Array<Area_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Area_Status_Enum>;
  _nin?: Maybe<Array<Area_Status_Enum>>;
};

/** input type for inserting data into table "area_status" */
export type Area_Status_Insert_Input = {
  areas?: Maybe<Areas_Arr_Rel_Insert_Input>;
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Area_Status_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Area_Status_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "area_status" */
export type Area_Status_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Area_Status>;
};

/** input type for inserting object relation for remote table "area_status" */
export type Area_Status_Obj_Rel_Insert_Input = {
  data: Area_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Area_Status_On_Conflict>;
};

/** on_conflict condition type for table "area_status" */
export type Area_Status_On_Conflict = {
  constraint: Area_Status_Constraint;
  update_columns?: Array<Area_Status_Update_Column>;
  where?: Maybe<Area_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "area_status". */
export type Area_Status_Order_By = {
  areas_aggregate?: Maybe<Areas_Aggregate_Order_By>;
  display?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: area_status */
export type Area_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "area_status" */
export enum Area_Status_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "area_status" */
export type Area_Status_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "area_status" */
export type Area_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Area_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Area_Status_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "area_status" */
export enum Area_Status_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Area_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Area_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Area_Status_Bool_Exp;
};

/** columns and relationships of "area_type" */
export type Area_Type = {
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: Areas_Aggregate;
  display: Scalars['String'];
  value: Scalars['String'];
};


/** columns and relationships of "area_type" */
export type Area_TypeAreasArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "area_type" */
export type Area_TypeAreas_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};

/** aggregated selection of "area_type" */
export type Area_Type_Aggregate = {
  aggregate?: Maybe<Area_Type_Aggregate_Fields>;
  nodes: Array<Area_Type>;
};

/** aggregate fields of "area_type" */
export type Area_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Area_Type_Max_Fields>;
  min?: Maybe<Area_Type_Min_Fields>;
};


/** aggregate fields of "area_type" */
export type Area_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Area_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "area_type". All fields are combined with a logical 'AND'. */
export type Area_Type_Bool_Exp = {
  _and?: Maybe<Array<Area_Type_Bool_Exp>>;
  _not?: Maybe<Area_Type_Bool_Exp>;
  _or?: Maybe<Array<Area_Type_Bool_Exp>>;
  areas?: Maybe<Areas_Bool_Exp>;
  areas_aggregate?: Maybe<Areas_Aggregate_Bool_Exp>;
  display?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "area_type" */
export enum Area_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  AreaTypePkey = 'area_type_pkey'
}

export enum Area_Type_Enum {
  /** Bar */
  Bar = 'bar',
  /** Club */
  Club = 'club',
  /** Event Space */
  EventSpace = 'event_space',
  /** Lounge */
  Lounge = 'lounge',
  /** Pool */
  Pool = 'pool',
  /** Restaurant */
  Restaurant = 'restaurant'
}

/** Boolean expression to compare columns of type "area_type_enum". All fields are combined with logical 'AND'. */
export type Area_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Area_Type_Enum>;
  _in?: Maybe<Array<Area_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Area_Type_Enum>;
  _nin?: Maybe<Array<Area_Type_Enum>>;
};

/** input type for inserting data into table "area_type" */
export type Area_Type_Insert_Input = {
  areas?: Maybe<Areas_Arr_Rel_Insert_Input>;
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Area_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Area_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "area_type" */
export type Area_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Area_Type>;
};

/** input type for inserting object relation for remote table "area_type" */
export type Area_Type_Obj_Rel_Insert_Input = {
  data: Area_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Area_Type_On_Conflict>;
};

/** on_conflict condition type for table "area_type" */
export type Area_Type_On_Conflict = {
  constraint: Area_Type_Constraint;
  update_columns?: Array<Area_Type_Update_Column>;
  where?: Maybe<Area_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "area_type". */
export type Area_Type_Order_By = {
  areas_aggregate?: Maybe<Areas_Aggregate_Order_By>;
  display?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: area_type */
export type Area_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "area_type" */
export enum Area_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "area_type" */
export type Area_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "area_type" */
export type Area_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Area_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Area_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "area_type" */
export enum Area_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Area_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Area_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Area_Type_Bool_Exp;
};

/** columns and relationships of "areas" */
export type Areas = {
  area_number?: Maybe<Scalars['Int']>;
  /** An object relationship */
  area_status: Area_Status;
  /** An object relationship */
  area_type: Area_Type;
  /** An array relationship */
  bookings: Array<Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Bookings_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** An array relationship */
  guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_aggregate: Guidelines_Aggregate;
  id: Scalars['uuid'];
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  status: Area_Status_Enum;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type: Area_Type_Enum;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  venue?: Maybe<Tenants>;
  venue_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "areas" */
export type AreasBookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "areas" */
export type AreasBookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "areas" */
export type AreasDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "areas" */
export type AreasDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "areas" */
export type AreasGuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "areas" */
export type AreasGuidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};

/** aggregated selection of "areas" */
export type Areas_Aggregate = {
  aggregate?: Maybe<Areas_Aggregate_Fields>;
  nodes: Array<Areas>;
};

export type Areas_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Areas_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Areas_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Areas_Aggregate_Bool_Exp_Count>;
};

export type Areas_Aggregate_Bool_Exp_Bool_And = {
  arguments: Areas_Select_Column_Areas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Areas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Areas_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Areas_Select_Column_Areas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Areas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Areas_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Areas_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Areas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "areas" */
export type Areas_Aggregate_Fields = {
  avg?: Maybe<Areas_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Areas_Max_Fields>;
  min?: Maybe<Areas_Min_Fields>;
  stddev?: Maybe<Areas_Stddev_Fields>;
  stddev_pop?: Maybe<Areas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Areas_Stddev_Samp_Fields>;
  sum?: Maybe<Areas_Sum_Fields>;
  var_pop?: Maybe<Areas_Var_Pop_Fields>;
  var_samp?: Maybe<Areas_Var_Samp_Fields>;
  variance?: Maybe<Areas_Variance_Fields>;
};


/** aggregate fields of "areas" */
export type Areas_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Areas_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "areas" */
export type Areas_Aggregate_Order_By = {
  avg?: Maybe<Areas_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Areas_Max_Order_By>;
  min?: Maybe<Areas_Min_Order_By>;
  stddev?: Maybe<Areas_Stddev_Order_By>;
  stddev_pop?: Maybe<Areas_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Areas_Stddev_Samp_Order_By>;
  sum?: Maybe<Areas_Sum_Order_By>;
  var_pop?: Maybe<Areas_Var_Pop_Order_By>;
  var_samp?: Maybe<Areas_Var_Samp_Order_By>;
  variance?: Maybe<Areas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "areas" */
export type Areas_Arr_Rel_Insert_Input = {
  data: Array<Areas_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Areas_On_Conflict>;
};

/** aggregate avg on columns */
export type Areas_Avg_Fields = {
  area_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "areas" */
export type Areas_Avg_Order_By = {
  area_number?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "areas". All fields are combined with a logical 'AND'. */
export type Areas_Bool_Exp = {
  _and?: Maybe<Array<Areas_Bool_Exp>>;
  _not?: Maybe<Areas_Bool_Exp>;
  _or?: Maybe<Array<Areas_Bool_Exp>>;
  area_number?: Maybe<Int_Comparison_Exp>;
  area_status?: Maybe<Area_Status_Bool_Exp>;
  area_type?: Maybe<Area_Type_Bool_Exp>;
  bookings?: Maybe<Bookings_Bool_Exp>;
  bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  guidelines?: Maybe<Guidelines_Bool_Exp>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  instagram?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  poc?: Maybe<String_Comparison_Exp>;
  status?: Maybe<Area_Status_Enum_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<Area_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
  venue?: Maybe<Tenants_Bool_Exp>;
  venue_id?: Maybe<Uuid_Comparison_Exp>;
  website?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "areas" */
export enum Areas_Constraint {
  /** unique or primary key constraint on columns "id" */
  AreasPkey = 'areas_pkey'
}

/** input type for incrementing numeric columns in table "areas" */
export type Areas_Inc_Input = {
  area_number?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "areas" */
export type Areas_Insert_Input = {
  area_number?: Maybe<Scalars['Int']>;
  area_status?: Maybe<Area_Status_Obj_Rel_Insert_Input>;
  area_type?: Maybe<Area_Type_Obj_Rel_Insert_Input>;
  bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  status?: Maybe<Area_Status_Enum>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Area_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  venue?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  venue_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Areas_Max_Fields = {
  area_number?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "areas" */
export type Areas_Max_Order_By = {
  area_number?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Areas_Min_Fields = {
  area_number?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "areas" */
export type Areas_Min_Order_By = {
  area_number?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** response of any mutation on the table "areas" */
export type Areas_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Areas>;
};

/** input type for inserting object relation for remote table "areas" */
export type Areas_Obj_Rel_Insert_Input = {
  data: Areas_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Areas_On_Conflict>;
};

/** on_conflict condition type for table "areas" */
export type Areas_On_Conflict = {
  constraint: Areas_Constraint;
  update_columns?: Array<Areas_Update_Column>;
  where?: Maybe<Areas_Bool_Exp>;
};

/** Ordering options when selecting data from "areas". */
export type Areas_Order_By = {
  area_number?: Maybe<Order_By>;
  area_status?: Maybe<Area_Status_Order_By>;
  area_type?: Maybe<Area_Type_Order_By>;
  bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  deleted?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
  venue?: Maybe<Tenants_Order_By>;
  venue_id?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** primary key columns input for table: areas */
export type Areas_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "areas" */
export enum Areas_Select_Column {
  /** column name */
  AreaNumber = 'area_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Name = 'name',
  /** column name */
  Poc = 'poc',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueId = 'venue_id',
  /** column name */
  Website = 'website'
}

/** select "areas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "areas" */
export enum Areas_Select_Column_Areas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "areas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "areas" */
export enum Areas_Select_Column_Areas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "areas" */
export type Areas_Set_Input = {
  area_number?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  status?: Maybe<Area_Status_Enum>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Area_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Areas_Stddev_Fields = {
  area_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "areas" */
export type Areas_Stddev_Order_By = {
  area_number?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Areas_Stddev_Pop_Fields = {
  area_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "areas" */
export type Areas_Stddev_Pop_Order_By = {
  area_number?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Areas_Stddev_Samp_Fields = {
  area_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "areas" */
export type Areas_Stddev_Samp_Order_By = {
  area_number?: Maybe<Order_By>;
};

/** Streaming cursor of the table "areas" */
export type Areas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Areas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Areas_Stream_Cursor_Value_Input = {
  area_number?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  status?: Maybe<Area_Status_Enum>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Area_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Areas_Sum_Fields = {
  area_number?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "areas" */
export type Areas_Sum_Order_By = {
  area_number?: Maybe<Order_By>;
};

/** update columns of table "areas" */
export enum Areas_Update_Column {
  /** column name */
  AreaNumber = 'area_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Name = 'name',
  /** column name */
  Poc = 'poc',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueId = 'venue_id',
  /** column name */
  Website = 'website'
}

export type Areas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Areas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Areas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Areas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Areas_Var_Pop_Fields = {
  area_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "areas" */
export type Areas_Var_Pop_Order_By = {
  area_number?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Areas_Var_Samp_Fields = {
  area_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "areas" */
export type Areas_Var_Samp_Order_By = {
  area_number?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Areas_Variance_Fields = {
  area_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "areas" */
export type Areas_Variance_Order_By = {
  area_number?: Maybe<Order_By>;
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "blackouts" */
export type Blackouts = {
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  start_at: Scalars['timestamptz'];
  /** An object relationship */
  talent: Users;
  talent_id: Scalars['uuid'];
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
};

/** aggregated selection of "blackouts" */
export type Blackouts_Aggregate = {
  aggregate?: Maybe<Blackouts_Aggregate_Fields>;
  nodes: Array<Blackouts>;
};

export type Blackouts_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Blackouts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Blackouts_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Blackouts_Aggregate_Bool_Exp_Count>;
};

export type Blackouts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Blackouts_Select_Column_Blackouts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Blackouts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Blackouts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Blackouts_Select_Column_Blackouts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Blackouts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Blackouts_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Blackouts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Blackouts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "blackouts" */
export type Blackouts_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Blackouts_Max_Fields>;
  min?: Maybe<Blackouts_Min_Fields>;
};


/** aggregate fields of "blackouts" */
export type Blackouts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Blackouts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "blackouts" */
export type Blackouts_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Blackouts_Max_Order_By>;
  min?: Maybe<Blackouts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "blackouts" */
export type Blackouts_Arr_Rel_Insert_Input = {
  data: Array<Blackouts_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Blackouts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "blackouts". All fields are combined with a logical 'AND'. */
export type Blackouts_Bool_Exp = {
  _and?: Maybe<Array<Blackouts_Bool_Exp>>;
  _not?: Maybe<Blackouts_Bool_Exp>;
  _or?: Maybe<Array<Blackouts_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  end_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  start_at?: Maybe<Timestamptz_Comparison_Exp>;
  talent?: Maybe<Users_Bool_Exp>;
  talent_id?: Maybe<Uuid_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "blackouts" */
export enum Blackouts_Constraint {
  /** unique or primary key constraint on columns "id" */
  BlackoutsPkey = 'blackouts_pkey'
}

/** input type for inserting data into table "blackouts" */
export type Blackouts_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  talent?: Maybe<Users_Obj_Rel_Insert_Input>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Blackouts_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  end_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "blackouts" */
export type Blackouts_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  end_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  start_at?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Blackouts_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  end_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "blackouts" */
export type Blackouts_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  end_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  start_at?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** response of any mutation on the table "blackouts" */
export type Blackouts_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Blackouts>;
};

/** on_conflict condition type for table "blackouts" */
export type Blackouts_On_Conflict = {
  constraint: Blackouts_Constraint;
  update_columns?: Array<Blackouts_Update_Column>;
  where?: Maybe<Blackouts_Bool_Exp>;
};

/** Ordering options when selecting data from "blackouts". */
export type Blackouts_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  deleted?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  end_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  start_at?: Maybe<Order_By>;
  talent?: Maybe<Users_Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: blackouts */
export type Blackouts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "blackouts" */
export enum Blackouts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  Id = 'id',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  TalentId = 'talent_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** select "blackouts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "blackouts" */
export enum Blackouts_Select_Column_Blackouts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "blackouts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "blackouts" */
export enum Blackouts_Select_Column_Blackouts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "blackouts" */
export type Blackouts_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "blackouts" */
export type Blackouts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Blackouts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Blackouts_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** update columns of table "blackouts" */
export enum Blackouts_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  Id = 'id',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  TalentId = 'talent_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Blackouts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Blackouts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Blackouts_Bool_Exp;
};

/** columns and relationships of "booking_series" */
export type Booking_Series = {
  /** An array relationship */
  bookings: Array<Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Bookings_Aggregate;
  by_day?: Maybe<Array<Scalars['String']>>;
  by_month_day?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  end_date?: Maybe<Scalars['date']>;
  frequency: Scalars['String'];
  id: Scalars['uuid'];
  interval: Scalars['Int'];
  /** An object relationship */
  master_booking?: Maybe<Bookings>;
  master_booking_id?: Maybe<Scalars['uuid']>;
  next_expansion?: Maybe<Scalars['date']>;
  rrule?: Maybe<Scalars['String']>;
  start_date: Scalars['date'];
  tenant_id?: Maybe<Scalars['uuid']>;
  timezone: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
};


/** columns and relationships of "booking_series" */
export type Booking_SeriesBookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "booking_series" */
export type Booking_SeriesBookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};

/** aggregated selection of "booking_series" */
export type Booking_Series_Aggregate = {
  aggregate?: Maybe<Booking_Series_Aggregate_Fields>;
  nodes: Array<Booking_Series>;
};

export type Booking_Series_Aggregate_Bool_Exp = {
  count?: Maybe<Booking_Series_Aggregate_Bool_Exp_Count>;
};

export type Booking_Series_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Booking_Series_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Booking_Series_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "booking_series" */
export type Booking_Series_Aggregate_Fields = {
  avg?: Maybe<Booking_Series_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Booking_Series_Max_Fields>;
  min?: Maybe<Booking_Series_Min_Fields>;
  stddev?: Maybe<Booking_Series_Stddev_Fields>;
  stddev_pop?: Maybe<Booking_Series_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Booking_Series_Stddev_Samp_Fields>;
  sum?: Maybe<Booking_Series_Sum_Fields>;
  var_pop?: Maybe<Booking_Series_Var_Pop_Fields>;
  var_samp?: Maybe<Booking_Series_Var_Samp_Fields>;
  variance?: Maybe<Booking_Series_Variance_Fields>;
};


/** aggregate fields of "booking_series" */
export type Booking_Series_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Booking_Series_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking_series" */
export type Booking_Series_Aggregate_Order_By = {
  avg?: Maybe<Booking_Series_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Booking_Series_Max_Order_By>;
  min?: Maybe<Booking_Series_Min_Order_By>;
  stddev?: Maybe<Booking_Series_Stddev_Order_By>;
  stddev_pop?: Maybe<Booking_Series_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Booking_Series_Stddev_Samp_Order_By>;
  sum?: Maybe<Booking_Series_Sum_Order_By>;
  var_pop?: Maybe<Booking_Series_Var_Pop_Order_By>;
  var_samp?: Maybe<Booking_Series_Var_Samp_Order_By>;
  variance?: Maybe<Booking_Series_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "booking_series" */
export type Booking_Series_Arr_Rel_Insert_Input = {
  data: Array<Booking_Series_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Booking_Series_On_Conflict>;
};

/** aggregate avg on columns */
export type Booking_Series_Avg_Fields = {
  count?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking_series" */
export type Booking_Series_Avg_Order_By = {
  count?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "booking_series". All fields are combined with a logical 'AND'. */
export type Booking_Series_Bool_Exp = {
  _and?: Maybe<Array<Booking_Series_Bool_Exp>>;
  _not?: Maybe<Booking_Series_Bool_Exp>;
  _or?: Maybe<Array<Booking_Series_Bool_Exp>>;
  bookings?: Maybe<Bookings_Bool_Exp>;
  bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  by_day?: Maybe<String_Array_Comparison_Exp>;
  by_month_day?: Maybe<Int_Array_Comparison_Exp>;
  count?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  frequency?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  interval?: Maybe<Int_Comparison_Exp>;
  master_booking?: Maybe<Bookings_Bool_Exp>;
  master_booking_id?: Maybe<Uuid_Comparison_Exp>;
  next_expansion?: Maybe<Date_Comparison_Exp>;
  rrule?: Maybe<String_Comparison_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  timezone?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "booking_series" */
export enum Booking_Series_Constraint {
  /** unique or primary key constraint on columns "id" */
  BookingSeriesPkey = 'booking_series_pkey'
}

/** input type for incrementing numeric columns in table "booking_series" */
export type Booking_Series_Inc_Input = {
  count?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking_series" */
export type Booking_Series_Insert_Input = {
  bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  by_day?: Maybe<Array<Scalars['String']>>;
  by_month_day?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  end_date?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interval?: Maybe<Scalars['Int']>;
  master_booking?: Maybe<Bookings_Obj_Rel_Insert_Input>;
  master_booking_id?: Maybe<Scalars['uuid']>;
  next_expansion?: Maybe<Scalars['date']>;
  rrule?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Booking_Series_Max_Fields = {
  by_day?: Maybe<Array<Scalars['String']>>;
  by_month_day?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interval?: Maybe<Scalars['Int']>;
  master_booking_id?: Maybe<Scalars['uuid']>;
  next_expansion?: Maybe<Scalars['date']>;
  rrule?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "booking_series" */
export type Booking_Series_Max_Order_By = {
  by_day?: Maybe<Order_By>;
  by_month_day?: Maybe<Order_By>;
  count?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
  master_booking_id?: Maybe<Order_By>;
  next_expansion?: Maybe<Order_By>;
  rrule?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Booking_Series_Min_Fields = {
  by_day?: Maybe<Array<Scalars['String']>>;
  by_month_day?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interval?: Maybe<Scalars['Int']>;
  master_booking_id?: Maybe<Scalars['uuid']>;
  next_expansion?: Maybe<Scalars['date']>;
  rrule?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "booking_series" */
export type Booking_Series_Min_Order_By = {
  by_day?: Maybe<Order_By>;
  by_month_day?: Maybe<Order_By>;
  count?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
  master_booking_id?: Maybe<Order_By>;
  next_expansion?: Maybe<Order_By>;
  rrule?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** response of any mutation on the table "booking_series" */
export type Booking_Series_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Booking_Series>;
};

/** input type for inserting object relation for remote table "booking_series" */
export type Booking_Series_Obj_Rel_Insert_Input = {
  data: Booking_Series_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Booking_Series_On_Conflict>;
};

/** on_conflict condition type for table "booking_series" */
export type Booking_Series_On_Conflict = {
  constraint: Booking_Series_Constraint;
  update_columns?: Array<Booking_Series_Update_Column>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};

/** Ordering options when selecting data from "booking_series". */
export type Booking_Series_Order_By = {
  bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  by_day?: Maybe<Order_By>;
  by_month_day?: Maybe<Order_By>;
  count?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  end_date?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
  master_booking?: Maybe<Bookings_Order_By>;
  master_booking_id?: Maybe<Order_By>;
  next_expansion?: Maybe<Order_By>;
  rrule?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: booking_series */
export type Booking_Series_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "booking_series" */
export enum Booking_Series_Select_Column {
  /** column name */
  ByDay = 'by_day',
  /** column name */
  ByMonthDay = 'by_month_day',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  MasterBookingId = 'master_booking_id',
  /** column name */
  NextExpansion = 'next_expansion',
  /** column name */
  Rrule = 'rrule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "booking_series" */
export type Booking_Series_Set_Input = {
  by_day?: Maybe<Array<Scalars['String']>>;
  by_month_day?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interval?: Maybe<Scalars['Int']>;
  master_booking_id?: Maybe<Scalars['uuid']>;
  next_expansion?: Maybe<Scalars['date']>;
  rrule?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Booking_Series_Stddev_Fields = {
  count?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking_series" */
export type Booking_Series_Stddev_Order_By = {
  count?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Booking_Series_Stddev_Pop_Fields = {
  count?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking_series" */
export type Booking_Series_Stddev_Pop_Order_By = {
  count?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Booking_Series_Stddev_Samp_Fields = {
  count?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking_series" */
export type Booking_Series_Stddev_Samp_Order_By = {
  count?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
};

/** Streaming cursor of the table "booking_series" */
export type Booking_Series_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Booking_Series_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Booking_Series_Stream_Cursor_Value_Input = {
  by_day?: Maybe<Array<Scalars['String']>>;
  by_month_day?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interval?: Maybe<Scalars['Int']>;
  master_booking_id?: Maybe<Scalars['uuid']>;
  next_expansion?: Maybe<Scalars['date']>;
  rrule?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Booking_Series_Sum_Fields = {
  count?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "booking_series" */
export type Booking_Series_Sum_Order_By = {
  count?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
};

/** update columns of table "booking_series" */
export enum Booking_Series_Update_Column {
  /** column name */
  ByDay = 'by_day',
  /** column name */
  ByMonthDay = 'by_month_day',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  MasterBookingId = 'master_booking_id',
  /** column name */
  NextExpansion = 'next_expansion',
  /** column name */
  Rrule = 'rrule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Booking_Series_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Booking_Series_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Booking_Series_Set_Input>;
  /** filter the rows which have to be updated */
  where: Booking_Series_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Booking_Series_Var_Pop_Fields = {
  count?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking_series" */
export type Booking_Series_Var_Pop_Order_By = {
  count?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Booking_Series_Var_Samp_Fields = {
  count?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking_series" */
export type Booking_Series_Var_Samp_Order_By = {
  count?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Booking_Series_Variance_Fields = {
  count?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking_series" */
export type Booking_Series_Variance_Order_By = {
  count?: Maybe<Order_By>;
  interval?: Maybe<Order_By>;
};

/** columns and relationships of "booking_status" */
export type Booking_Status = {
  /** An array relationship */
  bookings: Array<Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Bookings_Aggregate;
  display: Scalars['String'];
  /** An array relationship */
  target_status_guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  target_status_guidelines_aggregate: Guidelines_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "booking_status" */
export type Booking_StatusBookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "booking_status" */
export type Booking_StatusBookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "booking_status" */
export type Booking_StatusTarget_Status_GuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "booking_status" */
export type Booking_StatusTarget_Status_Guidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};

/** aggregated selection of "booking_status" */
export type Booking_Status_Aggregate = {
  aggregate?: Maybe<Booking_Status_Aggregate_Fields>;
  nodes: Array<Booking_Status>;
};

/** aggregate fields of "booking_status" */
export type Booking_Status_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Booking_Status_Max_Fields>;
  min?: Maybe<Booking_Status_Min_Fields>;
};


/** aggregate fields of "booking_status" */
export type Booking_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Booking_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_status". All fields are combined with a logical 'AND'. */
export type Booking_Status_Bool_Exp = {
  _and?: Maybe<Array<Booking_Status_Bool_Exp>>;
  _not?: Maybe<Booking_Status_Bool_Exp>;
  _or?: Maybe<Array<Booking_Status_Bool_Exp>>;
  bookings?: Maybe<Bookings_Bool_Exp>;
  bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  display?: Maybe<String_Comparison_Exp>;
  target_status_guidelines?: Maybe<Guidelines_Bool_Exp>;
  target_status_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "booking_status" */
export enum Booking_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  BookingStatusPkey = 'booking_status_pkey'
}

export enum Booking_Status_Enum {
  /** Accepted */
  Accepted = 'accepted',
  /** Active */
  Active = 'active',
  /** Advanced */
  Advanced = 'advanced',
  /** Booker Advancing */
  BookerAdvancing = 'booker_advancing',
  /** Cancellation */
  Cancellation = 'cancellation',
  /** Cancellation Approved */
  CancellationApproved = 'cancellation_approved',
  /** Cancellation Denied */
  CancellationDenied = 'cancellation_denied',
  /** Cancelled */
  Cancelled = 'cancelled',
  /** Completed */
  Completed = 'completed',
  /** Confirmed */
  Confirmed = 'confirmed',
  /** Declined */
  Declined = 'declined',
  /** Deleted */
  Deleted = 'deleted',
  /** Draft */
  Draft = 'draft',
  /** Invoiced */
  Invoiced = 'invoiced',
  /** Noshow */
  Noshow = 'noshow',
  /** Offered */
  Offered = 'offered',
  /** Paid */
  Paid = 'paid',
  /** Paid Out */
  PaidOut = 'paid_out',
  /** Talent Advancing */
  TalentAdvancing = 'talent_advancing',
  /** Talent Cancelled */
  TalentCancelled = 'talent_cancelled',
  /** Venue Cancelled */
  VenueCancelled = 'venue_cancelled'
}

/** Boolean expression to compare columns of type "booking_status_enum". All fields are combined with logical 'AND'. */
export type Booking_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Booking_Status_Enum>;
  _in?: Maybe<Array<Booking_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Booking_Status_Enum>;
  _nin?: Maybe<Array<Booking_Status_Enum>>;
};

/** input type for inserting data into table "booking_status" */
export type Booking_Status_Insert_Input = {
  bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  display?: Maybe<Scalars['String']>;
  target_status_guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Booking_Status_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Booking_Status_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_status" */
export type Booking_Status_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Booking_Status>;
};

/** input type for inserting object relation for remote table "booking_status" */
export type Booking_Status_Obj_Rel_Insert_Input = {
  data: Booking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Booking_Status_On_Conflict>;
};

/** on_conflict condition type for table "booking_status" */
export type Booking_Status_On_Conflict = {
  constraint: Booking_Status_Constraint;
  update_columns?: Array<Booking_Status_Update_Column>;
  where?: Maybe<Booking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "booking_status". */
export type Booking_Status_Order_By = {
  bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  display?: Maybe<Order_By>;
  target_status_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: booking_status */
export type Booking_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "booking_status" */
export enum Booking_Status_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_status" */
export type Booking_Status_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_status" */
export type Booking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Booking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Booking_Status_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "booking_status" */
export enum Booking_Status_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Booking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Booking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Booking_Status_Bool_Exp;
};

/** columns and relationships of "booking_type" */
export type Booking_Type = {
  /** An array relationship */
  bookings: Array<Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Bookings_Aggregate;
  display: Scalars['String'];
  /** An array relationship */
  target_type_guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  target_type_guidelines_aggregate: Guidelines_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "booking_type" */
export type Booking_TypeBookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "booking_type" */
export type Booking_TypeBookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "booking_type" */
export type Booking_TypeTarget_Type_GuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "booking_type" */
export type Booking_TypeTarget_Type_Guidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};

/** aggregated selection of "booking_type" */
export type Booking_Type_Aggregate = {
  aggregate?: Maybe<Booking_Type_Aggregate_Fields>;
  nodes: Array<Booking_Type>;
};

/** aggregate fields of "booking_type" */
export type Booking_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Booking_Type_Max_Fields>;
  min?: Maybe<Booking_Type_Min_Fields>;
};


/** aggregate fields of "booking_type" */
export type Booking_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Booking_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_type". All fields are combined with a logical 'AND'. */
export type Booking_Type_Bool_Exp = {
  _and?: Maybe<Array<Booking_Type_Bool_Exp>>;
  _not?: Maybe<Booking_Type_Bool_Exp>;
  _or?: Maybe<Array<Booking_Type_Bool_Exp>>;
  bookings?: Maybe<Bookings_Bool_Exp>;
  bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  display?: Maybe<String_Comparison_Exp>;
  target_type_guidelines?: Maybe<Guidelines_Bool_Exp>;
  target_type_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "booking_type" */
export enum Booking_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  BookingTypePkey = 'booking_type_pkey'
}

export enum Booking_Type_Enum {
  /** Corporate Event */
  CorporateEvent = 'corporate_event',
  /** House Party */
  HouseParty = 'house_party',
  /** Private Booking */
  PrivateBooking = 'private_booking',
  /** Venue Booking */
  VenueBooking = 'venue_booking',
  /** Wedding */
  Wedding = 'wedding'
}

/** Boolean expression to compare columns of type "booking_type_enum". All fields are combined with logical 'AND'. */
export type Booking_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Booking_Type_Enum>;
  _in?: Maybe<Array<Booking_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Booking_Type_Enum>;
  _nin?: Maybe<Array<Booking_Type_Enum>>;
};

/** input type for inserting data into table "booking_type" */
export type Booking_Type_Insert_Input = {
  bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  display?: Maybe<Scalars['String']>;
  target_type_guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Booking_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Booking_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_type" */
export type Booking_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Booking_Type>;
};

/** input type for inserting object relation for remote table "booking_type" */
export type Booking_Type_Obj_Rel_Insert_Input = {
  data: Booking_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Booking_Type_On_Conflict>;
};

/** on_conflict condition type for table "booking_type" */
export type Booking_Type_On_Conflict = {
  constraint: Booking_Type_Constraint;
  update_columns?: Array<Booking_Type_Update_Column>;
  where?: Maybe<Booking_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "booking_type". */
export type Booking_Type_Order_By = {
  bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  display?: Maybe<Order_By>;
  target_type_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: booking_type */
export type Booking_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "booking_type" */
export enum Booking_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_type" */
export type Booking_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_type" */
export type Booking_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Booking_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Booking_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "booking_type" */
export enum Booking_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Booking_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Booking_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Booking_Type_Bool_Exp;
};

/** columns and relationships of "bookings" */
export type Bookings = {
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  booking_invoice_target?: Maybe<Invoice_Target>;
  /** An object relationship */
  booking_rate_type?: Maybe<Rate_Type>;
  /** An array relationship */
  booking_series: Array<Booking_Series>;
  /** An aggregate relationship */
  booking_series_aggregate: Booking_Series_Aggregate;
  /** An object relationship */
  booking_status: Booking_Status;
  /** An object relationship */
  booking_type?: Maybe<Booking_Type>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  date?: Maybe<Scalars['date']>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  event_end_time?: Maybe<Scalars['time']>;
  event_start_time?: Maybe<Scalars['time']>;
  /** An array relationship */
  guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_aggregate: Guidelines_Aggregate;
  id: Scalars['uuid'];
  invoice_target?: Maybe<Invoice_Target_Enum>;
  is_master: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_margin?: Maybe<Scalars['numeric']>;
  rate_type?: Maybe<Rate_Type_Enum>;
  recurring: Scalars['Boolean'];
  /** An object relationship */
  series?: Maybe<Booking_Series>;
  series_id?: Maybe<Scalars['uuid']>;
  set_end_time?: Maybe<Scalars['time']>;
  set_start_time?: Maybe<Scalars['time']>;
  status: Booking_Status_Enum;
  /** An object relationship */
  talent?: Maybe<Users>;
  talent_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  threads: Array<Threads>;
  /** An aggregate relationship */
  threads_aggregate: Threads_Aggregate;
  type?: Maybe<Booking_Type_Enum>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  venue?: Maybe<Tenants>;
  venue_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "bookings" */
export type BookingsBooking_SeriesArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


/** columns and relationships of "bookings" */
export type BookingsBooking_Series_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


/** columns and relationships of "bookings" */
export type BookingsDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "bookings" */
export type BookingsDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "bookings" */
export type BookingsGuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "bookings" */
export type BookingsGuidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "bookings" */
export type BookingsThreadsArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "bookings" */
export type BookingsThreads_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};

/** aggregated selection of "bookings" */
export type Bookings_Aggregate = {
  aggregate?: Maybe<Bookings_Aggregate_Fields>;
  nodes: Array<Bookings>;
};

export type Bookings_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Bookings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Bookings_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Bookings_Aggregate_Bool_Exp_Count>;
};

export type Bookings_Aggregate_Bool_Exp_Bool_And = {
  arguments: Bookings_Select_Column_Bookings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Bookings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Bookings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Bookings_Select_Column_Bookings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Bookings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Bookings_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Bookings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Bookings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "bookings" */
export type Bookings_Aggregate_Fields = {
  avg?: Maybe<Bookings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Bookings_Max_Fields>;
  min?: Maybe<Bookings_Min_Fields>;
  stddev?: Maybe<Bookings_Stddev_Fields>;
  stddev_pop?: Maybe<Bookings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bookings_Stddev_Samp_Fields>;
  sum?: Maybe<Bookings_Sum_Fields>;
  var_pop?: Maybe<Bookings_Var_Pop_Fields>;
  var_samp?: Maybe<Bookings_Var_Samp_Fields>;
  variance?: Maybe<Bookings_Variance_Fields>;
};


/** aggregate fields of "bookings" */
export type Bookings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bookings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bookings" */
export type Bookings_Aggregate_Order_By = {
  avg?: Maybe<Bookings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bookings_Max_Order_By>;
  min?: Maybe<Bookings_Min_Order_By>;
  stddev?: Maybe<Bookings_Stddev_Order_By>;
  stddev_pop?: Maybe<Bookings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bookings_Stddev_Samp_Order_By>;
  sum?: Maybe<Bookings_Sum_Order_By>;
  var_pop?: Maybe<Bookings_Var_Pop_Order_By>;
  var_samp?: Maybe<Bookings_Var_Samp_Order_By>;
  variance?: Maybe<Bookings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bookings" */
export type Bookings_Arr_Rel_Insert_Input = {
  data: Array<Bookings_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Bookings_On_Conflict>;
};

/** aggregate avg on columns */
export type Bookings_Avg_Fields = {
  rate?: Maybe<Scalars['Float']>;
  rate_margin?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bookings" */
export type Bookings_Avg_Order_By = {
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bookings". All fields are combined with a logical 'AND'. */
export type Bookings_Bool_Exp = {
  _and?: Maybe<Array<Bookings_Bool_Exp>>;
  _not?: Maybe<Bookings_Bool_Exp>;
  _or?: Maybe<Array<Bookings_Bool_Exp>>;
  area?: Maybe<Areas_Bool_Exp>;
  area_id?: Maybe<Uuid_Comparison_Exp>;
  booking_invoice_target?: Maybe<Invoice_Target_Bool_Exp>;
  booking_rate_type?: Maybe<Rate_Type_Bool_Exp>;
  booking_series?: Maybe<Booking_Series_Bool_Exp>;
  booking_series_aggregate?: Maybe<Booking_Series_Aggregate_Bool_Exp>;
  booking_status?: Maybe<Booking_Status_Bool_Exp>;
  booking_type?: Maybe<Booking_Type_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  date?: Maybe<Date_Comparison_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  event_end_time?: Maybe<Time_Comparison_Exp>;
  event_start_time?: Maybe<Time_Comparison_Exp>;
  guidelines?: Maybe<Guidelines_Bool_Exp>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoice_target?: Maybe<Invoice_Target_Enum_Comparison_Exp>;
  is_master?: Maybe<Boolean_Comparison_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
  poc?: Maybe<String_Comparison_Exp>;
  rate?: Maybe<Numeric_Comparison_Exp>;
  rate_margin?: Maybe<Numeric_Comparison_Exp>;
  rate_type?: Maybe<Rate_Type_Enum_Comparison_Exp>;
  recurring?: Maybe<Boolean_Comparison_Exp>;
  series?: Maybe<Booking_Series_Bool_Exp>;
  series_id?: Maybe<Uuid_Comparison_Exp>;
  set_end_time?: Maybe<Time_Comparison_Exp>;
  set_start_time?: Maybe<Time_Comparison_Exp>;
  status?: Maybe<Booking_Status_Enum_Comparison_Exp>;
  talent?: Maybe<Users_Bool_Exp>;
  talent_id?: Maybe<Uuid_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  threads?: Maybe<Threads_Bool_Exp>;
  threads_aggregate?: Maybe<Threads_Aggregate_Bool_Exp>;
  type?: Maybe<Booking_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
  venue?: Maybe<Tenants_Bool_Exp>;
  venue_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "bookings" */
export enum Bookings_Constraint {
  /** unique or primary key constraint on columns "series_id" */
  BookingsOneMasterPerSeriesIndex = 'bookings_one_master_per_series_index',
  /** unique or primary key constraint on columns "id" */
  BookingsPkey = 'bookings_pkey'
}

/** input type for incrementing numeric columns in table "bookings" */
export type Bookings_Inc_Input = {
  rate?: Maybe<Scalars['numeric']>;
  rate_margin?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "bookings" */
export type Bookings_Insert_Input = {
  area?: Maybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: Maybe<Scalars['uuid']>;
  booking_invoice_target?: Maybe<Invoice_Target_Obj_Rel_Insert_Input>;
  booking_rate_type?: Maybe<Rate_Type_Obj_Rel_Insert_Input>;
  booking_series?: Maybe<Booking_Series_Arr_Rel_Insert_Input>;
  booking_status?: Maybe<Booking_Status_Obj_Rel_Insert_Input>;
  booking_type?: Maybe<Booking_Type_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  date?: Maybe<Scalars['date']>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  event_end_time?: Maybe<Scalars['time']>;
  event_start_time?: Maybe<Scalars['time']>;
  guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  invoice_target?: Maybe<Invoice_Target_Enum>;
  is_master?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_margin?: Maybe<Scalars['numeric']>;
  rate_type?: Maybe<Rate_Type_Enum>;
  recurring?: Maybe<Scalars['Boolean']>;
  series?: Maybe<Booking_Series_Obj_Rel_Insert_Input>;
  series_id?: Maybe<Scalars['uuid']>;
  set_end_time?: Maybe<Scalars['time']>;
  set_start_time?: Maybe<Scalars['time']>;
  status?: Maybe<Booking_Status_Enum>;
  talent?: Maybe<Users_Obj_Rel_Insert_Input>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  threads?: Maybe<Threads_Arr_Rel_Insert_Input>;
  type?: Maybe<Booking_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  venue?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Bookings_Max_Fields = {
  area_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_margin?: Maybe<Scalars['numeric']>;
  series_id?: Maybe<Scalars['uuid']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "bookings" */
export type Bookings_Max_Order_By = {
  area_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
  series_id?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bookings_Min_Fields = {
  area_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_margin?: Maybe<Scalars['numeric']>;
  series_id?: Maybe<Scalars['uuid']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "bookings" */
export type Bookings_Min_Order_By = {
  area_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
  series_id?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "bookings" */
export type Bookings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bookings>;
};

/** input type for inserting object relation for remote table "bookings" */
export type Bookings_Obj_Rel_Insert_Input = {
  data: Bookings_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Bookings_On_Conflict>;
};

/** on_conflict condition type for table "bookings" */
export type Bookings_On_Conflict = {
  constraint: Bookings_Constraint;
  update_columns?: Array<Bookings_Update_Column>;
  where?: Maybe<Bookings_Bool_Exp>;
};

/** Ordering options when selecting data from "bookings". */
export type Bookings_Order_By = {
  area?: Maybe<Areas_Order_By>;
  area_id?: Maybe<Order_By>;
  booking_invoice_target?: Maybe<Invoice_Target_Order_By>;
  booking_rate_type?: Maybe<Rate_Type_Order_By>;
  booking_series_aggregate?: Maybe<Booking_Series_Aggregate_Order_By>;
  booking_status?: Maybe<Booking_Status_Order_By>;
  booking_type?: Maybe<Booking_Type_Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  date?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  event_end_time?: Maybe<Order_By>;
  event_start_time?: Maybe<Order_By>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  invoice_target?: Maybe<Order_By>;
  is_master?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
  rate_type?: Maybe<Order_By>;
  recurring?: Maybe<Order_By>;
  series?: Maybe<Booking_Series_Order_By>;
  series_id?: Maybe<Order_By>;
  set_end_time?: Maybe<Order_By>;
  set_start_time?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  talent?: Maybe<Users_Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  threads_aggregate?: Maybe<Threads_Aggregate_Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
  venue?: Maybe<Tenants_Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** primary key columns input for table: bookings */
export type Bookings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "bookings" */
export enum Bookings_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Date = 'date',
  /** column name */
  EventEndTime = 'event_end_time',
  /** column name */
  EventStartTime = 'event_start_time',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTarget = 'invoice_target',
  /** column name */
  IsMaster = 'is_master',
  /** column name */
  Notes = 'notes',
  /** column name */
  Poc = 'poc',
  /** column name */
  Rate = 'rate',
  /** column name */
  RateMargin = 'rate_margin',
  /** column name */
  RateType = 'rate_type',
  /** column name */
  Recurring = 'recurring',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SetEndTime = 'set_end_time',
  /** column name */
  SetStartTime = 'set_start_time',
  /** column name */
  Status = 'status',
  /** column name */
  TalentId = 'talent_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueId = 'venue_id'
}

/** select "bookings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "bookings" */
export enum Bookings_Select_Column_Bookings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMaster = 'is_master',
  /** column name */
  Recurring = 'recurring'
}

/** select "bookings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "bookings" */
export enum Bookings_Select_Column_Bookings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMaster = 'is_master',
  /** column name */
  Recurring = 'recurring'
}

/** input type for updating data in table "bookings" */
export type Bookings_Set_Input = {
  area_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['date']>;
  event_end_time?: Maybe<Scalars['time']>;
  event_start_time?: Maybe<Scalars['time']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_target?: Maybe<Invoice_Target_Enum>;
  is_master?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_margin?: Maybe<Scalars['numeric']>;
  rate_type?: Maybe<Rate_Type_Enum>;
  recurring?: Maybe<Scalars['Boolean']>;
  series_id?: Maybe<Scalars['uuid']>;
  set_end_time?: Maybe<Scalars['time']>;
  set_start_time?: Maybe<Scalars['time']>;
  status?: Maybe<Booking_Status_Enum>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Booking_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Bookings_Stddev_Fields = {
  rate?: Maybe<Scalars['Float']>;
  rate_margin?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bookings" */
export type Bookings_Stddev_Order_By = {
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bookings_Stddev_Pop_Fields = {
  rate?: Maybe<Scalars['Float']>;
  rate_margin?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bookings" */
export type Bookings_Stddev_Pop_Order_By = {
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bookings_Stddev_Samp_Fields = {
  rate?: Maybe<Scalars['Float']>;
  rate_margin?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bookings" */
export type Bookings_Stddev_Samp_Order_By = {
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
};

/** Streaming cursor of the table "bookings" */
export type Bookings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bookings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bookings_Stream_Cursor_Value_Input = {
  area_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['date']>;
  event_end_time?: Maybe<Scalars['time']>;
  event_start_time?: Maybe<Scalars['time']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_target?: Maybe<Invoice_Target_Enum>;
  is_master?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_margin?: Maybe<Scalars['numeric']>;
  rate_type?: Maybe<Rate_Type_Enum>;
  recurring?: Maybe<Scalars['Boolean']>;
  series_id?: Maybe<Scalars['uuid']>;
  set_end_time?: Maybe<Scalars['time']>;
  set_start_time?: Maybe<Scalars['time']>;
  status?: Maybe<Booking_Status_Enum>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Booking_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Bookings_Sum_Fields = {
  rate?: Maybe<Scalars['numeric']>;
  rate_margin?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "bookings" */
export type Bookings_Sum_Order_By = {
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
};

/** update columns of table "bookings" */
export enum Bookings_Update_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Date = 'date',
  /** column name */
  EventEndTime = 'event_end_time',
  /** column name */
  EventStartTime = 'event_start_time',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTarget = 'invoice_target',
  /** column name */
  IsMaster = 'is_master',
  /** column name */
  Notes = 'notes',
  /** column name */
  Poc = 'poc',
  /** column name */
  Rate = 'rate',
  /** column name */
  RateMargin = 'rate_margin',
  /** column name */
  RateType = 'rate_type',
  /** column name */
  Recurring = 'recurring',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SetEndTime = 'set_end_time',
  /** column name */
  SetStartTime = 'set_start_time',
  /** column name */
  Status = 'status',
  /** column name */
  TalentId = 'talent_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueId = 'venue_id'
}

export type Bookings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Bookings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Bookings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bookings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bookings_Var_Pop_Fields = {
  rate?: Maybe<Scalars['Float']>;
  rate_margin?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bookings" */
export type Bookings_Var_Pop_Order_By = {
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bookings_Var_Samp_Fields = {
  rate?: Maybe<Scalars['Float']>;
  rate_margin?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bookings" */
export type Bookings_Var_Samp_Order_By = {
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bookings_Variance_Fields = {
  rate?: Maybe<Scalars['Float']>;
  rate_margin?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bookings" */
export type Bookings_Variance_Order_By = {
  rate?: Maybe<Order_By>;
  rate_margin?: Maybe<Order_By>;
};

export type Create_Booking_With_Series_Args = {
  p_area_id?: Maybe<Scalars['uuid']>;
  p_booking_type?: Maybe<Scalars['String']>;
  p_by_day?: Maybe<Scalars['_text']>;
  p_by_month_day?: Maybe<Scalars['_int4']>;
  p_count?: Maybe<Scalars['Int']>;
  p_date?: Maybe<Scalars['date']>;
  p_end_date?: Maybe<Scalars['date']>;
  p_event_end_time?: Maybe<Scalars['time']>;
  p_event_start_time?: Maybe<Scalars['time']>;
  p_frequency?: Maybe<Scalars['String']>;
  p_interval?: Maybe<Scalars['Int']>;
  p_invoice_target?: Maybe<Scalars['String']>;
  p_notes?: Maybe<Scalars['String']>;
  p_poc?: Maybe<Scalars['String']>;
  p_rate?: Maybe<Scalars['numeric']>;
  p_rate_margin?: Maybe<Scalars['numeric']>;
  p_rate_type?: Maybe<Scalars['String']>;
  p_recurring?: Maybe<Scalars['Boolean']>;
  p_rrule?: Maybe<Scalars['String']>;
  p_set_end_time?: Maybe<Scalars['time']>;
  p_set_start_time?: Maybe<Scalars['time']>;
  p_talent_id?: Maybe<Scalars['uuid']>;
  p_timezone?: Maybe<Scalars['String']>;
  p_venue_id?: Maybe<Scalars['uuid']>;
};

export type Create_Thread_With_Message_Args = {
  p_body?: Maybe<Scalars['String']>;
  p_booking_id?: Maybe<Scalars['uuid']>;
  p_departments?: Maybe<Scalars['_text']>;
  p_idempotency_key?: Maybe<Scalars['uuid']>;
  p_message_type?: Maybe<Scalars['String']>;
  p_recipient_ids?: Maybe<Scalars['_uuid']>;
  p_subject?: Maybe<Scalars['String']>;
  p_thread_type?: Maybe<Scalars['String']>;
  p_venue_id?: Maybe<Scalars['uuid']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};

/** columns and relationships of "document_role" */
export type Document_Role = {
  display: Scalars['String'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "document_role" */
export type Document_RoleDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "document_role" */
export type Document_RoleDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};

/** aggregated selection of "document_role" */
export type Document_Role_Aggregate = {
  aggregate?: Maybe<Document_Role_Aggregate_Fields>;
  nodes: Array<Document_Role>;
};

/** aggregate fields of "document_role" */
export type Document_Role_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Document_Role_Max_Fields>;
  min?: Maybe<Document_Role_Min_Fields>;
};


/** aggregate fields of "document_role" */
export type Document_Role_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "document_role". All fields are combined with a logical 'AND'. */
export type Document_Role_Bool_Exp = {
  _and?: Maybe<Array<Document_Role_Bool_Exp>>;
  _not?: Maybe<Document_Role_Bool_Exp>;
  _or?: Maybe<Array<Document_Role_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_role" */
export enum Document_Role_Constraint {
  /** unique or primary key constraint on columns "value" */
  DocumentRolePkey = 'document_role_pkey'
}

export enum Document_Role_Enum {
  /** Agency */
  Agency = 'agency',
  /** Area */
  Area = 'area',
  /** Booking */
  Booking = 'booking',
  /** Guideline */
  Guideline = 'guideline',
  /** Talent */
  Talent = 'talent',
  /** Venue */
  Venue = 'venue'
}

/** Boolean expression to compare columns of type "document_role_enum". All fields are combined with logical 'AND'. */
export type Document_Role_Enum_Comparison_Exp = {
  _eq?: Maybe<Document_Role_Enum>;
  _in?: Maybe<Array<Document_Role_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Document_Role_Enum>;
  _nin?: Maybe<Array<Document_Role_Enum>>;
};

/** input type for inserting data into table "document_role" */
export type Document_Role_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Role_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Role_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_role" */
export type Document_Role_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Role>;
};

/** input type for inserting object relation for remote table "document_role" */
export type Document_Role_Obj_Rel_Insert_Input = {
  data: Document_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Document_Role_On_Conflict>;
};

/** on_conflict condition type for table "document_role" */
export type Document_Role_On_Conflict = {
  constraint: Document_Role_Constraint;
  update_columns?: Array<Document_Role_Update_Column>;
  where?: Maybe<Document_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "document_role". */
export type Document_Role_Order_By = {
  display?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: document_role */
export type Document_Role_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "document_role" */
export enum Document_Role_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "document_role" */
export type Document_Role_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "document_role" */
export type Document_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Role_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "document_role" */
export enum Document_Role_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Document_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Role_Bool_Exp;
};

/** columns and relationships of "document_status" */
export type Document_Status = {
  display: Scalars['String'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "document_status" */
export type Document_StatusDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "document_status" */
export type Document_StatusDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};

/** aggregated selection of "document_status" */
export type Document_Status_Aggregate = {
  aggregate?: Maybe<Document_Status_Aggregate_Fields>;
  nodes: Array<Document_Status>;
};

/** aggregate fields of "document_status" */
export type Document_Status_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Document_Status_Max_Fields>;
  min?: Maybe<Document_Status_Min_Fields>;
};


/** aggregate fields of "document_status" */
export type Document_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "document_status". All fields are combined with a logical 'AND'. */
export type Document_Status_Bool_Exp = {
  _and?: Maybe<Array<Document_Status_Bool_Exp>>;
  _not?: Maybe<Document_Status_Bool_Exp>;
  _or?: Maybe<Array<Document_Status_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_status" */
export enum Document_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  DocumentStatusPkey = 'document_status_pkey'
}

export enum Document_Status_Enum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "document_status_enum". All fields are combined with logical 'AND'. */
export type Document_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Document_Status_Enum>;
  _in?: Maybe<Array<Document_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Document_Status_Enum>;
  _nin?: Maybe<Array<Document_Status_Enum>>;
};

/** input type for inserting data into table "document_status" */
export type Document_Status_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Status_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Status_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_status" */
export type Document_Status_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Status>;
};

/** input type for inserting object relation for remote table "document_status" */
export type Document_Status_Obj_Rel_Insert_Input = {
  data: Document_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Document_Status_On_Conflict>;
};

/** on_conflict condition type for table "document_status" */
export type Document_Status_On_Conflict = {
  constraint: Document_Status_Constraint;
  update_columns?: Array<Document_Status_Update_Column>;
  where?: Maybe<Document_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "document_status". */
export type Document_Status_Order_By = {
  display?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: document_status */
export type Document_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "document_status" */
export enum Document_Status_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "document_status" */
export type Document_Status_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "document_status" */
export type Document_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Status_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "document_status" */
export enum Document_Status_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Document_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Status_Bool_Exp;
};

/** columns and relationships of "document_type" */
export type Document_Type = {
  display: Scalars['String'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "document_type" */
export type Document_TypeDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "document_type" */
export type Document_TypeDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};

/** aggregated selection of "document_type" */
export type Document_Type_Aggregate = {
  aggregate?: Maybe<Document_Type_Aggregate_Fields>;
  nodes: Array<Document_Type>;
};

/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Document_Type_Max_Fields>;
  min?: Maybe<Document_Type_Min_Fields>;
};


/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "document_type". All fields are combined with a logical 'AND'. */
export type Document_Type_Bool_Exp = {
  _and?: Maybe<Array<Document_Type_Bool_Exp>>;
  _not?: Maybe<Document_Type_Bool_Exp>;
  _or?: Maybe<Array<Document_Type_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_type" */
export enum Document_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  DocumentTypePkey = 'document_type_pkey'
}

export enum Document_Type_Enum {
  /** Bio */
  Bio = 'bio',
  /** Document */
  Document = 'document',
  /** EPK */
  Epk = 'epk',
  /** Equipment Ryder */
  EquipmentRyder = 'equipment_ryder',
  /** Hospitality Ryder */
  HospitalityRyder = 'hospitality_ryder',
  /** Invoice */
  Invoice = 'invoice',
  /** Logo */
  Logo = 'logo',
  /** Media */
  Media = 'media',
  /** Press Pictures */
  PressPic = 'press_pic',
  /** W9 */
  W9 = 'w9'
}

/** Boolean expression to compare columns of type "document_type_enum". All fields are combined with logical 'AND'. */
export type Document_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Document_Type_Enum>;
  _in?: Maybe<Array<Document_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Document_Type_Enum>;
  _nin?: Maybe<Array<Document_Type_Enum>>;
};

/** input type for inserting data into table "document_type" */
export type Document_Type_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_type" */
export type Document_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Type>;
};

/** input type for inserting object relation for remote table "document_type" */
export type Document_Type_Obj_Rel_Insert_Input = {
  data: Document_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Document_Type_On_Conflict>;
};

/** on_conflict condition type for table "document_type" */
export type Document_Type_On_Conflict = {
  constraint: Document_Type_Constraint;
  update_columns?: Array<Document_Type_Update_Column>;
  where?: Maybe<Document_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "document_type". */
export type Document_Type_Order_By = {
  display?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: document_type */
export type Document_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "document_type" */
export enum Document_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "document_type" */
export type Document_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "document_type" */
export type Document_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "document_type" */
export enum Document_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Document_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Type_Bool_Exp;
};

/** columns and relationships of "documents" */
export type Documents = {
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  booking?: Maybe<Bookings>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  document_role: Document_Role;
  /** An object relationship */
  document_status: Document_Status;
  /** An object relationship */
  document_type: Document_Type;
  filename?: Maybe<Scalars['String']>;
  filetype?: Maybe<Scalars['String']>;
  /** An array relationship */
  guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_aggregate: Guidelines_Aggregate;
  id: Scalars['uuid'];
  role: Document_Role_Enum;
  size?: Maybe<Scalars['String']>;
  status: Document_Status_Enum;
  /** An object relationship */
  talent?: Maybe<Users>;
  talent_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type: Document_Type_Enum;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  url?: Maybe<Scalars['String']>;
  /** An object relationship */
  venue?: Maybe<Tenants>;
  venue_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "documents" */
export type DocumentsGuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsGuidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};

/** aggregated selection of "documents" */
export type Documents_Aggregate = {
  aggregate?: Maybe<Documents_Aggregate_Fields>;
  nodes: Array<Documents>;
};

export type Documents_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Documents_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Documents_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Documents_Aggregate_Bool_Exp_Count>;
};

export type Documents_Aggregate_Bool_Exp_Bool_And = {
  arguments: Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Documents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Documents_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Documents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Documents_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Documents_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "documents" */
export type Documents_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Documents_Max_Fields>;
  min?: Maybe<Documents_Min_Fields>;
};


/** aggregate fields of "documents" */
export type Documents_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Documents_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "documents" */
export type Documents_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Documents_Max_Order_By>;
  min?: Maybe<Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "documents" */
export type Documents_Arr_Rel_Insert_Input = {
  data: Array<Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export type Documents_Bool_Exp = {
  _and?: Maybe<Array<Documents_Bool_Exp>>;
  _not?: Maybe<Documents_Bool_Exp>;
  _or?: Maybe<Array<Documents_Bool_Exp>>;
  area?: Maybe<Areas_Bool_Exp>;
  area_id?: Maybe<Uuid_Comparison_Exp>;
  booking?: Maybe<Bookings_Bool_Exp>;
  booking_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  document_role?: Maybe<Document_Role_Bool_Exp>;
  document_status?: Maybe<Document_Status_Bool_Exp>;
  document_type?: Maybe<Document_Type_Bool_Exp>;
  filename?: Maybe<String_Comparison_Exp>;
  filetype?: Maybe<String_Comparison_Exp>;
  guidelines?: Maybe<Guidelines_Bool_Exp>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  role?: Maybe<Document_Role_Enum_Comparison_Exp>;
  size?: Maybe<String_Comparison_Exp>;
  status?: Maybe<Document_Status_Enum_Comparison_Exp>;
  talent?: Maybe<Users_Bool_Exp>;
  talent_id?: Maybe<Uuid_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<Document_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
  url?: Maybe<String_Comparison_Exp>;
  venue?: Maybe<Tenants_Bool_Exp>;
  venue_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "documents" */
export enum Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentsPkey = 'documents_pkey'
}

/** input type for inserting data into table "documents" */
export type Documents_Insert_Input = {
  area?: Maybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: Maybe<Scalars['uuid']>;
  booking?: Maybe<Bookings_Obj_Rel_Insert_Input>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  deleted?: Maybe<Scalars['Boolean']>;
  document_role?: Maybe<Document_Role_Obj_Rel_Insert_Input>;
  document_status?: Maybe<Document_Status_Obj_Rel_Insert_Input>;
  document_type?: Maybe<Document_Type_Obj_Rel_Insert_Input>;
  filename?: Maybe<Scalars['String']>;
  filetype?: Maybe<Scalars['String']>;
  guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Document_Role_Enum>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Document_Status_Enum>;
  talent?: Maybe<Users_Obj_Rel_Insert_Input>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Document_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  url?: Maybe<Scalars['String']>;
  venue?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Documents_Max_Fields = {
  area_id?: Maybe<Scalars['uuid']>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  filetype?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  size?: Maybe<Scalars['String']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "documents" */
export type Documents_Max_Order_By = {
  area_id?: Maybe<Order_By>;
  booking_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  filename?: Maybe<Order_By>;
  filetype?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Documents_Min_Fields = {
  area_id?: Maybe<Scalars['uuid']>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  filetype?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  size?: Maybe<Scalars['String']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "documents" */
export type Documents_Min_Order_By = {
  area_id?: Maybe<Order_By>;
  booking_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  filename?: Maybe<Order_By>;
  filetype?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "documents" */
export type Documents_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Documents>;
};

/** input type for inserting object relation for remote table "documents" */
export type Documents_Obj_Rel_Insert_Input = {
  data: Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Documents_On_Conflict>;
};

/** on_conflict condition type for table "documents" */
export type Documents_On_Conflict = {
  constraint: Documents_Constraint;
  update_columns?: Array<Documents_Update_Column>;
  where?: Maybe<Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "documents". */
export type Documents_Order_By = {
  area?: Maybe<Areas_Order_By>;
  area_id?: Maybe<Order_By>;
  booking?: Maybe<Bookings_Order_By>;
  booking_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  deleted?: Maybe<Order_By>;
  document_role?: Maybe<Document_Role_Order_By>;
  document_status?: Maybe<Document_Status_Order_By>;
  document_type?: Maybe<Document_Type_Order_By>;
  filename?: Maybe<Order_By>;
  filetype?: Maybe<Order_By>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  talent?: Maybe<Users_Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
  url?: Maybe<Order_By>;
  venue?: Maybe<Tenants_Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** primary key columns input for table: documents */
export type Documents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "documents" */
export enum Documents_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Filename = 'filename',
  /** column name */
  Filetype = 'filetype',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  Size = 'size',
  /** column name */
  Status = 'status',
  /** column name */
  TalentId = 'talent_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Url = 'url',
  /** column name */
  VenueId = 'venue_id'
}

/** select "documents_aggregate_bool_exp_bool_and_arguments_columns" columns of table "documents" */
export enum Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "documents_aggregate_bool_exp_bool_or_arguments_columns" columns of table "documents" */
export enum Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "documents" */
export type Documents_Set_Input = {
  area_id?: Maybe<Scalars['uuid']>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  filename?: Maybe<Scalars['String']>;
  filetype?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Document_Role_Enum>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Document_Status_Enum>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Document_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "documents" */
export type Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Documents_Stream_Cursor_Value_Input = {
  area_id?: Maybe<Scalars['uuid']>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  filename?: Maybe<Scalars['String']>;
  filetype?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Document_Role_Enum>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Document_Status_Enum>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Document_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "documents" */
export enum Documents_Update_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Filename = 'filename',
  /** column name */
  Filetype = 'filetype',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  Size = 'size',
  /** column name */
  Status = 'status',
  /** column name */
  TalentId = 'talent_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Url = 'url',
  /** column name */
  VenueId = 'venue_id'
}

export type Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Documents_Bool_Exp;
};

/** columns and relationships of "guideline_role" */
export type Guideline_Role = {
  display: Scalars['String'];
  /** An array relationship */
  guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_aggregate: Guidelines_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "guideline_role" */
export type Guideline_RoleGuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "guideline_role" */
export type Guideline_RoleGuidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};

/** aggregated selection of "guideline_role" */
export type Guideline_Role_Aggregate = {
  aggregate?: Maybe<Guideline_Role_Aggregate_Fields>;
  nodes: Array<Guideline_Role>;
};

/** aggregate fields of "guideline_role" */
export type Guideline_Role_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Guideline_Role_Max_Fields>;
  min?: Maybe<Guideline_Role_Min_Fields>;
};


/** aggregate fields of "guideline_role" */
export type Guideline_Role_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Guideline_Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "guideline_role". All fields are combined with a logical 'AND'. */
export type Guideline_Role_Bool_Exp = {
  _and?: Maybe<Array<Guideline_Role_Bool_Exp>>;
  _not?: Maybe<Guideline_Role_Bool_Exp>;
  _or?: Maybe<Array<Guideline_Role_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  guidelines?: Maybe<Guidelines_Bool_Exp>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "guideline_role" */
export enum Guideline_Role_Constraint {
  /** unique or primary key constraint on columns "value" */
  GuidelineRolePkey = 'guideline_role_pkey'
}

export enum Guideline_Role_Enum {
  /** Agency Task */
  AgencyTask = 'agency_task',
  /** Area Question */
  AreaQuestion = 'area_question',
  /** Area Task */
  AreaTask = 'area_task',
  /** Info */
  Info = 'info',
  /** Talent Question */
  TalentQuestion = 'talent_question',
  /** Talent Task */
  TalentTask = 'talent_task',
  /** Venue Question */
  VenueQuestion = 'venue_question',
  /** Venue Task */
  VenueTask = 'venue_task'
}

/** Boolean expression to compare columns of type "guideline_role_enum". All fields are combined with logical 'AND'. */
export type Guideline_Role_Enum_Comparison_Exp = {
  _eq?: Maybe<Guideline_Role_Enum>;
  _in?: Maybe<Array<Guideline_Role_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Guideline_Role_Enum>;
  _nin?: Maybe<Array<Guideline_Role_Enum>>;
};

/** input type for inserting data into table "guideline_role" */
export type Guideline_Role_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Guideline_Role_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Guideline_Role_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "guideline_role" */
export type Guideline_Role_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guideline_Role>;
};

/** input type for inserting object relation for remote table "guideline_role" */
export type Guideline_Role_Obj_Rel_Insert_Input = {
  data: Guideline_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Guideline_Role_On_Conflict>;
};

/** on_conflict condition type for table "guideline_role" */
export type Guideline_Role_On_Conflict = {
  constraint: Guideline_Role_Constraint;
  update_columns?: Array<Guideline_Role_Update_Column>;
  where?: Maybe<Guideline_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "guideline_role". */
export type Guideline_Role_Order_By = {
  display?: Maybe<Order_By>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: guideline_role */
export type Guideline_Role_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "guideline_role" */
export enum Guideline_Role_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "guideline_role" */
export type Guideline_Role_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "guideline_role" */
export type Guideline_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guideline_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guideline_Role_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "guideline_role" */
export enum Guideline_Role_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Guideline_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Guideline_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Guideline_Role_Bool_Exp;
};

/** columns and relationships of "guideline_status" */
export type Guideline_Status = {
  display: Scalars['String'];
  /** An array relationship */
  guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_aggregate: Guidelines_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "guideline_status" */
export type Guideline_StatusGuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "guideline_status" */
export type Guideline_StatusGuidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};

/** aggregated selection of "guideline_status" */
export type Guideline_Status_Aggregate = {
  aggregate?: Maybe<Guideline_Status_Aggregate_Fields>;
  nodes: Array<Guideline_Status>;
};

/** aggregate fields of "guideline_status" */
export type Guideline_Status_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Guideline_Status_Max_Fields>;
  min?: Maybe<Guideline_Status_Min_Fields>;
};


/** aggregate fields of "guideline_status" */
export type Guideline_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Guideline_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "guideline_status". All fields are combined with a logical 'AND'. */
export type Guideline_Status_Bool_Exp = {
  _and?: Maybe<Array<Guideline_Status_Bool_Exp>>;
  _not?: Maybe<Guideline_Status_Bool_Exp>;
  _or?: Maybe<Array<Guideline_Status_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  guidelines?: Maybe<Guidelines_Bool_Exp>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "guideline_status" */
export enum Guideline_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  GuidelineStatusPkey = 'guideline_status_pkey'
}

export enum Guideline_Status_Enum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "guideline_status_enum". All fields are combined with logical 'AND'. */
export type Guideline_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Guideline_Status_Enum>;
  _in?: Maybe<Array<Guideline_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Guideline_Status_Enum>;
  _nin?: Maybe<Array<Guideline_Status_Enum>>;
};

/** input type for inserting data into table "guideline_status" */
export type Guideline_Status_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Guideline_Status_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Guideline_Status_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "guideline_status" */
export type Guideline_Status_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guideline_Status>;
};

/** input type for inserting object relation for remote table "guideline_status" */
export type Guideline_Status_Obj_Rel_Insert_Input = {
  data: Guideline_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Guideline_Status_On_Conflict>;
};

/** on_conflict condition type for table "guideline_status" */
export type Guideline_Status_On_Conflict = {
  constraint: Guideline_Status_Constraint;
  update_columns?: Array<Guideline_Status_Update_Column>;
  where?: Maybe<Guideline_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "guideline_status". */
export type Guideline_Status_Order_By = {
  display?: Maybe<Order_By>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: guideline_status */
export type Guideline_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "guideline_status" */
export enum Guideline_Status_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "guideline_status" */
export type Guideline_Status_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "guideline_status" */
export type Guideline_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guideline_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guideline_Status_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "guideline_status" */
export enum Guideline_Status_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Guideline_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Guideline_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Guideline_Status_Bool_Exp;
};

/** columns and relationships of "guideline_type" */
export type Guideline_Type = {
  display: Scalars['String'];
  /** An array relationship */
  guidelines: Array<Guidelines>;
  /** An array relationship */
  guidelinesByParentGuidelineType: Array<Guidelines>;
  /** An aggregate relationship */
  guidelinesByParentGuidelineType_aggregate: Guidelines_Aggregate;
  /** An aggregate relationship */
  guidelines_aggregate: Guidelines_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "guideline_type" */
export type Guideline_TypeGuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "guideline_type" */
export type Guideline_TypeGuidelinesByParentGuidelineTypeArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "guideline_type" */
export type Guideline_TypeGuidelinesByParentGuidelineType_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "guideline_type" */
export type Guideline_TypeGuidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};

/** aggregated selection of "guideline_type" */
export type Guideline_Type_Aggregate = {
  aggregate?: Maybe<Guideline_Type_Aggregate_Fields>;
  nodes: Array<Guideline_Type>;
};

/** aggregate fields of "guideline_type" */
export type Guideline_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Guideline_Type_Max_Fields>;
  min?: Maybe<Guideline_Type_Min_Fields>;
};


/** aggregate fields of "guideline_type" */
export type Guideline_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Guideline_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "guideline_type". All fields are combined with a logical 'AND'. */
export type Guideline_Type_Bool_Exp = {
  _and?: Maybe<Array<Guideline_Type_Bool_Exp>>;
  _not?: Maybe<Guideline_Type_Bool_Exp>;
  _or?: Maybe<Array<Guideline_Type_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  guidelines?: Maybe<Guidelines_Bool_Exp>;
  guidelinesByParentGuidelineType?: Maybe<Guidelines_Bool_Exp>;
  guidelinesByParentGuidelineType_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "guideline_type" */
export enum Guideline_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  GuidelineTypePkey = 'guideline_type_pkey'
}

export enum Guideline_Type_Enum {
  /** Agency */
  Agency = 'agency',
  /** Area */
  Area = 'area',
  /** Booking */
  Booking = 'booking',
  /** Talent */
  Talent = 'talent',
  /** Venue */
  Venue = 'venue'
}

/** Boolean expression to compare columns of type "guideline_type_enum". All fields are combined with logical 'AND'. */
export type Guideline_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Guideline_Type_Enum>;
  _in?: Maybe<Array<Guideline_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Guideline_Type_Enum>;
  _nin?: Maybe<Array<Guideline_Type_Enum>>;
};

/** input type for inserting data into table "guideline_type" */
export type Guideline_Type_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  guidelinesByParentGuidelineType?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Guideline_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Guideline_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "guideline_type" */
export type Guideline_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guideline_Type>;
};

/** input type for inserting object relation for remote table "guideline_type" */
export type Guideline_Type_Obj_Rel_Insert_Input = {
  data: Guideline_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Guideline_Type_On_Conflict>;
};

/** on_conflict condition type for table "guideline_type" */
export type Guideline_Type_On_Conflict = {
  constraint: Guideline_Type_Constraint;
  update_columns?: Array<Guideline_Type_Update_Column>;
  where?: Maybe<Guideline_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "guideline_type". */
export type Guideline_Type_Order_By = {
  display?: Maybe<Order_By>;
  guidelinesByParentGuidelineType_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: guideline_type */
export type Guideline_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "guideline_type" */
export enum Guideline_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "guideline_type" */
export type Guideline_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "guideline_type" */
export type Guideline_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guideline_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guideline_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "guideline_type" */
export enum Guideline_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Guideline_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Guideline_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Guideline_Type_Bool_Exp;
};

/** columns and relationships of "guidelines" */
export type Guidelines = {
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  booking?: Maybe<Bookings>;
  booking_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  child_guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  child_guidelines_aggregate: Guidelines_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  document?: Maybe<Documents>;
  document_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  guideline_role?: Maybe<Guideline_Role>;
  /** An object relationship */
  guideline_status: Guideline_Status;
  /** An object relationship */
  guideline_type: Guideline_Type;
  id: Scalars['uuid'];
  information?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  parent_guideline?: Maybe<Guidelines>;
  parent_guideline_id?: Maybe<Scalars['uuid']>;
  parent_guideline_type?: Maybe<Guideline_Type_Enum>;
  /** An object relationship */
  parent_guideline_type_enum?: Maybe<Guideline_Type>;
  role?: Maybe<Guideline_Role_Enum>;
  status: Guideline_Status_Enum;
  /** An object relationship */
  talent?: Maybe<Users>;
  talent_completed: Scalars['Boolean'];
  talent_confirmed: Scalars['Boolean'];
  talent_id?: Maybe<Scalars['uuid']>;
  talent_required: Scalars['Boolean'];
  target_booking_status?: Maybe<Booking_Status_Enum>;
  /** An object relationship */
  target_booking_status_enum?: Maybe<Booking_Status>;
  target_booking_type?: Maybe<Booking_Type_Enum>;
  /** An object relationship */
  target_booking_type_enum?: Maybe<Booking_Type>;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_completed: Scalars['Boolean'];
  tenant_confirmed: Scalars['Boolean'];
  tenant_id?: Maybe<Scalars['uuid']>;
  tenant_required: Scalars['Boolean'];
  type: Guideline_Type_Enum;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  venue?: Maybe<Tenants>;
  venue_completed: Scalars['Boolean'];
  venue_confirmed: Scalars['Boolean'];
  venue_id?: Maybe<Scalars['uuid']>;
  venue_required: Scalars['Boolean'];
};


/** columns and relationships of "guidelines" */
export type GuidelinesChild_GuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "guidelines" */
export type GuidelinesChild_Guidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "guidelines" */
export type GuidelinesMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "guidelines" */
export type Guidelines_Aggregate = {
  aggregate?: Maybe<Guidelines_Aggregate_Fields>;
  nodes: Array<Guidelines>;
};

export type Guidelines_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Guidelines_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Guidelines_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Guidelines_Aggregate_Bool_Exp_Count>;
};

export type Guidelines_Aggregate_Bool_Exp_Bool_And = {
  arguments: Guidelines_Select_Column_Guidelines_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Guidelines_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Guidelines_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Guidelines_Select_Column_Guidelines_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Guidelines_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Guidelines_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Guidelines_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Guidelines_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "guidelines" */
export type Guidelines_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Guidelines_Max_Fields>;
  min?: Maybe<Guidelines_Min_Fields>;
};


/** aggregate fields of "guidelines" */
export type Guidelines_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Guidelines_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guidelines" */
export type Guidelines_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Guidelines_Max_Order_By>;
  min?: Maybe<Guidelines_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Guidelines_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "guidelines" */
export type Guidelines_Arr_Rel_Insert_Input = {
  data: Array<Guidelines_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Guidelines_On_Conflict>;
};

/** Boolean expression to filter rows from the table "guidelines". All fields are combined with a logical 'AND'. */
export type Guidelines_Bool_Exp = {
  _and?: Maybe<Array<Guidelines_Bool_Exp>>;
  _not?: Maybe<Guidelines_Bool_Exp>;
  _or?: Maybe<Array<Guidelines_Bool_Exp>>;
  area?: Maybe<Areas_Bool_Exp>;
  area_id?: Maybe<Uuid_Comparison_Exp>;
  booking?: Maybe<Bookings_Bool_Exp>;
  booking_id?: Maybe<Uuid_Comparison_Exp>;
  child_guidelines?: Maybe<Guidelines_Bool_Exp>;
  child_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  document?: Maybe<Documents_Bool_Exp>;
  document_id?: Maybe<Uuid_Comparison_Exp>;
  guideline_role?: Maybe<Guideline_Role_Bool_Exp>;
  guideline_status?: Maybe<Guideline_Status_Bool_Exp>;
  guideline_type?: Maybe<Guideline_Type_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  information?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  parent_guideline?: Maybe<Guidelines_Bool_Exp>;
  parent_guideline_id?: Maybe<Uuid_Comparison_Exp>;
  parent_guideline_type?: Maybe<Guideline_Type_Enum_Comparison_Exp>;
  parent_guideline_type_enum?: Maybe<Guideline_Type_Bool_Exp>;
  role?: Maybe<Guideline_Role_Enum_Comparison_Exp>;
  status?: Maybe<Guideline_Status_Enum_Comparison_Exp>;
  talent?: Maybe<Users_Bool_Exp>;
  talent_completed?: Maybe<Boolean_Comparison_Exp>;
  talent_confirmed?: Maybe<Boolean_Comparison_Exp>;
  talent_id?: Maybe<Uuid_Comparison_Exp>;
  talent_required?: Maybe<Boolean_Comparison_Exp>;
  target_booking_status?: Maybe<Booking_Status_Enum_Comparison_Exp>;
  target_booking_status_enum?: Maybe<Booking_Status_Bool_Exp>;
  target_booking_type?: Maybe<Booking_Type_Enum_Comparison_Exp>;
  target_booking_type_enum?: Maybe<Booking_Type_Bool_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_completed?: Maybe<Boolean_Comparison_Exp>;
  tenant_confirmed?: Maybe<Boolean_Comparison_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  tenant_required?: Maybe<Boolean_Comparison_Exp>;
  type?: Maybe<Guideline_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
  venue?: Maybe<Tenants_Bool_Exp>;
  venue_completed?: Maybe<Boolean_Comparison_Exp>;
  venue_confirmed?: Maybe<Boolean_Comparison_Exp>;
  venue_id?: Maybe<Uuid_Comparison_Exp>;
  venue_required?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "guidelines" */
export enum Guidelines_Constraint {
  /** unique or primary key constraint on columns "id" */
  GuidelinesPkey = 'guidelines_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Guidelines_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Guidelines_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Guidelines_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "guidelines" */
export type Guidelines_Insert_Input = {
  area?: Maybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: Maybe<Scalars['uuid']>;
  booking?: Maybe<Bookings_Obj_Rel_Insert_Input>;
  booking_id?: Maybe<Scalars['uuid']>;
  child_guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<Documents_Obj_Rel_Insert_Input>;
  document_id?: Maybe<Scalars['uuid']>;
  guideline_role?: Maybe<Guideline_Role_Obj_Rel_Insert_Input>;
  guideline_status?: Maybe<Guideline_Status_Obj_Rel_Insert_Input>;
  guideline_type?: Maybe<Guideline_Type_Obj_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  information?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  parent_guideline?: Maybe<Guidelines_Obj_Rel_Insert_Input>;
  parent_guideline_id?: Maybe<Scalars['uuid']>;
  parent_guideline_type?: Maybe<Guideline_Type_Enum>;
  parent_guideline_type_enum?: Maybe<Guideline_Type_Obj_Rel_Insert_Input>;
  role?: Maybe<Guideline_Role_Enum>;
  status?: Maybe<Guideline_Status_Enum>;
  talent?: Maybe<Users_Obj_Rel_Insert_Input>;
  talent_completed?: Maybe<Scalars['Boolean']>;
  talent_confirmed?: Maybe<Scalars['Boolean']>;
  talent_id?: Maybe<Scalars['uuid']>;
  talent_required?: Maybe<Scalars['Boolean']>;
  target_booking_status?: Maybe<Booking_Status_Enum>;
  target_booking_status_enum?: Maybe<Booking_Status_Obj_Rel_Insert_Input>;
  target_booking_type?: Maybe<Booking_Type_Enum>;
  target_booking_type_enum?: Maybe<Booking_Type_Obj_Rel_Insert_Input>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_completed?: Maybe<Scalars['Boolean']>;
  tenant_confirmed?: Maybe<Scalars['Boolean']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  tenant_required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Guideline_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  venue?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  venue_completed?: Maybe<Scalars['Boolean']>;
  venue_confirmed?: Maybe<Scalars['Boolean']>;
  venue_id?: Maybe<Scalars['uuid']>;
  venue_required?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Guidelines_Max_Fields = {
  area_id?: Maybe<Scalars['uuid']>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  information?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_guideline_id?: Maybe<Scalars['uuid']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "guidelines" */
export type Guidelines_Max_Order_By = {
  area_id?: Maybe<Order_By>;
  booking_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  information?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_guideline_id?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Guidelines_Min_Fields = {
  area_id?: Maybe<Scalars['uuid']>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  information?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_guideline_id?: Maybe<Scalars['uuid']>;
  talent_id?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "guidelines" */
export type Guidelines_Min_Order_By = {
  area_id?: Maybe<Order_By>;
  booking_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  information?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_guideline_id?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "guidelines" */
export type Guidelines_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guidelines>;
};

/** input type for inserting object relation for remote table "guidelines" */
export type Guidelines_Obj_Rel_Insert_Input = {
  data: Guidelines_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Guidelines_On_Conflict>;
};

/** on_conflict condition type for table "guidelines" */
export type Guidelines_On_Conflict = {
  constraint: Guidelines_Constraint;
  update_columns?: Array<Guidelines_Update_Column>;
  where?: Maybe<Guidelines_Bool_Exp>;
};

/** Ordering options when selecting data from "guidelines". */
export type Guidelines_Order_By = {
  area?: Maybe<Areas_Order_By>;
  area_id?: Maybe<Order_By>;
  booking?: Maybe<Bookings_Order_By>;
  booking_id?: Maybe<Order_By>;
  child_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  deleted?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  document?: Maybe<Documents_Order_By>;
  document_id?: Maybe<Order_By>;
  guideline_role?: Maybe<Guideline_Role_Order_By>;
  guideline_status?: Maybe<Guideline_Status_Order_By>;
  guideline_type?: Maybe<Guideline_Type_Order_By>;
  id?: Maybe<Order_By>;
  information?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_guideline?: Maybe<Guidelines_Order_By>;
  parent_guideline_id?: Maybe<Order_By>;
  parent_guideline_type?: Maybe<Order_By>;
  parent_guideline_type_enum?: Maybe<Guideline_Type_Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  talent?: Maybe<Users_Order_By>;
  talent_completed?: Maybe<Order_By>;
  talent_confirmed?: Maybe<Order_By>;
  talent_id?: Maybe<Order_By>;
  talent_required?: Maybe<Order_By>;
  target_booking_status?: Maybe<Order_By>;
  target_booking_status_enum?: Maybe<Booking_Status_Order_By>;
  target_booking_type?: Maybe<Order_By>;
  target_booking_type_enum?: Maybe<Booking_Type_Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_completed?: Maybe<Order_By>;
  tenant_confirmed?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  tenant_required?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
  venue?: Maybe<Tenants_Order_By>;
  venue_completed?: Maybe<Order_By>;
  venue_confirmed?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
  venue_required?: Maybe<Order_By>;
};

/** primary key columns input for table: guidelines */
export type Guidelines_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Guidelines_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "guidelines" */
export enum Guidelines_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Information = 'information',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  ParentGuidelineId = 'parent_guideline_id',
  /** column name */
  ParentGuidelineType = 'parent_guideline_type',
  /** column name */
  Role = 'role',
  /** column name */
  Status = 'status',
  /** column name */
  TalentCompleted = 'talent_completed',
  /** column name */
  TalentConfirmed = 'talent_confirmed',
  /** column name */
  TalentId = 'talent_id',
  /** column name */
  TalentRequired = 'talent_required',
  /** column name */
  TargetBookingStatus = 'target_booking_status',
  /** column name */
  TargetBookingType = 'target_booking_type',
  /** column name */
  TenantCompleted = 'tenant_completed',
  /** column name */
  TenantConfirmed = 'tenant_confirmed',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TenantRequired = 'tenant_required',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueCompleted = 'venue_completed',
  /** column name */
  VenueConfirmed = 'venue_confirmed',
  /** column name */
  VenueId = 'venue_id',
  /** column name */
  VenueRequired = 'venue_required'
}

/** select "guidelines_aggregate_bool_exp_bool_and_arguments_columns" columns of table "guidelines" */
export enum Guidelines_Select_Column_Guidelines_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  TalentCompleted = 'talent_completed',
  /** column name */
  TalentConfirmed = 'talent_confirmed',
  /** column name */
  TalentRequired = 'talent_required',
  /** column name */
  TenantCompleted = 'tenant_completed',
  /** column name */
  TenantConfirmed = 'tenant_confirmed',
  /** column name */
  TenantRequired = 'tenant_required',
  /** column name */
  VenueCompleted = 'venue_completed',
  /** column name */
  VenueConfirmed = 'venue_confirmed',
  /** column name */
  VenueRequired = 'venue_required'
}

/** select "guidelines_aggregate_bool_exp_bool_or_arguments_columns" columns of table "guidelines" */
export enum Guidelines_Select_Column_Guidelines_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  TalentCompleted = 'talent_completed',
  /** column name */
  TalentConfirmed = 'talent_confirmed',
  /** column name */
  TalentRequired = 'talent_required',
  /** column name */
  TenantCompleted = 'tenant_completed',
  /** column name */
  TenantConfirmed = 'tenant_confirmed',
  /** column name */
  TenantRequired = 'tenant_required',
  /** column name */
  VenueCompleted = 'venue_completed',
  /** column name */
  VenueConfirmed = 'venue_confirmed',
  /** column name */
  VenueRequired = 'venue_required'
}

/** input type for updating data in table "guidelines" */
export type Guidelines_Set_Input = {
  area_id?: Maybe<Scalars['uuid']>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  information?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  parent_guideline_id?: Maybe<Scalars['uuid']>;
  parent_guideline_type?: Maybe<Guideline_Type_Enum>;
  role?: Maybe<Guideline_Role_Enum>;
  status?: Maybe<Guideline_Status_Enum>;
  talent_completed?: Maybe<Scalars['Boolean']>;
  talent_confirmed?: Maybe<Scalars['Boolean']>;
  talent_id?: Maybe<Scalars['uuid']>;
  talent_required?: Maybe<Scalars['Boolean']>;
  target_booking_status?: Maybe<Booking_Status_Enum>;
  target_booking_type?: Maybe<Booking_Type_Enum>;
  tenant_completed?: Maybe<Scalars['Boolean']>;
  tenant_confirmed?: Maybe<Scalars['Boolean']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  tenant_required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Guideline_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_completed?: Maybe<Scalars['Boolean']>;
  venue_confirmed?: Maybe<Scalars['Boolean']>;
  venue_id?: Maybe<Scalars['uuid']>;
  venue_required?: Maybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "guidelines" */
export type Guidelines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guidelines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guidelines_Stream_Cursor_Value_Input = {
  area_id?: Maybe<Scalars['uuid']>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  information?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  parent_guideline_id?: Maybe<Scalars['uuid']>;
  parent_guideline_type?: Maybe<Guideline_Type_Enum>;
  role?: Maybe<Guideline_Role_Enum>;
  status?: Maybe<Guideline_Status_Enum>;
  talent_completed?: Maybe<Scalars['Boolean']>;
  talent_confirmed?: Maybe<Scalars['Boolean']>;
  talent_id?: Maybe<Scalars['uuid']>;
  talent_required?: Maybe<Scalars['Boolean']>;
  target_booking_status?: Maybe<Booking_Status_Enum>;
  target_booking_type?: Maybe<Booking_Type_Enum>;
  tenant_completed?: Maybe<Scalars['Boolean']>;
  tenant_confirmed?: Maybe<Scalars['Boolean']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  tenant_required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Guideline_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_completed?: Maybe<Scalars['Boolean']>;
  venue_confirmed?: Maybe<Scalars['Boolean']>;
  venue_id?: Maybe<Scalars['uuid']>;
  venue_required?: Maybe<Scalars['Boolean']>;
};

/** update columns of table "guidelines" */
export enum Guidelines_Update_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Information = 'information',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  ParentGuidelineId = 'parent_guideline_id',
  /** column name */
  ParentGuidelineType = 'parent_guideline_type',
  /** column name */
  Role = 'role',
  /** column name */
  Status = 'status',
  /** column name */
  TalentCompleted = 'talent_completed',
  /** column name */
  TalentConfirmed = 'talent_confirmed',
  /** column name */
  TalentId = 'talent_id',
  /** column name */
  TalentRequired = 'talent_required',
  /** column name */
  TargetBookingStatus = 'target_booking_status',
  /** column name */
  TargetBookingType = 'target_booking_type',
  /** column name */
  TenantCompleted = 'tenant_completed',
  /** column name */
  TenantConfirmed = 'tenant_confirmed',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TenantRequired = 'tenant_required',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueCompleted = 'venue_completed',
  /** column name */
  VenueConfirmed = 'venue_confirmed',
  /** column name */
  VenueId = 'venue_id',
  /** column name */
  VenueRequired = 'venue_required'
}

export type Guidelines_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Guidelines_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Guidelines_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Guidelines_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Guidelines_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Guidelines_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Guidelines_Set_Input>;
  /** filter the rows which have to be updated */
  where: Guidelines_Bool_Exp;
};

/** columns and relationships of "invoice_target" */
export type Invoice_Target = {
  /** An array relationship */
  bookings: Array<Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Bookings_Aggregate;
  display: Scalars['String'];
  value: Scalars['String'];
};


/** columns and relationships of "invoice_target" */
export type Invoice_TargetBookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "invoice_target" */
export type Invoice_TargetBookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};

/** aggregated selection of "invoice_target" */
export type Invoice_Target_Aggregate = {
  aggregate?: Maybe<Invoice_Target_Aggregate_Fields>;
  nodes: Array<Invoice_Target>;
};

/** aggregate fields of "invoice_target" */
export type Invoice_Target_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Invoice_Target_Max_Fields>;
  min?: Maybe<Invoice_Target_Min_Fields>;
};


/** aggregate fields of "invoice_target" */
export type Invoice_Target_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Invoice_Target_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoice_target". All fields are combined with a logical 'AND'. */
export type Invoice_Target_Bool_Exp = {
  _and?: Maybe<Array<Invoice_Target_Bool_Exp>>;
  _not?: Maybe<Invoice_Target_Bool_Exp>;
  _or?: Maybe<Array<Invoice_Target_Bool_Exp>>;
  bookings?: Maybe<Bookings_Bool_Exp>;
  bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  display?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoice_target" */
export enum Invoice_Target_Constraint {
  /** unique or primary key constraint on columns "value" */
  InvoiceTargetPkey = 'invoice_target_pkey'
}

export enum Invoice_Target_Enum {
  /** Agency */
  Agency = 'agency',
  /** Talent */
  Talent = 'talent',
  /** Venue */
  Venue = 'venue'
}

/** Boolean expression to compare columns of type "invoice_target_enum". All fields are combined with logical 'AND'. */
export type Invoice_Target_Enum_Comparison_Exp = {
  _eq?: Maybe<Invoice_Target_Enum>;
  _in?: Maybe<Array<Invoice_Target_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Invoice_Target_Enum>;
  _nin?: Maybe<Array<Invoice_Target_Enum>>;
};

/** input type for inserting data into table "invoice_target" */
export type Invoice_Target_Insert_Input = {
  bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Invoice_Target_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Invoice_Target_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "invoice_target" */
export type Invoice_Target_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice_Target>;
};

/** input type for inserting object relation for remote table "invoice_target" */
export type Invoice_Target_Obj_Rel_Insert_Input = {
  data: Invoice_Target_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Invoice_Target_On_Conflict>;
};

/** on_conflict condition type for table "invoice_target" */
export type Invoice_Target_On_Conflict = {
  constraint: Invoice_Target_Constraint;
  update_columns?: Array<Invoice_Target_Update_Column>;
  where?: Maybe<Invoice_Target_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice_target". */
export type Invoice_Target_Order_By = {
  bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  display?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: invoice_target */
export type Invoice_Target_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "invoice_target" */
export enum Invoice_Target_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "invoice_target" */
export type Invoice_Target_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "invoice_target" */
export type Invoice_Target_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Target_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Target_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "invoice_target" */
export enum Invoice_Target_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Invoice_Target_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Invoice_Target_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Target_Bool_Exp;
};


export type Jsonb_Cast_Exp = {
  String?: Maybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: Maybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

export type Mark_Thread_Read_Args = {
  p_thread_id?: Maybe<Scalars['uuid']>;
  p_to_message_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "message_attachments" */
export type Message_Attachments = {
  created_at: Scalars['timestamptz'];
  filename: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  mime: Scalars['String'];
  size: Scalars['bigint'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid'];
  url: Scalars['String'];
};

/** aggregated selection of "message_attachments" */
export type Message_Attachments_Aggregate = {
  aggregate?: Maybe<Message_Attachments_Aggregate_Fields>;
  nodes: Array<Message_Attachments>;
};

export type Message_Attachments_Aggregate_Bool_Exp = {
  count?: Maybe<Message_Attachments_Aggregate_Bool_Exp_Count>;
};

export type Message_Attachments_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Message_Attachments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Message_Attachments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "message_attachments" */
export type Message_Attachments_Aggregate_Fields = {
  avg?: Maybe<Message_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Message_Attachments_Max_Fields>;
  min?: Maybe<Message_Attachments_Min_Fields>;
  stddev?: Maybe<Message_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Message_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Message_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Message_Attachments_Sum_Fields>;
  var_pop?: Maybe<Message_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Message_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Message_Attachments_Variance_Fields>;
};


/** aggregate fields of "message_attachments" */
export type Message_Attachments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Message_Attachments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "message_attachments" */
export type Message_Attachments_Aggregate_Order_By = {
  avg?: Maybe<Message_Attachments_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Message_Attachments_Max_Order_By>;
  min?: Maybe<Message_Attachments_Min_Order_By>;
  stddev?: Maybe<Message_Attachments_Stddev_Order_By>;
  stddev_pop?: Maybe<Message_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Message_Attachments_Stddev_Samp_Order_By>;
  sum?: Maybe<Message_Attachments_Sum_Order_By>;
  var_pop?: Maybe<Message_Attachments_Var_Pop_Order_By>;
  var_samp?: Maybe<Message_Attachments_Var_Samp_Order_By>;
  variance?: Maybe<Message_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "message_attachments" */
export type Message_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Message_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Message_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Message_Attachments_Avg_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "message_attachments" */
export type Message_Attachments_Avg_Order_By = {
  size?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "message_attachments". All fields are combined with a logical 'AND'. */
export type Message_Attachments_Bool_Exp = {
  _and?: Maybe<Array<Message_Attachments_Bool_Exp>>;
  _not?: Maybe<Message_Attachments_Bool_Exp>;
  _or?: Maybe<Array<Message_Attachments_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  filename?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  message?: Maybe<Messages_Bool_Exp>;
  message_id?: Maybe<Uuid_Comparison_Exp>;
  mime?: Maybe<String_Comparison_Exp>;
  size?: Maybe<Bigint_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  url?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "message_attachments" */
export enum Message_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessageAttachmentsPkey = 'message_attachments_pkey'
}

/** input type for incrementing numeric columns in table "message_attachments" */
export type Message_Attachments_Inc_Input = {
  size?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "message_attachments" */
export type Message_Attachments_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Messages_Obj_Rel_Insert_Input>;
  message_id?: Maybe<Scalars['uuid']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['bigint']>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Message_Attachments_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['bigint']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "message_attachments" */
export type Message_Attachments_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  filename?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message_id?: Maybe<Order_By>;
  mime?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Message_Attachments_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['bigint']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "message_attachments" */
export type Message_Attachments_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  filename?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message_id?: Maybe<Order_By>;
  mime?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** response of any mutation on the table "message_attachments" */
export type Message_Attachments_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Message_Attachments>;
};

/** on_conflict condition type for table "message_attachments" */
export type Message_Attachments_On_Conflict = {
  constraint: Message_Attachments_Constraint;
  update_columns?: Array<Message_Attachments_Update_Column>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "message_attachments". */
export type Message_Attachments_Order_By = {
  created_at?: Maybe<Order_By>;
  filename?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Messages_Order_By>;
  message_id?: Maybe<Order_By>;
  mime?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** primary key columns input for table: message_attachments */
export type Message_Attachments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "message_attachments" */
export enum Message_Attachments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Mime = 'mime',
  /** column name */
  Size = 'size',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "message_attachments" */
export type Message_Attachments_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['bigint']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Message_Attachments_Stddev_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "message_attachments" */
export type Message_Attachments_Stddev_Order_By = {
  size?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Message_Attachments_Stddev_Pop_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "message_attachments" */
export type Message_Attachments_Stddev_Pop_Order_By = {
  size?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Message_Attachments_Stddev_Samp_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "message_attachments" */
export type Message_Attachments_Stddev_Samp_Order_By = {
  size?: Maybe<Order_By>;
};

/** Streaming cursor of the table "message_attachments" */
export type Message_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Message_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Message_Attachments_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['bigint']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Message_Attachments_Sum_Fields = {
  size?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "message_attachments" */
export type Message_Attachments_Sum_Order_By = {
  size?: Maybe<Order_By>;
};

/** update columns of table "message_attachments" */
export enum Message_Attachments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Mime = 'mime',
  /** column name */
  Size = 'size',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Url = 'url'
}

export type Message_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Message_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Message_Attachments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Message_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Message_Attachments_Var_Pop_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "message_attachments" */
export type Message_Attachments_Var_Pop_Order_By = {
  size?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Message_Attachments_Var_Samp_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "message_attachments" */
export type Message_Attachments_Var_Samp_Order_By = {
  size?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Message_Attachments_Variance_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "message_attachments" */
export type Message_Attachments_Variance_Order_By = {
  size?: Maybe<Order_By>;
};

/** columns and relationships of "message_type" */
export type Message_Type = {
  display: Scalars['String'];
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "message_type" */
export type Message_TypeMessagesArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


/** columns and relationships of "message_type" */
export type Message_TypeMessages_AggregateArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};

/** aggregated selection of "message_type" */
export type Message_Type_Aggregate = {
  aggregate?: Maybe<Message_Type_Aggregate_Fields>;
  nodes: Array<Message_Type>;
};

/** aggregate fields of "message_type" */
export type Message_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Message_Type_Max_Fields>;
  min?: Maybe<Message_Type_Min_Fields>;
};


/** aggregate fields of "message_type" */
export type Message_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Message_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "message_type". All fields are combined with a logical 'AND'. */
export type Message_Type_Bool_Exp = {
  _and?: Maybe<Array<Message_Type_Bool_Exp>>;
  _not?: Maybe<Message_Type_Bool_Exp>;
  _or?: Maybe<Array<Message_Type_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  messages?: Maybe<Messages_Bool_Exp>;
  messages_aggregate?: Maybe<Messages_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "message_type" */
export enum Message_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  MessageTypePkey = 'message_type_pkey'
}

export enum Message_Type_Enum {
  /** Action */
  Action = 'action',
  /** System */
  System = 'system',
  /** Text */
  Text = 'text'
}

/** Boolean expression to compare columns of type "message_type_enum". All fields are combined with logical 'AND'. */
export type Message_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Message_Type_Enum>;
  _in?: Maybe<Array<Message_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Message_Type_Enum>;
  _nin?: Maybe<Array<Message_Type_Enum>>;
};

/** input type for inserting data into table "message_type" */
export type Message_Type_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  messages?: Maybe<Messages_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Message_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Message_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "message_type" */
export type Message_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Message_Type>;
};

/** input type for inserting object relation for remote table "message_type" */
export type Message_Type_Obj_Rel_Insert_Input = {
  data: Message_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Message_Type_On_Conflict>;
};

/** on_conflict condition type for table "message_type" */
export type Message_Type_On_Conflict = {
  constraint: Message_Type_Constraint;
  update_columns?: Array<Message_Type_Update_Column>;
  where?: Maybe<Message_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "message_type". */
export type Message_Type_Order_By = {
  display?: Maybe<Order_By>;
  messages_aggregate?: Maybe<Messages_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: message_type */
export type Message_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "message_type" */
export enum Message_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "message_type" */
export type Message_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "message_type" */
export type Message_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Message_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Message_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "message_type" */
export enum Message_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Message_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Message_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Message_Type_Bool_Exp;
};

/** columns and relationships of "messages" */
export type Messages = {
  /** An array relationship */
  attachments: Array<Message_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Message_Attachments_Aggregate;
  /** An object relationship */
  author?: Maybe<Users>;
  author_id?: Maybe<Scalars['uuid']>;
  body?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  idem_key?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  message_type: Message_Type;
  meta?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  thread: Threads;
  thread_id: Scalars['uuid'];
  type: Message_Type_Enum;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "messages" */
export type MessagesAttachmentsArgs = {
  distinct_on?: Maybe<Array<Message_Attachments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Attachments_Order_By>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesAttachments_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Attachments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Attachments_Order_By>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "messages" */
export type Messages_Aggregate = {
  aggregate?: Maybe<Messages_Aggregate_Fields>;
  nodes: Array<Messages>;
};

export type Messages_Aggregate_Bool_Exp = {
  count?: Maybe<Messages_Aggregate_Bool_Exp_Count>;
};

export type Messages_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Messages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "messages" */
export type Messages_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Messages_Max_Fields>;
  min?: Maybe<Messages_Min_Fields>;
};


/** aggregate fields of "messages" */
export type Messages_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Messages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "messages" */
export type Messages_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Messages_Max_Order_By>;
  min?: Maybe<Messages_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Messages_Append_Input = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "messages" */
export type Messages_Arr_Rel_Insert_Input = {
  data: Array<Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Messages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export type Messages_Bool_Exp = {
  _and?: Maybe<Array<Messages_Bool_Exp>>;
  _not?: Maybe<Messages_Bool_Exp>;
  _or?: Maybe<Array<Messages_Bool_Exp>>;
  attachments?: Maybe<Message_Attachments_Bool_Exp>;
  attachments_aggregate?: Maybe<Message_Attachments_Aggregate_Bool_Exp>;
  author?: Maybe<Users_Bool_Exp>;
  author_id?: Maybe<Uuid_Comparison_Exp>;
  body?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  idem_key?: Maybe<Uuid_Comparison_Exp>;
  message_type?: Maybe<Message_Type_Bool_Exp>;
  meta?: Maybe<Jsonb_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  thread?: Maybe<Threads_Bool_Exp>;
  thread_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<Message_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "messages" */
export enum Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagesPkey = 'messages_pkey',
  /** unique or primary key constraint on columns "thread_id", "idem_key" */
  MessagesUniqueIdemPerThread = 'messages_unique_idem_per_thread'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Messages_Delete_At_Path_Input = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Messages_Delete_Elem_Input = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Messages_Delete_Key_Input = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "messages" */
export type Messages_Insert_Input = {
  attachments?: Maybe<Message_Attachments_Arr_Rel_Insert_Input>;
  author?: Maybe<Users_Obj_Rel_Insert_Input>;
  author_id?: Maybe<Scalars['uuid']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idem_key?: Maybe<Scalars['uuid']>;
  message_type?: Maybe<Message_Type_Obj_Rel_Insert_Input>;
  meta?: Maybe<Scalars['jsonb']>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread?: Maybe<Threads_Obj_Rel_Insert_Input>;
  thread_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Message_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Messages_Max_Fields = {
  author_id?: Maybe<Scalars['uuid']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idem_key?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "messages" */
export type Messages_Max_Order_By = {
  author_id?: Maybe<Order_By>;
  body?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  idem_key?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  thread_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Messages_Min_Fields = {
  author_id?: Maybe<Scalars['uuid']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idem_key?: Maybe<Scalars['uuid']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "messages" */
export type Messages_Min_Order_By = {
  author_id?: Maybe<Order_By>;
  body?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  idem_key?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  thread_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "messages" */
export type Messages_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Messages>;
};

/** input type for inserting object relation for remote table "messages" */
export type Messages_Obj_Rel_Insert_Input = {
  data: Messages_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Messages_On_Conflict>;
};

/** on_conflict condition type for table "messages" */
export type Messages_On_Conflict = {
  constraint: Messages_Constraint;
  update_columns?: Array<Messages_Update_Column>;
  where?: Maybe<Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "messages". */
export type Messages_Order_By = {
  attachments_aggregate?: Maybe<Message_Attachments_Aggregate_Order_By>;
  author?: Maybe<Users_Order_By>;
  author_id?: Maybe<Order_By>;
  body?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  idem_key?: Maybe<Order_By>;
  message_type?: Maybe<Message_Type_Order_By>;
  meta?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  thread?: Maybe<Threads_Order_By>;
  thread_id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: messages */
export type Messages_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Messages_Prepend_Input = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "messages" */
export enum Messages_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdemKey = 'idem_key',
  /** column name */
  Meta = 'meta',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "messages" */
export type Messages_Set_Input = {
  author_id?: Maybe<Scalars['uuid']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idem_key?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Message_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "messages" */
export type Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messages_Stream_Cursor_Value_Input = {
  author_id?: Maybe<Scalars['uuid']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idem_key?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Message_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "messages" */
export enum Messages_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdemKey = 'idem_key',
  /** column name */
  Meta = 'meta',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Messages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Messages_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messages_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  /** execute VOLATILE function "create_booking_with_series" which returns "bookings" */
  create_booking_with_series?: Maybe<Bookings>;
  /** execute VOLATILE function "create_thread_with_message" which returns "threads" */
  create_thread_with_message?: Maybe<Threads>;
  /** delete data from the table: "area_status" */
  delete_area_status?: Maybe<Area_Status_Mutation_Response>;
  /** delete single row from the table: "area_status" */
  delete_area_status_by_pk?: Maybe<Area_Status>;
  /** delete data from the table: "area_type" */
  delete_area_type?: Maybe<Area_Type_Mutation_Response>;
  /** delete single row from the table: "area_type" */
  delete_area_type_by_pk?: Maybe<Area_Type>;
  /** delete data from the table: "areas" */
  delete_areas?: Maybe<Areas_Mutation_Response>;
  /** delete single row from the table: "areas" */
  delete_areas_by_pk?: Maybe<Areas>;
  /** delete data from the table: "blackouts" */
  delete_blackouts?: Maybe<Blackouts_Mutation_Response>;
  /** delete single row from the table: "blackouts" */
  delete_blackouts_by_pk?: Maybe<Blackouts>;
  /** delete data from the table: "booking_series" */
  delete_booking_series?: Maybe<Booking_Series_Mutation_Response>;
  /** delete single row from the table: "booking_series" */
  delete_booking_series_by_pk?: Maybe<Booking_Series>;
  /** delete data from the table: "booking_status" */
  delete_booking_status?: Maybe<Booking_Status_Mutation_Response>;
  /** delete single row from the table: "booking_status" */
  delete_booking_status_by_pk?: Maybe<Booking_Status>;
  /** delete data from the table: "booking_type" */
  delete_booking_type?: Maybe<Booking_Type_Mutation_Response>;
  /** delete single row from the table: "booking_type" */
  delete_booking_type_by_pk?: Maybe<Booking_Type>;
  /** delete data from the table: "bookings" */
  delete_bookings?: Maybe<Bookings_Mutation_Response>;
  /** delete single row from the table: "bookings" */
  delete_bookings_by_pk?: Maybe<Bookings>;
  /** delete data from the table: "document_role" */
  delete_document_role?: Maybe<Document_Role_Mutation_Response>;
  /** delete single row from the table: "document_role" */
  delete_document_role_by_pk?: Maybe<Document_Role>;
  /** delete data from the table: "document_status" */
  delete_document_status?: Maybe<Document_Status_Mutation_Response>;
  /** delete single row from the table: "document_status" */
  delete_document_status_by_pk?: Maybe<Document_Status>;
  /** delete data from the table: "document_type" */
  delete_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** delete single row from the table: "document_type" */
  delete_document_type_by_pk?: Maybe<Document_Type>;
  /** delete data from the table: "documents" */
  delete_documents?: Maybe<Documents_Mutation_Response>;
  /** delete single row from the table: "documents" */
  delete_documents_by_pk?: Maybe<Documents>;
  /** delete data from the table: "guideline_role" */
  delete_guideline_role?: Maybe<Guideline_Role_Mutation_Response>;
  /** delete single row from the table: "guideline_role" */
  delete_guideline_role_by_pk?: Maybe<Guideline_Role>;
  /** delete data from the table: "guideline_status" */
  delete_guideline_status?: Maybe<Guideline_Status_Mutation_Response>;
  /** delete single row from the table: "guideline_status" */
  delete_guideline_status_by_pk?: Maybe<Guideline_Status>;
  /** delete data from the table: "guideline_type" */
  delete_guideline_type?: Maybe<Guideline_Type_Mutation_Response>;
  /** delete single row from the table: "guideline_type" */
  delete_guideline_type_by_pk?: Maybe<Guideline_Type>;
  /** delete data from the table: "guidelines" */
  delete_guidelines?: Maybe<Guidelines_Mutation_Response>;
  /** delete single row from the table: "guidelines" */
  delete_guidelines_by_pk?: Maybe<Guidelines>;
  /** delete data from the table: "invoice_target" */
  delete_invoice_target?: Maybe<Invoice_Target_Mutation_Response>;
  /** delete single row from the table: "invoice_target" */
  delete_invoice_target_by_pk?: Maybe<Invoice_Target>;
  /** delete data from the table: "message_attachments" */
  delete_message_attachments?: Maybe<Message_Attachments_Mutation_Response>;
  /** delete single row from the table: "message_attachments" */
  delete_message_attachments_by_pk?: Maybe<Message_Attachments>;
  /** delete data from the table: "message_type" */
  delete_message_type?: Maybe<Message_Type_Mutation_Response>;
  /** delete single row from the table: "message_type" */
  delete_message_type_by_pk?: Maybe<Message_Type>;
  /** delete data from the table: "messages" */
  delete_messages?: Maybe<Messages_Mutation_Response>;
  /** delete single row from the table: "messages" */
  delete_messages_by_pk?: Maybe<Messages>;
  /** delete data from the table: "push_subscriptions" */
  delete_push_subscriptions?: Maybe<Push_Subscriptions_Mutation_Response>;
  /** delete single row from the table: "push_subscriptions" */
  delete_push_subscriptions_by_pk?: Maybe<Push_Subscriptions>;
  /** delete data from the table: "rate_type" */
  delete_rate_type?: Maybe<Rate_Type_Mutation_Response>;
  /** delete single row from the table: "rate_type" */
  delete_rate_type_by_pk?: Maybe<Rate_Type>;
  /** delete data from the table: "tenant_status" */
  delete_tenant_status?: Maybe<Tenant_Status_Mutation_Response>;
  /** delete single row from the table: "tenant_status" */
  delete_tenant_status_by_pk?: Maybe<Tenant_Status>;
  /** delete data from the table: "tenant_type" */
  delete_tenant_type?: Maybe<Tenant_Type_Mutation_Response>;
  /** delete single row from the table: "tenant_type" */
  delete_tenant_type_by_pk?: Maybe<Tenant_Type>;
  /** delete data from the table: "tenants" */
  delete_tenants?: Maybe<Tenants_Mutation_Response>;
  /** delete single row from the table: "tenants" */
  delete_tenants_by_pk?: Maybe<Tenants>;
  /** delete data from the table: "thread_departments" */
  delete_thread_departments?: Maybe<Thread_Departments_Mutation_Response>;
  /** delete single row from the table: "thread_departments" */
  delete_thread_departments_by_pk?: Maybe<Thread_Departments>;
  /** delete data from the table: "thread_members" */
  delete_thread_members?: Maybe<Thread_Members_Mutation_Response>;
  /** delete single row from the table: "thread_members" */
  delete_thread_members_by_pk?: Maybe<Thread_Members>;
  /** delete data from the table: "thread_status" */
  delete_thread_status?: Maybe<Thread_Status_Mutation_Response>;
  /** delete single row from the table: "thread_status" */
  delete_thread_status_by_pk?: Maybe<Thread_Status>;
  /** delete data from the table: "thread_type" */
  delete_thread_type?: Maybe<Thread_Type_Mutation_Response>;
  /** delete single row from the table: "thread_type" */
  delete_thread_type_by_pk?: Maybe<Thread_Type>;
  /** delete data from the table: "threads" */
  delete_threads?: Maybe<Threads_Mutation_Response>;
  /** delete single row from the table: "threads" */
  delete_threads_by_pk?: Maybe<Threads>;
  /** delete data from the table: "user_roles" */
  delete_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** delete single row from the table: "user_roles" */
  delete_user_roles_by_pk?: Maybe<User_Roles>;
  /** delete data from the table: "user_status" */
  delete_user_status?: Maybe<User_Status_Mutation_Response>;
  /** delete single row from the table: "user_status" */
  delete_user_status_by_pk?: Maybe<User_Status>;
  /** delete data from the table: "user_type" */
  delete_user_type?: Maybe<User_Type_Mutation_Response>;
  /** delete single row from the table: "user_type" */
  delete_user_type_by_pk?: Maybe<User_Type>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "area_status" */
  insert_area_status?: Maybe<Area_Status_Mutation_Response>;
  /** insert a single row into the table: "area_status" */
  insert_area_status_one?: Maybe<Area_Status>;
  /** insert data into the table: "area_type" */
  insert_area_type?: Maybe<Area_Type_Mutation_Response>;
  /** insert a single row into the table: "area_type" */
  insert_area_type_one?: Maybe<Area_Type>;
  /** insert data into the table: "areas" */
  insert_areas?: Maybe<Areas_Mutation_Response>;
  /** insert a single row into the table: "areas" */
  insert_areas_one?: Maybe<Areas>;
  /** insert data into the table: "blackouts" */
  insert_blackouts?: Maybe<Blackouts_Mutation_Response>;
  /** insert a single row into the table: "blackouts" */
  insert_blackouts_one?: Maybe<Blackouts>;
  /** insert data into the table: "booking_series" */
  insert_booking_series?: Maybe<Booking_Series_Mutation_Response>;
  /** insert a single row into the table: "booking_series" */
  insert_booking_series_one?: Maybe<Booking_Series>;
  /** insert data into the table: "booking_status" */
  insert_booking_status?: Maybe<Booking_Status_Mutation_Response>;
  /** insert a single row into the table: "booking_status" */
  insert_booking_status_one?: Maybe<Booking_Status>;
  /** insert data into the table: "booking_type" */
  insert_booking_type?: Maybe<Booking_Type_Mutation_Response>;
  /** insert a single row into the table: "booking_type" */
  insert_booking_type_one?: Maybe<Booking_Type>;
  /** insert data into the table: "bookings" */
  insert_bookings?: Maybe<Bookings_Mutation_Response>;
  /** insert a single row into the table: "bookings" */
  insert_bookings_one?: Maybe<Bookings>;
  /** insert data into the table: "document_role" */
  insert_document_role?: Maybe<Document_Role_Mutation_Response>;
  /** insert a single row into the table: "document_role" */
  insert_document_role_one?: Maybe<Document_Role>;
  /** insert data into the table: "document_status" */
  insert_document_status?: Maybe<Document_Status_Mutation_Response>;
  /** insert a single row into the table: "document_status" */
  insert_document_status_one?: Maybe<Document_Status>;
  /** insert data into the table: "document_type" */
  insert_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** insert a single row into the table: "document_type" */
  insert_document_type_one?: Maybe<Document_Type>;
  /** insert data into the table: "documents" */
  insert_documents?: Maybe<Documents_Mutation_Response>;
  /** insert a single row into the table: "documents" */
  insert_documents_one?: Maybe<Documents>;
  /** insert data into the table: "guideline_role" */
  insert_guideline_role?: Maybe<Guideline_Role_Mutation_Response>;
  /** insert a single row into the table: "guideline_role" */
  insert_guideline_role_one?: Maybe<Guideline_Role>;
  /** insert data into the table: "guideline_status" */
  insert_guideline_status?: Maybe<Guideline_Status_Mutation_Response>;
  /** insert a single row into the table: "guideline_status" */
  insert_guideline_status_one?: Maybe<Guideline_Status>;
  /** insert data into the table: "guideline_type" */
  insert_guideline_type?: Maybe<Guideline_Type_Mutation_Response>;
  /** insert a single row into the table: "guideline_type" */
  insert_guideline_type_one?: Maybe<Guideline_Type>;
  /** insert data into the table: "guidelines" */
  insert_guidelines?: Maybe<Guidelines_Mutation_Response>;
  /** insert a single row into the table: "guidelines" */
  insert_guidelines_one?: Maybe<Guidelines>;
  /** insert data into the table: "invoice_target" */
  insert_invoice_target?: Maybe<Invoice_Target_Mutation_Response>;
  /** insert a single row into the table: "invoice_target" */
  insert_invoice_target_one?: Maybe<Invoice_Target>;
  /** insert data into the table: "message_attachments" */
  insert_message_attachments?: Maybe<Message_Attachments_Mutation_Response>;
  /** insert a single row into the table: "message_attachments" */
  insert_message_attachments_one?: Maybe<Message_Attachments>;
  /** insert data into the table: "message_type" */
  insert_message_type?: Maybe<Message_Type_Mutation_Response>;
  /** insert a single row into the table: "message_type" */
  insert_message_type_one?: Maybe<Message_Type>;
  /** insert data into the table: "messages" */
  insert_messages?: Maybe<Messages_Mutation_Response>;
  /** insert a single row into the table: "messages" */
  insert_messages_one?: Maybe<Messages>;
  /** insert data into the table: "push_subscriptions" */
  insert_push_subscriptions?: Maybe<Push_Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "push_subscriptions" */
  insert_push_subscriptions_one?: Maybe<Push_Subscriptions>;
  /** insert data into the table: "rate_type" */
  insert_rate_type?: Maybe<Rate_Type_Mutation_Response>;
  /** insert a single row into the table: "rate_type" */
  insert_rate_type_one?: Maybe<Rate_Type>;
  /** insert data into the table: "tenant_status" */
  insert_tenant_status?: Maybe<Tenant_Status_Mutation_Response>;
  /** insert a single row into the table: "tenant_status" */
  insert_tenant_status_one?: Maybe<Tenant_Status>;
  /** insert data into the table: "tenant_type" */
  insert_tenant_type?: Maybe<Tenant_Type_Mutation_Response>;
  /** insert a single row into the table: "tenant_type" */
  insert_tenant_type_one?: Maybe<Tenant_Type>;
  /** insert data into the table: "tenants" */
  insert_tenants?: Maybe<Tenants_Mutation_Response>;
  /** insert a single row into the table: "tenants" */
  insert_tenants_one?: Maybe<Tenants>;
  /** insert data into the table: "thread_departments" */
  insert_thread_departments?: Maybe<Thread_Departments_Mutation_Response>;
  /** insert a single row into the table: "thread_departments" */
  insert_thread_departments_one?: Maybe<Thread_Departments>;
  /** insert data into the table: "thread_members" */
  insert_thread_members?: Maybe<Thread_Members_Mutation_Response>;
  /** insert a single row into the table: "thread_members" */
  insert_thread_members_one?: Maybe<Thread_Members>;
  /** insert data into the table: "thread_status" */
  insert_thread_status?: Maybe<Thread_Status_Mutation_Response>;
  /** insert a single row into the table: "thread_status" */
  insert_thread_status_one?: Maybe<Thread_Status>;
  /** insert data into the table: "thread_type" */
  insert_thread_type?: Maybe<Thread_Type_Mutation_Response>;
  /** insert a single row into the table: "thread_type" */
  insert_thread_type_one?: Maybe<Thread_Type>;
  /** insert data into the table: "threads" */
  insert_threads?: Maybe<Threads_Mutation_Response>;
  /** insert a single row into the table: "threads" */
  insert_threads_one?: Maybe<Threads>;
  /** insert data into the table: "user_roles" */
  insert_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** insert a single row into the table: "user_roles" */
  insert_user_roles_one?: Maybe<User_Roles>;
  /** insert data into the table: "user_status" */
  insert_user_status?: Maybe<User_Status_Mutation_Response>;
  /** insert a single row into the table: "user_status" */
  insert_user_status_one?: Maybe<User_Status>;
  /** insert data into the table: "user_type" */
  insert_user_type?: Maybe<User_Type_Mutation_Response>;
  /** insert a single row into the table: "user_type" */
  insert_user_type_one?: Maybe<User_Type>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** execute VOLATILE function "mark_thread_read" which returns "thread_members" */
  mark_thread_read?: Maybe<Thread_Members>;
  /** update data of the table: "area_status" */
  update_area_status?: Maybe<Area_Status_Mutation_Response>;
  /** update single row of the table: "area_status" */
  update_area_status_by_pk?: Maybe<Area_Status>;
  /** update multiples rows of table: "area_status" */
  update_area_status_many?: Maybe<Array<Maybe<Area_Status_Mutation_Response>>>;
  /** update data of the table: "area_type" */
  update_area_type?: Maybe<Area_Type_Mutation_Response>;
  /** update single row of the table: "area_type" */
  update_area_type_by_pk?: Maybe<Area_Type>;
  /** update multiples rows of table: "area_type" */
  update_area_type_many?: Maybe<Array<Maybe<Area_Type_Mutation_Response>>>;
  /** update data of the table: "areas" */
  update_areas?: Maybe<Areas_Mutation_Response>;
  /** update single row of the table: "areas" */
  update_areas_by_pk?: Maybe<Areas>;
  /** update multiples rows of table: "areas" */
  update_areas_many?: Maybe<Array<Maybe<Areas_Mutation_Response>>>;
  /** update data of the table: "blackouts" */
  update_blackouts?: Maybe<Blackouts_Mutation_Response>;
  /** update single row of the table: "blackouts" */
  update_blackouts_by_pk?: Maybe<Blackouts>;
  /** update multiples rows of table: "blackouts" */
  update_blackouts_many?: Maybe<Array<Maybe<Blackouts_Mutation_Response>>>;
  /** update data of the table: "booking_series" */
  update_booking_series?: Maybe<Booking_Series_Mutation_Response>;
  /** update single row of the table: "booking_series" */
  update_booking_series_by_pk?: Maybe<Booking_Series>;
  /** update multiples rows of table: "booking_series" */
  update_booking_series_many?: Maybe<Array<Maybe<Booking_Series_Mutation_Response>>>;
  /** update data of the table: "booking_status" */
  update_booking_status?: Maybe<Booking_Status_Mutation_Response>;
  /** update single row of the table: "booking_status" */
  update_booking_status_by_pk?: Maybe<Booking_Status>;
  /** update multiples rows of table: "booking_status" */
  update_booking_status_many?: Maybe<Array<Maybe<Booking_Status_Mutation_Response>>>;
  /** update data of the table: "booking_type" */
  update_booking_type?: Maybe<Booking_Type_Mutation_Response>;
  /** update single row of the table: "booking_type" */
  update_booking_type_by_pk?: Maybe<Booking_Type>;
  /** update multiples rows of table: "booking_type" */
  update_booking_type_many?: Maybe<Array<Maybe<Booking_Type_Mutation_Response>>>;
  /** update data of the table: "bookings" */
  update_bookings?: Maybe<Bookings_Mutation_Response>;
  /** update single row of the table: "bookings" */
  update_bookings_by_pk?: Maybe<Bookings>;
  /** update multiples rows of table: "bookings" */
  update_bookings_many?: Maybe<Array<Maybe<Bookings_Mutation_Response>>>;
  /** update data of the table: "document_role" */
  update_document_role?: Maybe<Document_Role_Mutation_Response>;
  /** update single row of the table: "document_role" */
  update_document_role_by_pk?: Maybe<Document_Role>;
  /** update multiples rows of table: "document_role" */
  update_document_role_many?: Maybe<Array<Maybe<Document_Role_Mutation_Response>>>;
  /** update data of the table: "document_status" */
  update_document_status?: Maybe<Document_Status_Mutation_Response>;
  /** update single row of the table: "document_status" */
  update_document_status_by_pk?: Maybe<Document_Status>;
  /** update multiples rows of table: "document_status" */
  update_document_status_many?: Maybe<Array<Maybe<Document_Status_Mutation_Response>>>;
  /** update data of the table: "document_type" */
  update_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** update single row of the table: "document_type" */
  update_document_type_by_pk?: Maybe<Document_Type>;
  /** update multiples rows of table: "document_type" */
  update_document_type_many?: Maybe<Array<Maybe<Document_Type_Mutation_Response>>>;
  /** update data of the table: "documents" */
  update_documents?: Maybe<Documents_Mutation_Response>;
  /** update single row of the table: "documents" */
  update_documents_by_pk?: Maybe<Documents>;
  /** update multiples rows of table: "documents" */
  update_documents_many?: Maybe<Array<Maybe<Documents_Mutation_Response>>>;
  /** update data of the table: "guideline_role" */
  update_guideline_role?: Maybe<Guideline_Role_Mutation_Response>;
  /** update single row of the table: "guideline_role" */
  update_guideline_role_by_pk?: Maybe<Guideline_Role>;
  /** update multiples rows of table: "guideline_role" */
  update_guideline_role_many?: Maybe<Array<Maybe<Guideline_Role_Mutation_Response>>>;
  /** update data of the table: "guideline_status" */
  update_guideline_status?: Maybe<Guideline_Status_Mutation_Response>;
  /** update single row of the table: "guideline_status" */
  update_guideline_status_by_pk?: Maybe<Guideline_Status>;
  /** update multiples rows of table: "guideline_status" */
  update_guideline_status_many?: Maybe<Array<Maybe<Guideline_Status_Mutation_Response>>>;
  /** update data of the table: "guideline_type" */
  update_guideline_type?: Maybe<Guideline_Type_Mutation_Response>;
  /** update single row of the table: "guideline_type" */
  update_guideline_type_by_pk?: Maybe<Guideline_Type>;
  /** update multiples rows of table: "guideline_type" */
  update_guideline_type_many?: Maybe<Array<Maybe<Guideline_Type_Mutation_Response>>>;
  /** update data of the table: "guidelines" */
  update_guidelines?: Maybe<Guidelines_Mutation_Response>;
  /** update single row of the table: "guidelines" */
  update_guidelines_by_pk?: Maybe<Guidelines>;
  /** update multiples rows of table: "guidelines" */
  update_guidelines_many?: Maybe<Array<Maybe<Guidelines_Mutation_Response>>>;
  /** update data of the table: "invoice_target" */
  update_invoice_target?: Maybe<Invoice_Target_Mutation_Response>;
  /** update single row of the table: "invoice_target" */
  update_invoice_target_by_pk?: Maybe<Invoice_Target>;
  /** update multiples rows of table: "invoice_target" */
  update_invoice_target_many?: Maybe<Array<Maybe<Invoice_Target_Mutation_Response>>>;
  /** update data of the table: "message_attachments" */
  update_message_attachments?: Maybe<Message_Attachments_Mutation_Response>;
  /** update single row of the table: "message_attachments" */
  update_message_attachments_by_pk?: Maybe<Message_Attachments>;
  /** update multiples rows of table: "message_attachments" */
  update_message_attachments_many?: Maybe<Array<Maybe<Message_Attachments_Mutation_Response>>>;
  /** update data of the table: "message_type" */
  update_message_type?: Maybe<Message_Type_Mutation_Response>;
  /** update single row of the table: "message_type" */
  update_message_type_by_pk?: Maybe<Message_Type>;
  /** update multiples rows of table: "message_type" */
  update_message_type_many?: Maybe<Array<Maybe<Message_Type_Mutation_Response>>>;
  /** update data of the table: "messages" */
  update_messages?: Maybe<Messages_Mutation_Response>;
  /** update single row of the table: "messages" */
  update_messages_by_pk?: Maybe<Messages>;
  /** update multiples rows of table: "messages" */
  update_messages_many?: Maybe<Array<Maybe<Messages_Mutation_Response>>>;
  /** update data of the table: "push_subscriptions" */
  update_push_subscriptions?: Maybe<Push_Subscriptions_Mutation_Response>;
  /** update single row of the table: "push_subscriptions" */
  update_push_subscriptions_by_pk?: Maybe<Push_Subscriptions>;
  /** update multiples rows of table: "push_subscriptions" */
  update_push_subscriptions_many?: Maybe<Array<Maybe<Push_Subscriptions_Mutation_Response>>>;
  /** update data of the table: "rate_type" */
  update_rate_type?: Maybe<Rate_Type_Mutation_Response>;
  /** update single row of the table: "rate_type" */
  update_rate_type_by_pk?: Maybe<Rate_Type>;
  /** update multiples rows of table: "rate_type" */
  update_rate_type_many?: Maybe<Array<Maybe<Rate_Type_Mutation_Response>>>;
  /** update data of the table: "tenant_status" */
  update_tenant_status?: Maybe<Tenant_Status_Mutation_Response>;
  /** update single row of the table: "tenant_status" */
  update_tenant_status_by_pk?: Maybe<Tenant_Status>;
  /** update multiples rows of table: "tenant_status" */
  update_tenant_status_many?: Maybe<Array<Maybe<Tenant_Status_Mutation_Response>>>;
  /** update data of the table: "tenant_type" */
  update_tenant_type?: Maybe<Tenant_Type_Mutation_Response>;
  /** update single row of the table: "tenant_type" */
  update_tenant_type_by_pk?: Maybe<Tenant_Type>;
  /** update multiples rows of table: "tenant_type" */
  update_tenant_type_many?: Maybe<Array<Maybe<Tenant_Type_Mutation_Response>>>;
  /** update data of the table: "tenants" */
  update_tenants?: Maybe<Tenants_Mutation_Response>;
  /** update single row of the table: "tenants" */
  update_tenants_by_pk?: Maybe<Tenants>;
  /** update multiples rows of table: "tenants" */
  update_tenants_many?: Maybe<Array<Maybe<Tenants_Mutation_Response>>>;
  /** update data of the table: "thread_departments" */
  update_thread_departments?: Maybe<Thread_Departments_Mutation_Response>;
  /** update single row of the table: "thread_departments" */
  update_thread_departments_by_pk?: Maybe<Thread_Departments>;
  /** update multiples rows of table: "thread_departments" */
  update_thread_departments_many?: Maybe<Array<Maybe<Thread_Departments_Mutation_Response>>>;
  /** update data of the table: "thread_members" */
  update_thread_members?: Maybe<Thread_Members_Mutation_Response>;
  /** update single row of the table: "thread_members" */
  update_thread_members_by_pk?: Maybe<Thread_Members>;
  /** update multiples rows of table: "thread_members" */
  update_thread_members_many?: Maybe<Array<Maybe<Thread_Members_Mutation_Response>>>;
  /** update data of the table: "thread_status" */
  update_thread_status?: Maybe<Thread_Status_Mutation_Response>;
  /** update single row of the table: "thread_status" */
  update_thread_status_by_pk?: Maybe<Thread_Status>;
  /** update multiples rows of table: "thread_status" */
  update_thread_status_many?: Maybe<Array<Maybe<Thread_Status_Mutation_Response>>>;
  /** update data of the table: "thread_type" */
  update_thread_type?: Maybe<Thread_Type_Mutation_Response>;
  /** update single row of the table: "thread_type" */
  update_thread_type_by_pk?: Maybe<Thread_Type>;
  /** update multiples rows of table: "thread_type" */
  update_thread_type_many?: Maybe<Array<Maybe<Thread_Type_Mutation_Response>>>;
  /** update data of the table: "threads" */
  update_threads?: Maybe<Threads_Mutation_Response>;
  /** update single row of the table: "threads" */
  update_threads_by_pk?: Maybe<Threads>;
  /** update multiples rows of table: "threads" */
  update_threads_many?: Maybe<Array<Maybe<Threads_Mutation_Response>>>;
  /** update data of the table: "user_roles" */
  update_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** update single row of the table: "user_roles" */
  update_user_roles_by_pk?: Maybe<User_Roles>;
  /** update multiples rows of table: "user_roles" */
  update_user_roles_many?: Maybe<Array<Maybe<User_Roles_Mutation_Response>>>;
  /** update data of the table: "user_status" */
  update_user_status?: Maybe<User_Status_Mutation_Response>;
  /** update single row of the table: "user_status" */
  update_user_status_by_pk?: Maybe<User_Status>;
  /** update multiples rows of table: "user_status" */
  update_user_status_many?: Maybe<Array<Maybe<User_Status_Mutation_Response>>>;
  /** update data of the table: "user_type" */
  update_user_type?: Maybe<User_Type_Mutation_Response>;
  /** update single row of the table: "user_type" */
  update_user_type_by_pk?: Maybe<User_Type>;
  /** update multiples rows of table: "user_type" */
  update_user_type_many?: Maybe<Array<Maybe<User_Type_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootCreate_Booking_With_SeriesArgs = {
  args: Create_Booking_With_Series_Args;
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCreate_Thread_With_MessageArgs = {
  args: Create_Thread_With_Message_Args;
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootDelete_Area_StatusArgs = {
  where: Area_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Area_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Area_TypeArgs = {
  where: Area_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Area_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_AreasArgs = {
  where: Areas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Areas_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_BlackoutsArgs = {
  where: Blackouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Blackouts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Booking_SeriesArgs = {
  where: Booking_Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Booking_Series_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Booking_StatusArgs = {
  where: Booking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Booking_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Booking_TypeArgs = {
  where: Booking_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Booking_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_BookingsArgs = {
  where: Bookings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bookings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_RoleArgs = {
  where: Document_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Role_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Document_StatusArgs = {
  where: Document_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Document_TypeArgs = {
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentsArgs = {
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Guideline_RoleArgs = {
  where: Guideline_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guideline_Role_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Guideline_StatusArgs = {
  where: Guideline_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guideline_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Guideline_TypeArgs = {
  where: Guideline_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guideline_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_GuidelinesArgs = {
  where: Guidelines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guidelines_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Invoice_TargetArgs = {
  where: Invoice_Target_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Target_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Message_AttachmentsArgs = {
  where: Message_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Message_Attachments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Message_TypeArgs = {
  where: Message_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Message_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_MessagesArgs = {
  where: Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Messages_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Push_SubscriptionsArgs = {
  where: Push_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Push_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Rate_TypeArgs = {
  where: Rate_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rate_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Tenant_StatusArgs = {
  where: Tenant_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenant_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Tenant_TypeArgs = {
  where: Tenant_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenant_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TenantsArgs = {
  where: Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenants_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Thread_DepartmentsArgs = {
  where: Thread_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Thread_Departments_By_PkArgs = {
  department: User_Type_Enum;
  thread_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Thread_MembersArgs = {
  where: Thread_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Thread_Members_By_PkArgs = {
  thread_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Thread_StatusArgs = {
  where: Thread_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Thread_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Thread_TypeArgs = {
  where: Thread_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Thread_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ThreadsArgs = {
  where: Threads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Threads_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_RolesArgs = {
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Roles_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_StatusArgs = {
  where: User_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_TypeArgs = {
  where: User_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_Area_StatusArgs = {
  objects: Array<Area_Status_Insert_Input>;
  on_conflict?: Maybe<Area_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Area_Status_OneArgs = {
  object: Area_Status_Insert_Input;
  on_conflict?: Maybe<Area_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Area_TypeArgs = {
  objects: Array<Area_Type_Insert_Input>;
  on_conflict?: Maybe<Area_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Area_Type_OneArgs = {
  object: Area_Type_Insert_Input;
  on_conflict?: Maybe<Area_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AreasArgs = {
  objects: Array<Areas_Insert_Input>;
  on_conflict?: Maybe<Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Areas_OneArgs = {
  object: Areas_Insert_Input;
  on_conflict?: Maybe<Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BlackoutsArgs = {
  objects: Array<Blackouts_Insert_Input>;
  on_conflict?: Maybe<Blackouts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blackouts_OneArgs = {
  object: Blackouts_Insert_Input;
  on_conflict?: Maybe<Blackouts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_SeriesArgs = {
  objects: Array<Booking_Series_Insert_Input>;
  on_conflict?: Maybe<Booking_Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_Series_OneArgs = {
  object: Booking_Series_Insert_Input;
  on_conflict?: Maybe<Booking_Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_StatusArgs = {
  objects: Array<Booking_Status_Insert_Input>;
  on_conflict?: Maybe<Booking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_Status_OneArgs = {
  object: Booking_Status_Insert_Input;
  on_conflict?: Maybe<Booking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_TypeArgs = {
  objects: Array<Booking_Type_Insert_Input>;
  on_conflict?: Maybe<Booking_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_Type_OneArgs = {
  object: Booking_Type_Insert_Input;
  on_conflict?: Maybe<Booking_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BookingsArgs = {
  objects: Array<Bookings_Insert_Input>;
  on_conflict?: Maybe<Bookings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bookings_OneArgs = {
  object: Bookings_Insert_Input;
  on_conflict?: Maybe<Bookings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_RoleArgs = {
  objects: Array<Document_Role_Insert_Input>;
  on_conflict?: Maybe<Document_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Role_OneArgs = {
  object: Document_Role_Insert_Input;
  on_conflict?: Maybe<Document_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_StatusArgs = {
  objects: Array<Document_Status_Insert_Input>;
  on_conflict?: Maybe<Document_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Status_OneArgs = {
  object: Document_Status_Insert_Input;
  on_conflict?: Maybe<Document_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_TypeArgs = {
  objects: Array<Document_Type_Insert_Input>;
  on_conflict?: Maybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_OneArgs = {
  object: Document_Type_Insert_Input;
  on_conflict?: Maybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentsArgs = {
  objects: Array<Documents_Insert_Input>;
  on_conflict?: Maybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Documents_OneArgs = {
  object: Documents_Insert_Input;
  on_conflict?: Maybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guideline_RoleArgs = {
  objects: Array<Guideline_Role_Insert_Input>;
  on_conflict?: Maybe<Guideline_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guideline_Role_OneArgs = {
  object: Guideline_Role_Insert_Input;
  on_conflict?: Maybe<Guideline_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guideline_StatusArgs = {
  objects: Array<Guideline_Status_Insert_Input>;
  on_conflict?: Maybe<Guideline_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guideline_Status_OneArgs = {
  object: Guideline_Status_Insert_Input;
  on_conflict?: Maybe<Guideline_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guideline_TypeArgs = {
  objects: Array<Guideline_Type_Insert_Input>;
  on_conflict?: Maybe<Guideline_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guideline_Type_OneArgs = {
  object: Guideline_Type_Insert_Input;
  on_conflict?: Maybe<Guideline_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GuidelinesArgs = {
  objects: Array<Guidelines_Insert_Input>;
  on_conflict?: Maybe<Guidelines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guidelines_OneArgs = {
  object: Guidelines_Insert_Input;
  on_conflict?: Maybe<Guidelines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_TargetArgs = {
  objects: Array<Invoice_Target_Insert_Input>;
  on_conflict?: Maybe<Invoice_Target_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Target_OneArgs = {
  object: Invoice_Target_Insert_Input;
  on_conflict?: Maybe<Invoice_Target_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Message_AttachmentsArgs = {
  objects: Array<Message_Attachments_Insert_Input>;
  on_conflict?: Maybe<Message_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Message_Attachments_OneArgs = {
  object: Message_Attachments_Insert_Input;
  on_conflict?: Maybe<Message_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Message_TypeArgs = {
  objects: Array<Message_Type_Insert_Input>;
  on_conflict?: Maybe<Message_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Message_Type_OneArgs = {
  object: Message_Type_Insert_Input;
  on_conflict?: Maybe<Message_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MessagesArgs = {
  objects: Array<Messages_Insert_Input>;
  on_conflict?: Maybe<Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Messages_OneArgs = {
  object: Messages_Insert_Input;
  on_conflict?: Maybe<Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_SubscriptionsArgs = {
  objects: Array<Push_Subscriptions_Insert_Input>;
  on_conflict?: Maybe<Push_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Subscriptions_OneArgs = {
  object: Push_Subscriptions_Insert_Input;
  on_conflict?: Maybe<Push_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rate_TypeArgs = {
  objects: Array<Rate_Type_Insert_Input>;
  on_conflict?: Maybe<Rate_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rate_Type_OneArgs = {
  object: Rate_Type_Insert_Input;
  on_conflict?: Maybe<Rate_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenant_StatusArgs = {
  objects: Array<Tenant_Status_Insert_Input>;
  on_conflict?: Maybe<Tenant_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenant_Status_OneArgs = {
  object: Tenant_Status_Insert_Input;
  on_conflict?: Maybe<Tenant_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenant_TypeArgs = {
  objects: Array<Tenant_Type_Insert_Input>;
  on_conflict?: Maybe<Tenant_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenant_Type_OneArgs = {
  object: Tenant_Type_Insert_Input;
  on_conflict?: Maybe<Tenant_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantsArgs = {
  objects: Array<Tenants_Insert_Input>;
  on_conflict?: Maybe<Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenants_OneArgs = {
  object: Tenants_Insert_Input;
  on_conflict?: Maybe<Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_DepartmentsArgs = {
  objects: Array<Thread_Departments_Insert_Input>;
  on_conflict?: Maybe<Thread_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_Departments_OneArgs = {
  object: Thread_Departments_Insert_Input;
  on_conflict?: Maybe<Thread_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_MembersArgs = {
  objects: Array<Thread_Members_Insert_Input>;
  on_conflict?: Maybe<Thread_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_Members_OneArgs = {
  object: Thread_Members_Insert_Input;
  on_conflict?: Maybe<Thread_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_StatusArgs = {
  objects: Array<Thread_Status_Insert_Input>;
  on_conflict?: Maybe<Thread_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_Status_OneArgs = {
  object: Thread_Status_Insert_Input;
  on_conflict?: Maybe<Thread_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_TypeArgs = {
  objects: Array<Thread_Type_Insert_Input>;
  on_conflict?: Maybe<Thread_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_Type_OneArgs = {
  object: Thread_Type_Insert_Input;
  on_conflict?: Maybe<Thread_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ThreadsArgs = {
  objects: Array<Threads_Insert_Input>;
  on_conflict?: Maybe<Threads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threads_OneArgs = {
  object: Threads_Insert_Input;
  on_conflict?: Maybe<Threads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RolesArgs = {
  objects: Array<User_Roles_Insert_Input>;
  on_conflict?: Maybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Roles_OneArgs = {
  object: User_Roles_Insert_Input;
  on_conflict?: Maybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_StatusArgs = {
  objects: Array<User_Status_Insert_Input>;
  on_conflict?: Maybe<User_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Status_OneArgs = {
  object: User_Status_Insert_Input;
  on_conflict?: Maybe<User_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_TypeArgs = {
  objects: Array<User_Type_Insert_Input>;
  on_conflict?: Maybe<User_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Type_OneArgs = {
  object: User_Type_Insert_Input;
  on_conflict?: Maybe<User_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootMark_Thread_ReadArgs = {
  args: Mark_Thread_Read_Args;
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_Area_StatusArgs = {
  _set?: Maybe<Area_Status_Set_Input>;
  where: Area_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Area_Status_By_PkArgs = {
  _set?: Maybe<Area_Status_Set_Input>;
  pk_columns: Area_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Area_Status_ManyArgs = {
  updates: Array<Area_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Area_TypeArgs = {
  _set?: Maybe<Area_Type_Set_Input>;
  where: Area_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Area_Type_By_PkArgs = {
  _set?: Maybe<Area_Type_Set_Input>;
  pk_columns: Area_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Area_Type_ManyArgs = {
  updates: Array<Area_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AreasArgs = {
  _inc?: Maybe<Areas_Inc_Input>;
  _set?: Maybe<Areas_Set_Input>;
  where: Areas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Areas_By_PkArgs = {
  _inc?: Maybe<Areas_Inc_Input>;
  _set?: Maybe<Areas_Set_Input>;
  pk_columns: Areas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Areas_ManyArgs = {
  updates: Array<Areas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BlackoutsArgs = {
  _set?: Maybe<Blackouts_Set_Input>;
  where: Blackouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Blackouts_By_PkArgs = {
  _set?: Maybe<Blackouts_Set_Input>;
  pk_columns: Blackouts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Blackouts_ManyArgs = {
  updates: Array<Blackouts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_SeriesArgs = {
  _inc?: Maybe<Booking_Series_Inc_Input>;
  _set?: Maybe<Booking_Series_Set_Input>;
  where: Booking_Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Series_By_PkArgs = {
  _inc?: Maybe<Booking_Series_Inc_Input>;
  _set?: Maybe<Booking_Series_Set_Input>;
  pk_columns: Booking_Series_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Series_ManyArgs = {
  updates: Array<Booking_Series_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_StatusArgs = {
  _set?: Maybe<Booking_Status_Set_Input>;
  where: Booking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Status_By_PkArgs = {
  _set?: Maybe<Booking_Status_Set_Input>;
  pk_columns: Booking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Status_ManyArgs = {
  updates: Array<Booking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_TypeArgs = {
  _set?: Maybe<Booking_Type_Set_Input>;
  where: Booking_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Type_By_PkArgs = {
  _set?: Maybe<Booking_Type_Set_Input>;
  pk_columns: Booking_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Type_ManyArgs = {
  updates: Array<Booking_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BookingsArgs = {
  _inc?: Maybe<Bookings_Inc_Input>;
  _set?: Maybe<Bookings_Set_Input>;
  where: Bookings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bookings_By_PkArgs = {
  _inc?: Maybe<Bookings_Inc_Input>;
  _set?: Maybe<Bookings_Set_Input>;
  pk_columns: Bookings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bookings_ManyArgs = {
  updates: Array<Bookings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_RoleArgs = {
  _set?: Maybe<Document_Role_Set_Input>;
  where: Document_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Role_By_PkArgs = {
  _set?: Maybe<Document_Role_Set_Input>;
  pk_columns: Document_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Role_ManyArgs = {
  updates: Array<Document_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_StatusArgs = {
  _set?: Maybe<Document_Status_Set_Input>;
  where: Document_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Status_By_PkArgs = {
  _set?: Maybe<Document_Status_Set_Input>;
  pk_columns: Document_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Status_ManyArgs = {
  updates: Array<Document_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_TypeArgs = {
  _set?: Maybe<Document_Type_Set_Input>;
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_By_PkArgs = {
  _set?: Maybe<Document_Type_Set_Input>;
  pk_columns: Document_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_ManyArgs = {
  updates: Array<Document_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentsArgs = {
  _set?: Maybe<Documents_Set_Input>;
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_By_PkArgs = {
  _set?: Maybe<Documents_Set_Input>;
  pk_columns: Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_ManyArgs = {
  updates: Array<Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_RoleArgs = {
  _set?: Maybe<Guideline_Role_Set_Input>;
  where: Guideline_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_Role_By_PkArgs = {
  _set?: Maybe<Guideline_Role_Set_Input>;
  pk_columns: Guideline_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_Role_ManyArgs = {
  updates: Array<Guideline_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_StatusArgs = {
  _set?: Maybe<Guideline_Status_Set_Input>;
  where: Guideline_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_Status_By_PkArgs = {
  _set?: Maybe<Guideline_Status_Set_Input>;
  pk_columns: Guideline_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_Status_ManyArgs = {
  updates: Array<Guideline_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_TypeArgs = {
  _set?: Maybe<Guideline_Type_Set_Input>;
  where: Guideline_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_Type_By_PkArgs = {
  _set?: Maybe<Guideline_Type_Set_Input>;
  pk_columns: Guideline_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guideline_Type_ManyArgs = {
  updates: Array<Guideline_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GuidelinesArgs = {
  _append?: Maybe<Guidelines_Append_Input>;
  _delete_at_path?: Maybe<Guidelines_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Guidelines_Delete_Elem_Input>;
  _delete_key?: Maybe<Guidelines_Delete_Key_Input>;
  _prepend?: Maybe<Guidelines_Prepend_Input>;
  _set?: Maybe<Guidelines_Set_Input>;
  where: Guidelines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guidelines_By_PkArgs = {
  _append?: Maybe<Guidelines_Append_Input>;
  _delete_at_path?: Maybe<Guidelines_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Guidelines_Delete_Elem_Input>;
  _delete_key?: Maybe<Guidelines_Delete_Key_Input>;
  _prepend?: Maybe<Guidelines_Prepend_Input>;
  _set?: Maybe<Guidelines_Set_Input>;
  pk_columns: Guidelines_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guidelines_ManyArgs = {
  updates: Array<Guidelines_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_TargetArgs = {
  _set?: Maybe<Invoice_Target_Set_Input>;
  where: Invoice_Target_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Target_By_PkArgs = {
  _set?: Maybe<Invoice_Target_Set_Input>;
  pk_columns: Invoice_Target_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Target_ManyArgs = {
  updates: Array<Invoice_Target_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Message_AttachmentsArgs = {
  _inc?: Maybe<Message_Attachments_Inc_Input>;
  _set?: Maybe<Message_Attachments_Set_Input>;
  where: Message_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Message_Attachments_By_PkArgs = {
  _inc?: Maybe<Message_Attachments_Inc_Input>;
  _set?: Maybe<Message_Attachments_Set_Input>;
  pk_columns: Message_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Message_Attachments_ManyArgs = {
  updates: Array<Message_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Message_TypeArgs = {
  _set?: Maybe<Message_Type_Set_Input>;
  where: Message_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Message_Type_By_PkArgs = {
  _set?: Maybe<Message_Type_Set_Input>;
  pk_columns: Message_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Message_Type_ManyArgs = {
  updates: Array<Message_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MessagesArgs = {
  _append?: Maybe<Messages_Append_Input>;
  _delete_at_path?: Maybe<Messages_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Messages_Delete_Elem_Input>;
  _delete_key?: Maybe<Messages_Delete_Key_Input>;
  _prepend?: Maybe<Messages_Prepend_Input>;
  _set?: Maybe<Messages_Set_Input>;
  where: Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Messages_By_PkArgs = {
  _append?: Maybe<Messages_Append_Input>;
  _delete_at_path?: Maybe<Messages_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Messages_Delete_Elem_Input>;
  _delete_key?: Maybe<Messages_Delete_Key_Input>;
  _prepend?: Maybe<Messages_Prepend_Input>;
  _set?: Maybe<Messages_Set_Input>;
  pk_columns: Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Messages_ManyArgs = {
  updates: Array<Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Push_SubscriptionsArgs = {
  _set?: Maybe<Push_Subscriptions_Set_Input>;
  where: Push_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Push_Subscriptions_By_PkArgs = {
  _set?: Maybe<Push_Subscriptions_Set_Input>;
  pk_columns: Push_Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Push_Subscriptions_ManyArgs = {
  updates: Array<Push_Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rate_TypeArgs = {
  _set?: Maybe<Rate_Type_Set_Input>;
  where: Rate_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rate_Type_By_PkArgs = {
  _set?: Maybe<Rate_Type_Set_Input>;
  pk_columns: Rate_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rate_Type_ManyArgs = {
  updates: Array<Rate_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_StatusArgs = {
  _set?: Maybe<Tenant_Status_Set_Input>;
  where: Tenant_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_Status_By_PkArgs = {
  _set?: Maybe<Tenant_Status_Set_Input>;
  pk_columns: Tenant_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_Status_ManyArgs = {
  updates: Array<Tenant_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_TypeArgs = {
  _set?: Maybe<Tenant_Type_Set_Input>;
  where: Tenant_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_Type_By_PkArgs = {
  _set?: Maybe<Tenant_Type_Set_Input>;
  pk_columns: Tenant_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_Type_ManyArgs = {
  updates: Array<Tenant_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantsArgs = {
  _inc?: Maybe<Tenants_Inc_Input>;
  _set?: Maybe<Tenants_Set_Input>;
  where: Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenants_By_PkArgs = {
  _inc?: Maybe<Tenants_Inc_Input>;
  _set?: Maybe<Tenants_Set_Input>;
  pk_columns: Tenants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenants_ManyArgs = {
  updates: Array<Tenants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_DepartmentsArgs = {
  _set?: Maybe<Thread_Departments_Set_Input>;
  where: Thread_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Departments_By_PkArgs = {
  _set?: Maybe<Thread_Departments_Set_Input>;
  pk_columns: Thread_Departments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Departments_ManyArgs = {
  updates: Array<Thread_Departments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_MembersArgs = {
  _set?: Maybe<Thread_Members_Set_Input>;
  where: Thread_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Members_By_PkArgs = {
  _set?: Maybe<Thread_Members_Set_Input>;
  pk_columns: Thread_Members_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Members_ManyArgs = {
  updates: Array<Thread_Members_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_StatusArgs = {
  _set?: Maybe<Thread_Status_Set_Input>;
  where: Thread_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Status_By_PkArgs = {
  _set?: Maybe<Thread_Status_Set_Input>;
  pk_columns: Thread_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Status_ManyArgs = {
  updates: Array<Thread_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_TypeArgs = {
  _set?: Maybe<Thread_Type_Set_Input>;
  where: Thread_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Type_By_PkArgs = {
  _set?: Maybe<Thread_Type_Set_Input>;
  pk_columns: Thread_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Type_ManyArgs = {
  updates: Array<Thread_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ThreadsArgs = {
  _set?: Maybe<Threads_Set_Input>;
  where: Threads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Threads_By_PkArgs = {
  _set?: Maybe<Threads_Set_Input>;
  pk_columns: Threads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Threads_ManyArgs = {
  updates: Array<Threads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RolesArgs = {
  _set?: Maybe<User_Roles_Set_Input>;
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_By_PkArgs = {
  _set?: Maybe<User_Roles_Set_Input>;
  pk_columns: User_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_ManyArgs = {
  updates: Array<User_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_StatusArgs = {
  _set?: Maybe<User_Status_Set_Input>;
  where: User_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Status_By_PkArgs = {
  _set?: Maybe<User_Status_Set_Input>;
  pk_columns: User_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Status_ManyArgs = {
  updates: Array<User_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_TypeArgs = {
  _set?: Maybe<User_Type_Set_Input>;
  where: User_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Type_By_PkArgs = {
  _set?: Maybe<User_Type_Set_Input>;
  pk_columns: User_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Type_ManyArgs = {
  updates: Array<User_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: Maybe<Users_Inc_Input>;
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: Maybe<Users_Inc_Input>;
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "push_subscriptions" */
export type Push_Subscriptions = {
  created_at?: Maybe<Scalars['timestamptz']>;
  device_label?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  onesignal_subscription_id: Scalars['String'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "push_subscriptions" */
export type Push_Subscriptions_Aggregate = {
  aggregate?: Maybe<Push_Subscriptions_Aggregate_Fields>;
  nodes: Array<Push_Subscriptions>;
};

/** aggregate fields of "push_subscriptions" */
export type Push_Subscriptions_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Push_Subscriptions_Max_Fields>;
  min?: Maybe<Push_Subscriptions_Min_Fields>;
};


/** aggregate fields of "push_subscriptions" */
export type Push_Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Push_Subscriptions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "push_subscriptions". All fields are combined with a logical 'AND'. */
export type Push_Subscriptions_Bool_Exp = {
  _and?: Maybe<Array<Push_Subscriptions_Bool_Exp>>;
  _not?: Maybe<Push_Subscriptions_Bool_Exp>;
  _or?: Maybe<Array<Push_Subscriptions_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  device_label?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  onesignal_subscription_id?: Maybe<String_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "push_subscriptions" */
export enum Push_Subscriptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PushSubscriptionsPkey = 'push_subscriptions_pkey',
  /** unique or primary key constraint on columns "user_id", "onesignal_subscription_id" */
  PushSubscriptionsUserIdOnesignalSubscriptionIdKey = 'push_subscriptions_user_id_onesignal_subscription_id_key'
}

/** input type for inserting data into table "push_subscriptions" */
export type Push_Subscriptions_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  device_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  onesignal_subscription_id?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Push_Subscriptions_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  device_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  onesignal_subscription_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Push_Subscriptions_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  device_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  onesignal_subscription_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "push_subscriptions" */
export type Push_Subscriptions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Push_Subscriptions>;
};

/** on_conflict condition type for table "push_subscriptions" */
export type Push_Subscriptions_On_Conflict = {
  constraint: Push_Subscriptions_Constraint;
  update_columns?: Array<Push_Subscriptions_Update_Column>;
  where?: Maybe<Push_Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "push_subscriptions". */
export type Push_Subscriptions_Order_By = {
  created_at?: Maybe<Order_By>;
  device_label?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  onesignal_subscription_id?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: push_subscriptions */
export type Push_Subscriptions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "push_subscriptions" */
export enum Push_Subscriptions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceLabel = 'device_label',
  /** column name */
  Id = 'id',
  /** column name */
  OnesignalSubscriptionId = 'onesignal_subscription_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "push_subscriptions" */
export type Push_Subscriptions_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  device_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  onesignal_subscription_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "push_subscriptions" */
export type Push_Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Push_Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Push_Subscriptions_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  device_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  onesignal_subscription_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "push_subscriptions" */
export enum Push_Subscriptions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceLabel = 'device_label',
  /** column name */
  Id = 'id',
  /** column name */
  OnesignalSubscriptionId = 'onesignal_subscription_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Push_Subscriptions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Push_Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Push_Subscriptions_Bool_Exp;
};

export type Query_Root = {
  /** fetch data from the table: "area_status" */
  area_status: Array<Area_Status>;
  /** fetch aggregated fields from the table: "area_status" */
  area_status_aggregate: Area_Status_Aggregate;
  /** fetch data from the table: "area_status" using primary key columns */
  area_status_by_pk?: Maybe<Area_Status>;
  /** fetch data from the table: "area_type" */
  area_type: Array<Area_Type>;
  /** fetch aggregated fields from the table: "area_type" */
  area_type_aggregate: Area_Type_Aggregate;
  /** fetch data from the table: "area_type" using primary key columns */
  area_type_by_pk?: Maybe<Area_Type>;
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: Areas_Aggregate;
  /** fetch data from the table: "areas" using primary key columns */
  areas_by_pk?: Maybe<Areas>;
  /** An array relationship */
  blackouts: Array<Blackouts>;
  /** An aggregate relationship */
  blackouts_aggregate: Blackouts_Aggregate;
  /** fetch data from the table: "blackouts" using primary key columns */
  blackouts_by_pk?: Maybe<Blackouts>;
  /** An array relationship */
  booking_series: Array<Booking_Series>;
  /** An aggregate relationship */
  booking_series_aggregate: Booking_Series_Aggregate;
  /** fetch data from the table: "booking_series" using primary key columns */
  booking_series_by_pk?: Maybe<Booking_Series>;
  /** fetch data from the table: "booking_status" */
  booking_status: Array<Booking_Status>;
  /** fetch aggregated fields from the table: "booking_status" */
  booking_status_aggregate: Booking_Status_Aggregate;
  /** fetch data from the table: "booking_status" using primary key columns */
  booking_status_by_pk?: Maybe<Booking_Status>;
  /** fetch data from the table: "booking_type" */
  booking_type: Array<Booking_Type>;
  /** fetch aggregated fields from the table: "booking_type" */
  booking_type_aggregate: Booking_Type_Aggregate;
  /** fetch data from the table: "booking_type" using primary key columns */
  booking_type_by_pk?: Maybe<Booking_Type>;
  /** An array relationship */
  bookings: Array<Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Bookings_Aggregate;
  /** fetch data from the table: "bookings" using primary key columns */
  bookings_by_pk?: Maybe<Bookings>;
  /** fetch data from the table: "document_role" */
  document_role: Array<Document_Role>;
  /** fetch aggregated fields from the table: "document_role" */
  document_role_aggregate: Document_Role_Aggregate;
  /** fetch data from the table: "document_role" using primary key columns */
  document_role_by_pk?: Maybe<Document_Role>;
  /** fetch data from the table: "document_status" */
  document_status: Array<Document_Status>;
  /** fetch aggregated fields from the table: "document_status" */
  document_status_aggregate: Document_Status_Aggregate;
  /** fetch data from the table: "document_status" using primary key columns */
  document_status_by_pk?: Maybe<Document_Status>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk?: Maybe<Document_Type>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** fetch data from the table: "guideline_role" */
  guideline_role: Array<Guideline_Role>;
  /** fetch aggregated fields from the table: "guideline_role" */
  guideline_role_aggregate: Guideline_Role_Aggregate;
  /** fetch data from the table: "guideline_role" using primary key columns */
  guideline_role_by_pk?: Maybe<Guideline_Role>;
  /** fetch data from the table: "guideline_status" */
  guideline_status: Array<Guideline_Status>;
  /** fetch aggregated fields from the table: "guideline_status" */
  guideline_status_aggregate: Guideline_Status_Aggregate;
  /** fetch data from the table: "guideline_status" using primary key columns */
  guideline_status_by_pk?: Maybe<Guideline_Status>;
  /** fetch data from the table: "guideline_type" */
  guideline_type: Array<Guideline_Type>;
  /** fetch aggregated fields from the table: "guideline_type" */
  guideline_type_aggregate: Guideline_Type_Aggregate;
  /** fetch data from the table: "guideline_type" using primary key columns */
  guideline_type_by_pk?: Maybe<Guideline_Type>;
  /** An array relationship */
  guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_aggregate: Guidelines_Aggregate;
  /** fetch data from the table: "guidelines" using primary key columns */
  guidelines_by_pk?: Maybe<Guidelines>;
  /** fetch data from the table: "invoice_target" */
  invoice_target: Array<Invoice_Target>;
  /** fetch aggregated fields from the table: "invoice_target" */
  invoice_target_aggregate: Invoice_Target_Aggregate;
  /** fetch data from the table: "invoice_target" using primary key columns */
  invoice_target_by_pk?: Maybe<Invoice_Target>;
  /** An array relationship */
  message_attachments: Array<Message_Attachments>;
  /** An aggregate relationship */
  message_attachments_aggregate: Message_Attachments_Aggregate;
  /** fetch data from the table: "message_attachments" using primary key columns */
  message_attachments_by_pk?: Maybe<Message_Attachments>;
  /** fetch data from the table: "message_type" */
  message_type: Array<Message_Type>;
  /** fetch aggregated fields from the table: "message_type" */
  message_type_aggregate: Message_Type_Aggregate;
  /** fetch data from the table: "message_type" using primary key columns */
  message_type_by_pk?: Maybe<Message_Type>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** fetch data from the table: "push_subscriptions" */
  push_subscriptions: Array<Push_Subscriptions>;
  /** fetch aggregated fields from the table: "push_subscriptions" */
  push_subscriptions_aggregate: Push_Subscriptions_Aggregate;
  /** fetch data from the table: "push_subscriptions" using primary key columns */
  push_subscriptions_by_pk?: Maybe<Push_Subscriptions>;
  /** fetch data from the table: "rate_type" */
  rate_type: Array<Rate_Type>;
  /** fetch aggregated fields from the table: "rate_type" */
  rate_type_aggregate: Rate_Type_Aggregate;
  /** fetch data from the table: "rate_type" using primary key columns */
  rate_type_by_pk?: Maybe<Rate_Type>;
  /** fetch data from the table: "tenant_status" */
  tenant_status: Array<Tenant_Status>;
  /** fetch aggregated fields from the table: "tenant_status" */
  tenant_status_aggregate: Tenant_Status_Aggregate;
  /** fetch data from the table: "tenant_status" using primary key columns */
  tenant_status_by_pk?: Maybe<Tenant_Status>;
  /** fetch data from the table: "tenant_type" */
  tenant_type: Array<Tenant_Type>;
  /** fetch aggregated fields from the table: "tenant_type" */
  tenant_type_aggregate: Tenant_Type_Aggregate;
  /** fetch data from the table: "tenant_type" using primary key columns */
  tenant_type_by_pk?: Maybe<Tenant_Type>;
  /** An array relationship */
  tenants: Array<Tenants>;
  /** An aggregate relationship */
  tenants_aggregate: Tenants_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenants_by_pk?: Maybe<Tenants>;
  /** An array relationship */
  thread_departments: Array<Thread_Departments>;
  /** An aggregate relationship */
  thread_departments_aggregate: Thread_Departments_Aggregate;
  /** fetch data from the table: "thread_departments" using primary key columns */
  thread_departments_by_pk?: Maybe<Thread_Departments>;
  /** An array relationship */
  thread_members: Array<Thread_Members>;
  /** An aggregate relationship */
  thread_members_aggregate: Thread_Members_Aggregate;
  /** fetch data from the table: "thread_members" using primary key columns */
  thread_members_by_pk?: Maybe<Thread_Members>;
  /** fetch data from the table: "thread_status" */
  thread_status: Array<Thread_Status>;
  /** fetch aggregated fields from the table: "thread_status" */
  thread_status_aggregate: Thread_Status_Aggregate;
  /** fetch data from the table: "thread_status" using primary key columns */
  thread_status_by_pk?: Maybe<Thread_Status>;
  /** fetch data from the table: "thread_type" */
  thread_type: Array<Thread_Type>;
  /** fetch aggregated fields from the table: "thread_type" */
  thread_type_aggregate: Thread_Type_Aggregate;
  /** fetch data from the table: "thread_type" using primary key columns */
  thread_type_by_pk?: Maybe<Thread_Type>;
  /** An array relationship */
  threads: Array<Threads>;
  /** An aggregate relationship */
  threads_aggregate: Threads_Aggregate;
  /** fetch data from the table: "threads" using primary key columns */
  threads_by_pk?: Maybe<Threads>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** fetch data from the table: "user_status" */
  user_status: Array<User_Status>;
  /** fetch aggregated fields from the table: "user_status" */
  user_status_aggregate: User_Status_Aggregate;
  /** fetch data from the table: "user_status" using primary key columns */
  user_status_by_pk?: Maybe<User_Status>;
  /** fetch data from the table: "user_type" */
  user_type: Array<User_Type>;
  /** fetch aggregated fields from the table: "user_type" */
  user_type_aggregate: User_Type_Aggregate;
  /** fetch data from the table: "user_type" using primary key columns */
  user_type_by_pk?: Maybe<User_Type>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootArea_StatusArgs = {
  distinct_on?: Maybe<Array<Area_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Area_Status_Order_By>>;
  where?: Maybe<Area_Status_Bool_Exp>;
};


export type Query_RootArea_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Area_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Area_Status_Order_By>>;
  where?: Maybe<Area_Status_Bool_Exp>;
};


export type Query_RootArea_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootArea_TypeArgs = {
  distinct_on?: Maybe<Array<Area_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Area_Type_Order_By>>;
  where?: Maybe<Area_Type_Bool_Exp>;
};


export type Query_RootArea_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Area_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Area_Type_Order_By>>;
  where?: Maybe<Area_Type_Bool_Exp>;
};


export type Query_RootArea_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootAreasArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Query_RootAreas_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Query_RootAreas_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBlackoutsArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


export type Query_RootBlackouts_AggregateArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


export type Query_RootBlackouts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBooking_SeriesArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


export type Query_RootBooking_Series_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


export type Query_RootBooking_Series_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBooking_StatusArgs = {
  distinct_on?: Maybe<Array<Booking_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Status_Order_By>>;
  where?: Maybe<Booking_Status_Bool_Exp>;
};


export type Query_RootBooking_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Status_Order_By>>;
  where?: Maybe<Booking_Status_Bool_Exp>;
};


export type Query_RootBooking_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootBooking_TypeArgs = {
  distinct_on?: Maybe<Array<Booking_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Type_Order_By>>;
  where?: Maybe<Booking_Type_Bool_Exp>;
};


export type Query_RootBooking_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Type_Order_By>>;
  where?: Maybe<Booking_Type_Bool_Exp>;
};


export type Query_RootBooking_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


export type Query_RootBookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


export type Query_RootBookings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocument_RoleArgs = {
  distinct_on?: Maybe<Array<Document_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Role_Order_By>>;
  where?: Maybe<Document_Role_Bool_Exp>;
};


export type Query_RootDocument_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Role_Order_By>>;
  where?: Maybe<Document_Role_Bool_Exp>;
};


export type Query_RootDocument_Role_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootDocument_StatusArgs = {
  distinct_on?: Maybe<Array<Document_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Status_Order_By>>;
  where?: Maybe<Document_Status_Bool_Exp>;
};


export type Query_RootDocument_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Status_Order_By>>;
  where?: Maybe<Document_Status_Bool_Exp>;
};


export type Query_RootDocument_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootDocument_TypeArgs = {
  distinct_on?: Maybe<Array<Document_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Type_Order_By>>;
  where?: Maybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Type_Order_By>>;
  where?: Maybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGuideline_RoleArgs = {
  distinct_on?: Maybe<Array<Guideline_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Role_Order_By>>;
  where?: Maybe<Guideline_Role_Bool_Exp>;
};


export type Query_RootGuideline_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Guideline_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Role_Order_By>>;
  where?: Maybe<Guideline_Role_Bool_Exp>;
};


export type Query_RootGuideline_Role_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootGuideline_StatusArgs = {
  distinct_on?: Maybe<Array<Guideline_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Status_Order_By>>;
  where?: Maybe<Guideline_Status_Bool_Exp>;
};


export type Query_RootGuideline_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Guideline_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Status_Order_By>>;
  where?: Maybe<Guideline_Status_Bool_Exp>;
};


export type Query_RootGuideline_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootGuideline_TypeArgs = {
  distinct_on?: Maybe<Array<Guideline_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Type_Order_By>>;
  where?: Maybe<Guideline_Type_Bool_Exp>;
};


export type Query_RootGuideline_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Guideline_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Type_Order_By>>;
  where?: Maybe<Guideline_Type_Bool_Exp>;
};


export type Query_RootGuideline_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootGuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


export type Query_RootGuidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


export type Query_RootGuidelines_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootInvoice_TargetArgs = {
  distinct_on?: Maybe<Array<Invoice_Target_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Target_Order_By>>;
  where?: Maybe<Invoice_Target_Bool_Exp>;
};


export type Query_RootInvoice_Target_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Target_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Target_Order_By>>;
  where?: Maybe<Invoice_Target_Bool_Exp>;
};


export type Query_RootInvoice_Target_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootMessage_AttachmentsArgs = {
  distinct_on?: Maybe<Array<Message_Attachments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Attachments_Order_By>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


export type Query_RootMessage_Attachments_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Attachments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Attachments_Order_By>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


export type Query_RootMessage_Attachments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMessage_TypeArgs = {
  distinct_on?: Maybe<Array<Message_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Type_Order_By>>;
  where?: Maybe<Message_Type_Bool_Exp>;
};


export type Query_RootMessage_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Type_Order_By>>;
  where?: Maybe<Message_Type_Bool_Exp>;
};


export type Query_RootMessage_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootMessagesArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


export type Query_RootMessages_AggregateArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


export type Query_RootMessages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPush_SubscriptionsArgs = {
  distinct_on?: Maybe<Array<Push_Subscriptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Push_Subscriptions_Order_By>>;
  where?: Maybe<Push_Subscriptions_Bool_Exp>;
};


export type Query_RootPush_Subscriptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Push_Subscriptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Push_Subscriptions_Order_By>>;
  where?: Maybe<Push_Subscriptions_Bool_Exp>;
};


export type Query_RootPush_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRate_TypeArgs = {
  distinct_on?: Maybe<Array<Rate_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rate_Type_Order_By>>;
  where?: Maybe<Rate_Type_Bool_Exp>;
};


export type Query_RootRate_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Rate_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rate_Type_Order_By>>;
  where?: Maybe<Rate_Type_Bool_Exp>;
};


export type Query_RootRate_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootTenant_StatusArgs = {
  distinct_on?: Maybe<Array<Tenant_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenant_Status_Order_By>>;
  where?: Maybe<Tenant_Status_Bool_Exp>;
};


export type Query_RootTenant_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenant_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenant_Status_Order_By>>;
  where?: Maybe<Tenant_Status_Bool_Exp>;
};


export type Query_RootTenant_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootTenant_TypeArgs = {
  distinct_on?: Maybe<Array<Tenant_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenant_Type_Order_By>>;
  where?: Maybe<Tenant_Type_Bool_Exp>;
};


export type Query_RootTenant_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenant_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenant_Type_Order_By>>;
  where?: Maybe<Tenant_Type_Bool_Exp>;
};


export type Query_RootTenant_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootTenantsArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


export type Query_RootTenants_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


export type Query_RootTenants_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootThread_DepartmentsArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


export type Query_RootThread_Departments_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


export type Query_RootThread_Departments_By_PkArgs = {
  department: User_Type_Enum;
  thread_id: Scalars['uuid'];
};


export type Query_RootThread_MembersArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


export type Query_RootThread_Members_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


export type Query_RootThread_Members_By_PkArgs = {
  thread_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Query_RootThread_StatusArgs = {
  distinct_on?: Maybe<Array<Thread_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Status_Order_By>>;
  where?: Maybe<Thread_Status_Bool_Exp>;
};


export type Query_RootThread_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Status_Order_By>>;
  where?: Maybe<Thread_Status_Bool_Exp>;
};


export type Query_RootThread_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootThread_TypeArgs = {
  distinct_on?: Maybe<Array<Thread_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Type_Order_By>>;
  where?: Maybe<Thread_Type_Bool_Exp>;
};


export type Query_RootThread_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Type_Order_By>>;
  where?: Maybe<Thread_Type_Bool_Exp>;
};


export type Query_RootThread_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootThreadsArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


export type Query_RootThreads_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


export type Query_RootThreads_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_RolesArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


export type Query_RootUser_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


export type Query_RootUser_Roles_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_StatusArgs = {
  distinct_on?: Maybe<Array<User_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Status_Order_By>>;
  where?: Maybe<User_Status_Bool_Exp>;
};


export type Query_RootUser_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Status_Order_By>>;
  where?: Maybe<User_Status_Bool_Exp>;
};


export type Query_RootUser_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_TypeArgs = {
  distinct_on?: Maybe<Array<User_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Type_Order_By>>;
  where?: Maybe<User_Type_Bool_Exp>;
};


export type Query_RootUser_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Type_Order_By>>;
  where?: Maybe<User_Type_Bool_Exp>;
};


export type Query_RootUser_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "rate_type" */
export type Rate_Type = {
  /** An array relationship */
  bookings: Array<Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Bookings_Aggregate;
  display: Scalars['String'];
  value: Scalars['String'];
};


/** columns and relationships of "rate_type" */
export type Rate_TypeBookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "rate_type" */
export type Rate_TypeBookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};

/** aggregated selection of "rate_type" */
export type Rate_Type_Aggregate = {
  aggregate?: Maybe<Rate_Type_Aggregate_Fields>;
  nodes: Array<Rate_Type>;
};

/** aggregate fields of "rate_type" */
export type Rate_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Rate_Type_Max_Fields>;
  min?: Maybe<Rate_Type_Min_Fields>;
};


/** aggregate fields of "rate_type" */
export type Rate_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Rate_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "rate_type". All fields are combined with a logical 'AND'. */
export type Rate_Type_Bool_Exp = {
  _and?: Maybe<Array<Rate_Type_Bool_Exp>>;
  _not?: Maybe<Rate_Type_Bool_Exp>;
  _or?: Maybe<Array<Rate_Type_Bool_Exp>>;
  bookings?: Maybe<Bookings_Bool_Exp>;
  bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  display?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rate_type" */
export enum Rate_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  RateTypePkey = 'rate_type_pkey'
}

export enum Rate_Type_Enum {
  /** Full */
  Full = 'full',
  /** Hourly */
  Hourly = 'hourly'
}

/** Boolean expression to compare columns of type "rate_type_enum". All fields are combined with logical 'AND'. */
export type Rate_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Rate_Type_Enum>;
  _in?: Maybe<Array<Rate_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Rate_Type_Enum>;
  _nin?: Maybe<Array<Rate_Type_Enum>>;
};

/** input type for inserting data into table "rate_type" */
export type Rate_Type_Insert_Input = {
  bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Rate_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Rate_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "rate_type" */
export type Rate_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rate_Type>;
};

/** input type for inserting object relation for remote table "rate_type" */
export type Rate_Type_Obj_Rel_Insert_Input = {
  data: Rate_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Rate_Type_On_Conflict>;
};

/** on_conflict condition type for table "rate_type" */
export type Rate_Type_On_Conflict = {
  constraint: Rate_Type_Constraint;
  update_columns?: Array<Rate_Type_Update_Column>;
  where?: Maybe<Rate_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "rate_type". */
export type Rate_Type_Order_By = {
  bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  display?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: rate_type */
export type Rate_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "rate_type" */
export enum Rate_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "rate_type" */
export type Rate_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "rate_type" */
export type Rate_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rate_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rate_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "rate_type" */
export enum Rate_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Rate_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Rate_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rate_Type_Bool_Exp;
};

export type Subscription_Root = {
  /** fetch data from the table: "area_status" */
  area_status: Array<Area_Status>;
  /** fetch aggregated fields from the table: "area_status" */
  area_status_aggregate: Area_Status_Aggregate;
  /** fetch data from the table: "area_status" using primary key columns */
  area_status_by_pk?: Maybe<Area_Status>;
  /** fetch data from the table in a streaming manner: "area_status" */
  area_status_stream: Array<Area_Status>;
  /** fetch data from the table: "area_type" */
  area_type: Array<Area_Type>;
  /** fetch aggregated fields from the table: "area_type" */
  area_type_aggregate: Area_Type_Aggregate;
  /** fetch data from the table: "area_type" using primary key columns */
  area_type_by_pk?: Maybe<Area_Type>;
  /** fetch data from the table in a streaming manner: "area_type" */
  area_type_stream: Array<Area_Type>;
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: Areas_Aggregate;
  /** fetch data from the table: "areas" using primary key columns */
  areas_by_pk?: Maybe<Areas>;
  /** fetch data from the table in a streaming manner: "areas" */
  areas_stream: Array<Areas>;
  /** An array relationship */
  blackouts: Array<Blackouts>;
  /** An aggregate relationship */
  blackouts_aggregate: Blackouts_Aggregate;
  /** fetch data from the table: "blackouts" using primary key columns */
  blackouts_by_pk?: Maybe<Blackouts>;
  /** fetch data from the table in a streaming manner: "blackouts" */
  blackouts_stream: Array<Blackouts>;
  /** An array relationship */
  booking_series: Array<Booking_Series>;
  /** An aggregate relationship */
  booking_series_aggregate: Booking_Series_Aggregate;
  /** fetch data from the table: "booking_series" using primary key columns */
  booking_series_by_pk?: Maybe<Booking_Series>;
  /** fetch data from the table in a streaming manner: "booking_series" */
  booking_series_stream: Array<Booking_Series>;
  /** fetch data from the table: "booking_status" */
  booking_status: Array<Booking_Status>;
  /** fetch aggregated fields from the table: "booking_status" */
  booking_status_aggregate: Booking_Status_Aggregate;
  /** fetch data from the table: "booking_status" using primary key columns */
  booking_status_by_pk?: Maybe<Booking_Status>;
  /** fetch data from the table in a streaming manner: "booking_status" */
  booking_status_stream: Array<Booking_Status>;
  /** fetch data from the table: "booking_type" */
  booking_type: Array<Booking_Type>;
  /** fetch aggregated fields from the table: "booking_type" */
  booking_type_aggregate: Booking_Type_Aggregate;
  /** fetch data from the table: "booking_type" using primary key columns */
  booking_type_by_pk?: Maybe<Booking_Type>;
  /** fetch data from the table in a streaming manner: "booking_type" */
  booking_type_stream: Array<Booking_Type>;
  /** An array relationship */
  bookings: Array<Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Bookings_Aggregate;
  /** fetch data from the table: "bookings" using primary key columns */
  bookings_by_pk?: Maybe<Bookings>;
  /** fetch data from the table in a streaming manner: "bookings" */
  bookings_stream: Array<Bookings>;
  /** fetch data from the table: "document_role" */
  document_role: Array<Document_Role>;
  /** fetch aggregated fields from the table: "document_role" */
  document_role_aggregate: Document_Role_Aggregate;
  /** fetch data from the table: "document_role" using primary key columns */
  document_role_by_pk?: Maybe<Document_Role>;
  /** fetch data from the table in a streaming manner: "document_role" */
  document_role_stream: Array<Document_Role>;
  /** fetch data from the table: "document_status" */
  document_status: Array<Document_Status>;
  /** fetch aggregated fields from the table: "document_status" */
  document_status_aggregate: Document_Status_Aggregate;
  /** fetch data from the table: "document_status" using primary key columns */
  document_status_by_pk?: Maybe<Document_Status>;
  /** fetch data from the table in a streaming manner: "document_status" */
  document_status_stream: Array<Document_Status>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk?: Maybe<Document_Type>;
  /** fetch data from the table in a streaming manner: "document_type" */
  document_type_stream: Array<Document_Type>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** fetch data from the table in a streaming manner: "documents" */
  documents_stream: Array<Documents>;
  /** fetch data from the table: "guideline_role" */
  guideline_role: Array<Guideline_Role>;
  /** fetch aggregated fields from the table: "guideline_role" */
  guideline_role_aggregate: Guideline_Role_Aggregate;
  /** fetch data from the table: "guideline_role" using primary key columns */
  guideline_role_by_pk?: Maybe<Guideline_Role>;
  /** fetch data from the table in a streaming manner: "guideline_role" */
  guideline_role_stream: Array<Guideline_Role>;
  /** fetch data from the table: "guideline_status" */
  guideline_status: Array<Guideline_Status>;
  /** fetch aggregated fields from the table: "guideline_status" */
  guideline_status_aggregate: Guideline_Status_Aggregate;
  /** fetch data from the table: "guideline_status" using primary key columns */
  guideline_status_by_pk?: Maybe<Guideline_Status>;
  /** fetch data from the table in a streaming manner: "guideline_status" */
  guideline_status_stream: Array<Guideline_Status>;
  /** fetch data from the table: "guideline_type" */
  guideline_type: Array<Guideline_Type>;
  /** fetch aggregated fields from the table: "guideline_type" */
  guideline_type_aggregate: Guideline_Type_Aggregate;
  /** fetch data from the table: "guideline_type" using primary key columns */
  guideline_type_by_pk?: Maybe<Guideline_Type>;
  /** fetch data from the table in a streaming manner: "guideline_type" */
  guideline_type_stream: Array<Guideline_Type>;
  /** An array relationship */
  guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_aggregate: Guidelines_Aggregate;
  /** fetch data from the table: "guidelines" using primary key columns */
  guidelines_by_pk?: Maybe<Guidelines>;
  /** fetch data from the table in a streaming manner: "guidelines" */
  guidelines_stream: Array<Guidelines>;
  /** fetch data from the table: "invoice_target" */
  invoice_target: Array<Invoice_Target>;
  /** fetch aggregated fields from the table: "invoice_target" */
  invoice_target_aggregate: Invoice_Target_Aggregate;
  /** fetch data from the table: "invoice_target" using primary key columns */
  invoice_target_by_pk?: Maybe<Invoice_Target>;
  /** fetch data from the table in a streaming manner: "invoice_target" */
  invoice_target_stream: Array<Invoice_Target>;
  /** An array relationship */
  message_attachments: Array<Message_Attachments>;
  /** An aggregate relationship */
  message_attachments_aggregate: Message_Attachments_Aggregate;
  /** fetch data from the table: "message_attachments" using primary key columns */
  message_attachments_by_pk?: Maybe<Message_Attachments>;
  /** fetch data from the table in a streaming manner: "message_attachments" */
  message_attachments_stream: Array<Message_Attachments>;
  /** fetch data from the table: "message_type" */
  message_type: Array<Message_Type>;
  /** fetch aggregated fields from the table: "message_type" */
  message_type_aggregate: Message_Type_Aggregate;
  /** fetch data from the table: "message_type" using primary key columns */
  message_type_by_pk?: Maybe<Message_Type>;
  /** fetch data from the table in a streaming manner: "message_type" */
  message_type_stream: Array<Message_Type>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** fetch data from the table in a streaming manner: "messages" */
  messages_stream: Array<Messages>;
  /** fetch data from the table: "push_subscriptions" */
  push_subscriptions: Array<Push_Subscriptions>;
  /** fetch aggregated fields from the table: "push_subscriptions" */
  push_subscriptions_aggregate: Push_Subscriptions_Aggregate;
  /** fetch data from the table: "push_subscriptions" using primary key columns */
  push_subscriptions_by_pk?: Maybe<Push_Subscriptions>;
  /** fetch data from the table in a streaming manner: "push_subscriptions" */
  push_subscriptions_stream: Array<Push_Subscriptions>;
  /** fetch data from the table: "rate_type" */
  rate_type: Array<Rate_Type>;
  /** fetch aggregated fields from the table: "rate_type" */
  rate_type_aggregate: Rate_Type_Aggregate;
  /** fetch data from the table: "rate_type" using primary key columns */
  rate_type_by_pk?: Maybe<Rate_Type>;
  /** fetch data from the table in a streaming manner: "rate_type" */
  rate_type_stream: Array<Rate_Type>;
  /** fetch data from the table: "tenant_status" */
  tenant_status: Array<Tenant_Status>;
  /** fetch aggregated fields from the table: "tenant_status" */
  tenant_status_aggregate: Tenant_Status_Aggregate;
  /** fetch data from the table: "tenant_status" using primary key columns */
  tenant_status_by_pk?: Maybe<Tenant_Status>;
  /** fetch data from the table in a streaming manner: "tenant_status" */
  tenant_status_stream: Array<Tenant_Status>;
  /** fetch data from the table: "tenant_type" */
  tenant_type: Array<Tenant_Type>;
  /** fetch aggregated fields from the table: "tenant_type" */
  tenant_type_aggregate: Tenant_Type_Aggregate;
  /** fetch data from the table: "tenant_type" using primary key columns */
  tenant_type_by_pk?: Maybe<Tenant_Type>;
  /** fetch data from the table in a streaming manner: "tenant_type" */
  tenant_type_stream: Array<Tenant_Type>;
  /** An array relationship */
  tenants: Array<Tenants>;
  /** An aggregate relationship */
  tenants_aggregate: Tenants_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenants_by_pk?: Maybe<Tenants>;
  /** fetch data from the table in a streaming manner: "tenants" */
  tenants_stream: Array<Tenants>;
  /** An array relationship */
  thread_departments: Array<Thread_Departments>;
  /** An aggregate relationship */
  thread_departments_aggregate: Thread_Departments_Aggregate;
  /** fetch data from the table: "thread_departments" using primary key columns */
  thread_departments_by_pk?: Maybe<Thread_Departments>;
  /** fetch data from the table in a streaming manner: "thread_departments" */
  thread_departments_stream: Array<Thread_Departments>;
  /** An array relationship */
  thread_members: Array<Thread_Members>;
  /** An aggregate relationship */
  thread_members_aggregate: Thread_Members_Aggregate;
  /** fetch data from the table: "thread_members" using primary key columns */
  thread_members_by_pk?: Maybe<Thread_Members>;
  /** fetch data from the table in a streaming manner: "thread_members" */
  thread_members_stream: Array<Thread_Members>;
  /** fetch data from the table: "thread_status" */
  thread_status: Array<Thread_Status>;
  /** fetch aggregated fields from the table: "thread_status" */
  thread_status_aggregate: Thread_Status_Aggregate;
  /** fetch data from the table: "thread_status" using primary key columns */
  thread_status_by_pk?: Maybe<Thread_Status>;
  /** fetch data from the table in a streaming manner: "thread_status" */
  thread_status_stream: Array<Thread_Status>;
  /** fetch data from the table: "thread_type" */
  thread_type: Array<Thread_Type>;
  /** fetch aggregated fields from the table: "thread_type" */
  thread_type_aggregate: Thread_Type_Aggregate;
  /** fetch data from the table: "thread_type" using primary key columns */
  thread_type_by_pk?: Maybe<Thread_Type>;
  /** fetch data from the table in a streaming manner: "thread_type" */
  thread_type_stream: Array<Thread_Type>;
  /** An array relationship */
  threads: Array<Threads>;
  /** An aggregate relationship */
  threads_aggregate: Threads_Aggregate;
  /** fetch data from the table: "threads" using primary key columns */
  threads_by_pk?: Maybe<Threads>;
  /** fetch data from the table in a streaming manner: "threads" */
  threads_stream: Array<Threads>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** fetch data from the table in a streaming manner: "user_roles" */
  user_roles_stream: Array<User_Roles>;
  /** fetch data from the table: "user_status" */
  user_status: Array<User_Status>;
  /** fetch aggregated fields from the table: "user_status" */
  user_status_aggregate: User_Status_Aggregate;
  /** fetch data from the table: "user_status" using primary key columns */
  user_status_by_pk?: Maybe<User_Status>;
  /** fetch data from the table in a streaming manner: "user_status" */
  user_status_stream: Array<User_Status>;
  /** fetch data from the table: "user_type" */
  user_type: Array<User_Type>;
  /** fetch aggregated fields from the table: "user_type" */
  user_type_aggregate: User_Type_Aggregate;
  /** fetch data from the table: "user_type" using primary key columns */
  user_type_by_pk?: Maybe<User_Type>;
  /** fetch data from the table in a streaming manner: "user_type" */
  user_type_stream: Array<User_Type>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootArea_StatusArgs = {
  distinct_on?: Maybe<Array<Area_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Area_Status_Order_By>>;
  where?: Maybe<Area_Status_Bool_Exp>;
};


export type Subscription_RootArea_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Area_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Area_Status_Order_By>>;
  where?: Maybe<Area_Status_Bool_Exp>;
};


export type Subscription_RootArea_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootArea_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Area_Status_Stream_Cursor_Input>>;
  where?: Maybe<Area_Status_Bool_Exp>;
};


export type Subscription_RootArea_TypeArgs = {
  distinct_on?: Maybe<Array<Area_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Area_Type_Order_By>>;
  where?: Maybe<Area_Type_Bool_Exp>;
};


export type Subscription_RootArea_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Area_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Area_Type_Order_By>>;
  where?: Maybe<Area_Type_Bool_Exp>;
};


export type Subscription_RootArea_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootArea_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Area_Type_Stream_Cursor_Input>>;
  where?: Maybe<Area_Type_Bool_Exp>;
};


export type Subscription_RootAreasArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Subscription_RootAreas_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Subscription_RootAreas_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAreas_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Areas_Stream_Cursor_Input>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Subscription_RootBlackoutsArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


export type Subscription_RootBlackouts_AggregateArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


export type Subscription_RootBlackouts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBlackouts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Blackouts_Stream_Cursor_Input>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


export type Subscription_RootBooking_SeriesArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


export type Subscription_RootBooking_Series_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


export type Subscription_RootBooking_Series_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBooking_Series_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Booking_Series_Stream_Cursor_Input>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


export type Subscription_RootBooking_StatusArgs = {
  distinct_on?: Maybe<Array<Booking_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Status_Order_By>>;
  where?: Maybe<Booking_Status_Bool_Exp>;
};


export type Subscription_RootBooking_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Status_Order_By>>;
  where?: Maybe<Booking_Status_Bool_Exp>;
};


export type Subscription_RootBooking_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBooking_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Booking_Status_Stream_Cursor_Input>>;
  where?: Maybe<Booking_Status_Bool_Exp>;
};


export type Subscription_RootBooking_TypeArgs = {
  distinct_on?: Maybe<Array<Booking_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Type_Order_By>>;
  where?: Maybe<Booking_Type_Bool_Exp>;
};


export type Subscription_RootBooking_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Type_Order_By>>;
  where?: Maybe<Booking_Type_Bool_Exp>;
};


export type Subscription_RootBooking_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBooking_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Booking_Type_Stream_Cursor_Input>>;
  where?: Maybe<Booking_Type_Bool_Exp>;
};


export type Subscription_RootBookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


export type Subscription_RootBookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


export type Subscription_RootBookings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBookings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Bookings_Stream_Cursor_Input>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


export type Subscription_RootDocument_RoleArgs = {
  distinct_on?: Maybe<Array<Document_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Role_Order_By>>;
  where?: Maybe<Document_Role_Bool_Exp>;
};


export type Subscription_RootDocument_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Role_Order_By>>;
  where?: Maybe<Document_Role_Bool_Exp>;
};


export type Subscription_RootDocument_Role_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootDocument_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Role_Stream_Cursor_Input>>;
  where?: Maybe<Document_Role_Bool_Exp>;
};


export type Subscription_RootDocument_StatusArgs = {
  distinct_on?: Maybe<Array<Document_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Status_Order_By>>;
  where?: Maybe<Document_Status_Bool_Exp>;
};


export type Subscription_RootDocument_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Status_Order_By>>;
  where?: Maybe<Document_Status_Bool_Exp>;
};


export type Subscription_RootDocument_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootDocument_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Status_Stream_Cursor_Input>>;
  where?: Maybe<Document_Status_Bool_Exp>;
};


export type Subscription_RootDocument_TypeArgs = {
  distinct_on?: Maybe<Array<Document_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Type_Order_By>>;
  where?: Maybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Type_Order_By>>;
  where?: Maybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootDocument_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Type_Stream_Cursor_Input>>;
  where?: Maybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocuments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Documents_Stream_Cursor_Input>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Subscription_RootGuideline_RoleArgs = {
  distinct_on?: Maybe<Array<Guideline_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Role_Order_By>>;
  where?: Maybe<Guideline_Role_Bool_Exp>;
};


export type Subscription_RootGuideline_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Guideline_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Role_Order_By>>;
  where?: Maybe<Guideline_Role_Bool_Exp>;
};


export type Subscription_RootGuideline_Role_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGuideline_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Guideline_Role_Stream_Cursor_Input>>;
  where?: Maybe<Guideline_Role_Bool_Exp>;
};


export type Subscription_RootGuideline_StatusArgs = {
  distinct_on?: Maybe<Array<Guideline_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Status_Order_By>>;
  where?: Maybe<Guideline_Status_Bool_Exp>;
};


export type Subscription_RootGuideline_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Guideline_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Status_Order_By>>;
  where?: Maybe<Guideline_Status_Bool_Exp>;
};


export type Subscription_RootGuideline_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGuideline_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Guideline_Status_Stream_Cursor_Input>>;
  where?: Maybe<Guideline_Status_Bool_Exp>;
};


export type Subscription_RootGuideline_TypeArgs = {
  distinct_on?: Maybe<Array<Guideline_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Type_Order_By>>;
  where?: Maybe<Guideline_Type_Bool_Exp>;
};


export type Subscription_RootGuideline_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Guideline_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guideline_Type_Order_By>>;
  where?: Maybe<Guideline_Type_Bool_Exp>;
};


export type Subscription_RootGuideline_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGuideline_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Guideline_Type_Stream_Cursor_Input>>;
  where?: Maybe<Guideline_Type_Bool_Exp>;
};


export type Subscription_RootGuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


export type Subscription_RootGuidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


export type Subscription_RootGuidelines_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGuidelines_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Guidelines_Stream_Cursor_Input>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


export type Subscription_RootInvoice_TargetArgs = {
  distinct_on?: Maybe<Array<Invoice_Target_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Target_Order_By>>;
  where?: Maybe<Invoice_Target_Bool_Exp>;
};


export type Subscription_RootInvoice_Target_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Target_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Target_Order_By>>;
  where?: Maybe<Invoice_Target_Bool_Exp>;
};


export type Subscription_RootInvoice_Target_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootInvoice_Target_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Invoice_Target_Stream_Cursor_Input>>;
  where?: Maybe<Invoice_Target_Bool_Exp>;
};


export type Subscription_RootMessage_AttachmentsArgs = {
  distinct_on?: Maybe<Array<Message_Attachments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Attachments_Order_By>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


export type Subscription_RootMessage_Attachments_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Attachments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Attachments_Order_By>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


export type Subscription_RootMessage_Attachments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMessage_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Message_Attachments_Stream_Cursor_Input>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


export type Subscription_RootMessage_TypeArgs = {
  distinct_on?: Maybe<Array<Message_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Type_Order_By>>;
  where?: Maybe<Message_Type_Bool_Exp>;
};


export type Subscription_RootMessage_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Type_Order_By>>;
  where?: Maybe<Message_Type_Bool_Exp>;
};


export type Subscription_RootMessage_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootMessage_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Message_Type_Stream_Cursor_Input>>;
  where?: Maybe<Message_Type_Bool_Exp>;
};


export type Subscription_RootMessagesArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


export type Subscription_RootMessages_AggregateArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


export type Subscription_RootMessages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMessages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Messages_Stream_Cursor_Input>>;
  where?: Maybe<Messages_Bool_Exp>;
};


export type Subscription_RootPush_SubscriptionsArgs = {
  distinct_on?: Maybe<Array<Push_Subscriptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Push_Subscriptions_Order_By>>;
  where?: Maybe<Push_Subscriptions_Bool_Exp>;
};


export type Subscription_RootPush_Subscriptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Push_Subscriptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Push_Subscriptions_Order_By>>;
  where?: Maybe<Push_Subscriptions_Bool_Exp>;
};


export type Subscription_RootPush_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPush_Subscriptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Push_Subscriptions_Stream_Cursor_Input>>;
  where?: Maybe<Push_Subscriptions_Bool_Exp>;
};


export type Subscription_RootRate_TypeArgs = {
  distinct_on?: Maybe<Array<Rate_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rate_Type_Order_By>>;
  where?: Maybe<Rate_Type_Bool_Exp>;
};


export type Subscription_RootRate_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Rate_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rate_Type_Order_By>>;
  where?: Maybe<Rate_Type_Bool_Exp>;
};


export type Subscription_RootRate_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootRate_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Rate_Type_Stream_Cursor_Input>>;
  where?: Maybe<Rate_Type_Bool_Exp>;
};


export type Subscription_RootTenant_StatusArgs = {
  distinct_on?: Maybe<Array<Tenant_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenant_Status_Order_By>>;
  where?: Maybe<Tenant_Status_Bool_Exp>;
};


export type Subscription_RootTenant_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenant_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenant_Status_Order_By>>;
  where?: Maybe<Tenant_Status_Bool_Exp>;
};


export type Subscription_RootTenant_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootTenant_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tenant_Status_Stream_Cursor_Input>>;
  where?: Maybe<Tenant_Status_Bool_Exp>;
};


export type Subscription_RootTenant_TypeArgs = {
  distinct_on?: Maybe<Array<Tenant_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenant_Type_Order_By>>;
  where?: Maybe<Tenant_Type_Bool_Exp>;
};


export type Subscription_RootTenant_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenant_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenant_Type_Order_By>>;
  where?: Maybe<Tenant_Type_Bool_Exp>;
};


export type Subscription_RootTenant_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootTenant_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tenant_Type_Stream_Cursor_Input>>;
  where?: Maybe<Tenant_Type_Bool_Exp>;
};


export type Subscription_RootTenantsArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenants_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenants_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTenants_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tenants_Stream_Cursor_Input>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


export type Subscription_RootThread_DepartmentsArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


export type Subscription_RootThread_Departments_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


export type Subscription_RootThread_Departments_By_PkArgs = {
  department: User_Type_Enum;
  thread_id: Scalars['uuid'];
};


export type Subscription_RootThread_Departments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Thread_Departments_Stream_Cursor_Input>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


export type Subscription_RootThread_MembersArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


export type Subscription_RootThread_Members_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


export type Subscription_RootThread_Members_By_PkArgs = {
  thread_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Subscription_RootThread_Members_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Thread_Members_Stream_Cursor_Input>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


export type Subscription_RootThread_StatusArgs = {
  distinct_on?: Maybe<Array<Thread_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Status_Order_By>>;
  where?: Maybe<Thread_Status_Bool_Exp>;
};


export type Subscription_RootThread_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Status_Order_By>>;
  where?: Maybe<Thread_Status_Bool_Exp>;
};


export type Subscription_RootThread_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootThread_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Thread_Status_Stream_Cursor_Input>>;
  where?: Maybe<Thread_Status_Bool_Exp>;
};


export type Subscription_RootThread_TypeArgs = {
  distinct_on?: Maybe<Array<Thread_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Type_Order_By>>;
  where?: Maybe<Thread_Type_Bool_Exp>;
};


export type Subscription_RootThread_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Type_Order_By>>;
  where?: Maybe<Thread_Type_Bool_Exp>;
};


export type Subscription_RootThread_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootThread_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Thread_Type_Stream_Cursor_Input>>;
  where?: Maybe<Thread_Type_Bool_Exp>;
};


export type Subscription_RootThreadsArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


export type Subscription_RootThreads_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


export type Subscription_RootThreads_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootThreads_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Threads_Stream_Cursor_Input>>;
  where?: Maybe<Threads_Bool_Exp>;
};


export type Subscription_RootUser_RolesArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Roles_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Roles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Roles_Stream_Cursor_Input>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_StatusArgs = {
  distinct_on?: Maybe<Array<User_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Status_Order_By>>;
  where?: Maybe<User_Status_Bool_Exp>;
};


export type Subscription_RootUser_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Status_Order_By>>;
  where?: Maybe<User_Status_Bool_Exp>;
};


export type Subscription_RootUser_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Status_Stream_Cursor_Input>>;
  where?: Maybe<User_Status_Bool_Exp>;
};


export type Subscription_RootUser_TypeArgs = {
  distinct_on?: Maybe<Array<User_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Type_Order_By>>;
  where?: Maybe<User_Type_Bool_Exp>;
};


export type Subscription_RootUser_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Type_Order_By>>;
  where?: Maybe<User_Type_Bool_Exp>;
};


export type Subscription_RootUser_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Type_Stream_Cursor_Input>>;
  where?: Maybe<User_Type_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Users_Stream_Cursor_Input>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** columns and relationships of "tenant_status" */
export type Tenant_Status = {
  display: Scalars['String'];
  /** An array relationship */
  tenants: Array<Tenants>;
  /** An aggregate relationship */
  tenants_aggregate: Tenants_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "tenant_status" */
export type Tenant_StatusTenantsArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** columns and relationships of "tenant_status" */
export type Tenant_StatusTenants_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};

/** aggregated selection of "tenant_status" */
export type Tenant_Status_Aggregate = {
  aggregate?: Maybe<Tenant_Status_Aggregate_Fields>;
  nodes: Array<Tenant_Status>;
};

/** aggregate fields of "tenant_status" */
export type Tenant_Status_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Tenant_Status_Max_Fields>;
  min?: Maybe<Tenant_Status_Min_Fields>;
};


/** aggregate fields of "tenant_status" */
export type Tenant_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tenant_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "tenant_status". All fields are combined with a logical 'AND'. */
export type Tenant_Status_Bool_Exp = {
  _and?: Maybe<Array<Tenant_Status_Bool_Exp>>;
  _not?: Maybe<Tenant_Status_Bool_Exp>;
  _or?: Maybe<Array<Tenant_Status_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  tenants?: Maybe<Tenants_Bool_Exp>;
  tenants_aggregate?: Maybe<Tenants_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_status" */
export enum Tenant_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  TenantStatusPkey = 'tenant_status_pkey'
}

export enum Tenant_Status_Enum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "tenant_status_enum". All fields are combined with logical 'AND'. */
export type Tenant_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Tenant_Status_Enum>;
  _in?: Maybe<Array<Tenant_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Tenant_Status_Enum>;
  _nin?: Maybe<Array<Tenant_Status_Enum>>;
};

/** input type for inserting data into table "tenant_status" */
export type Tenant_Status_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  tenants?: Maybe<Tenants_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tenant_Status_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tenant_Status_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tenant_status" */
export type Tenant_Status_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenant_Status>;
};

/** input type for inserting object relation for remote table "tenant_status" */
export type Tenant_Status_Obj_Rel_Insert_Input = {
  data: Tenant_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Tenant_Status_On_Conflict>;
};

/** on_conflict condition type for table "tenant_status" */
export type Tenant_Status_On_Conflict = {
  constraint: Tenant_Status_Constraint;
  update_columns?: Array<Tenant_Status_Update_Column>;
  where?: Maybe<Tenant_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_status". */
export type Tenant_Status_Order_By = {
  display?: Maybe<Order_By>;
  tenants_aggregate?: Maybe<Tenants_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: tenant_status */
export type Tenant_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "tenant_status" */
export enum Tenant_Status_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tenant_status" */
export type Tenant_Status_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "tenant_status" */
export type Tenant_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenant_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenant_Status_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "tenant_status" */
export enum Tenant_Status_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Tenant_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tenant_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenant_Status_Bool_Exp;
};

/** columns and relationships of "tenant_type" */
export type Tenant_Type = {
  display: Scalars['String'];
  /** An array relationship */
  tenants: Array<Tenants>;
  /** An aggregate relationship */
  tenants_aggregate: Tenants_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "tenant_type" */
export type Tenant_TypeTenantsArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** columns and relationships of "tenant_type" */
export type Tenant_TypeTenants_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};

/** aggregated selection of "tenant_type" */
export type Tenant_Type_Aggregate = {
  aggregate?: Maybe<Tenant_Type_Aggregate_Fields>;
  nodes: Array<Tenant_Type>;
};

/** aggregate fields of "tenant_type" */
export type Tenant_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Tenant_Type_Max_Fields>;
  min?: Maybe<Tenant_Type_Min_Fields>;
};


/** aggregate fields of "tenant_type" */
export type Tenant_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tenant_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "tenant_type". All fields are combined with a logical 'AND'. */
export type Tenant_Type_Bool_Exp = {
  _and?: Maybe<Array<Tenant_Type_Bool_Exp>>;
  _not?: Maybe<Tenant_Type_Bool_Exp>;
  _or?: Maybe<Array<Tenant_Type_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  tenants?: Maybe<Tenants_Bool_Exp>;
  tenants_aggregate?: Maybe<Tenants_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_type" */
export enum Tenant_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  TenantTypePkey = 'tenant_type_pkey'
}

export enum Tenant_Type_Enum {
  /** Agency */
  Agency = 'agency',
  /** Bar */
  Bar = 'bar',
  /** Business */
  Business = 'business',
  /** Club */
  Club = 'club',
  /** Event Space */
  EventSpace = 'event_space',
  /** Hospitality Group */
  HospitalityGroup = 'hospitality_group',
  /** Hotel */
  Hotel = 'hotel',
  /** Restaurant */
  Restaurant = 'restaurant'
}

/** Boolean expression to compare columns of type "tenant_type_enum". All fields are combined with logical 'AND'. */
export type Tenant_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Tenant_Type_Enum>;
  _in?: Maybe<Array<Tenant_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Tenant_Type_Enum>;
  _nin?: Maybe<Array<Tenant_Type_Enum>>;
};

/** input type for inserting data into table "tenant_type" */
export type Tenant_Type_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  tenants?: Maybe<Tenants_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tenant_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tenant_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tenant_type" */
export type Tenant_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenant_Type>;
};

/** input type for inserting object relation for remote table "tenant_type" */
export type Tenant_Type_Obj_Rel_Insert_Input = {
  data: Tenant_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Tenant_Type_On_Conflict>;
};

/** on_conflict condition type for table "tenant_type" */
export type Tenant_Type_On_Conflict = {
  constraint: Tenant_Type_Constraint;
  update_columns?: Array<Tenant_Type_Update_Column>;
  where?: Maybe<Tenant_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_type". */
export type Tenant_Type_Order_By = {
  display?: Maybe<Order_By>;
  tenants_aggregate?: Maybe<Tenants_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: tenant_type */
export type Tenant_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "tenant_type" */
export enum Tenant_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tenant_type" */
export type Tenant_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "tenant_type" */
export type Tenant_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenant_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenant_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "tenant_type" */
export enum Tenant_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Tenant_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tenant_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenant_Type_Bool_Exp;
};

/** columns and relationships of "tenants" */
export type Tenants = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  /** An object relationship */
  agency?: Maybe<Tenants>;
  anniversary?: Maybe<Scalars['date']>;
  /** An array relationship */
  blackouts: Array<Blackouts>;
  /** An aggregate relationship */
  blackouts_aggregate: Blackouts_Aggregate;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  /** An array relationship */
  message_attachments: Array<Message_Attachments>;
  /** An aggregate relationship */
  message_attachments_aggregate: Message_Attachments_Aggregate;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  name: Scalars['String'];
  parent_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status: Tenant_Status_Enum;
  /** An array relationship */
  tenant_areas: Array<Areas>;
  /** An aggregate relationship */
  tenant_areas_aggregate: Areas_Aggregate;
  /** An array relationship */
  tenant_bookings: Array<Bookings>;
  /** An aggregate relationship */
  tenant_bookings_aggregate: Bookings_Aggregate;
  /** An array relationship */
  tenant_documents: Array<Documents>;
  /** An aggregate relationship */
  tenant_documents_aggregate: Documents_Aggregate;
  /** An array relationship */
  tenant_guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  tenant_guidelines_aggregate: Guidelines_Aggregate;
  tenant_number?: Maybe<Scalars['Int']>;
  /** An object relationship */
  tenant_status: Tenant_Status;
  /** An array relationship */
  tenant_threads: Array<Threads>;
  /** An aggregate relationship */
  tenant_threads_aggregate: Threads_Aggregate;
  /** An object relationship */
  tenant_type: Tenant_Type;
  /** An array relationship */
  thread_departments: Array<Thread_Departments>;
  /** An aggregate relationship */
  thread_departments_aggregate: Thread_Departments_Aggregate;
  /** An array relationship */
  thread_members: Array<Thread_Members>;
  /** An aggregate relationship */
  thread_members_aggregate: Thread_Members_Aggregate;
  timezone?: Maybe<Scalars['String']>;
  type: Tenant_Type_Enum;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** An array relationship */
  venue_areas: Array<Areas>;
  /** An aggregate relationship */
  venue_areas_aggregate: Areas_Aggregate;
  /** An array relationship */
  venue_bookings: Array<Bookings>;
  /** An aggregate relationship */
  venue_bookings_aggregate: Bookings_Aggregate;
  /** An array relationship */
  venue_documents: Array<Documents>;
  /** An aggregate relationship */
  venue_documents_aggregate: Documents_Aggregate;
  /** An array relationship */
  venue_guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  venue_guidelines_aggregate: Guidelines_Aggregate;
  /** An array relationship */
  venue_threads: Array<Threads>;
  /** An aggregate relationship */
  venue_threads_aggregate: Threads_Aggregate;
  /** An array relationship */
  venues: Array<Tenants>;
  /** An aggregate relationship */
  venues_aggregate: Tenants_Aggregate;
  website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "tenants" */
export type TenantsBlackoutsArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsBlackouts_AggregateArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsMessage_AttachmentsArgs = {
  distinct_on?: Maybe<Array<Message_Attachments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Attachments_Order_By>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsMessage_Attachments_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Attachments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Attachments_Order_By>>;
  where?: Maybe<Message_Attachments_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsMessagesArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsMessages_AggregateArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_AreasArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_Areas_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_BookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_Bookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_DocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_GuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_Guidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_ThreadsArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenant_Threads_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsThread_DepartmentsArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsThread_Departments_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsThread_MembersArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsThread_Members_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_AreasArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_Areas_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_BookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_Bookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_DocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_GuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_Guidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_ThreadsArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenue_Threads_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenuesArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsVenues_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};

/** aggregated selection of "tenants" */
export type Tenants_Aggregate = {
  aggregate?: Maybe<Tenants_Aggregate_Fields>;
  nodes: Array<Tenants>;
};

export type Tenants_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Tenants_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Tenants_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Tenants_Aggregate_Bool_Exp_Count>;
};

export type Tenants_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tenants_Select_Column_Tenants_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tenants_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenants_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tenants_Select_Column_Tenants_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tenants_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tenants_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tenants_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tenants_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenants" */
export type Tenants_Aggregate_Fields = {
  avg?: Maybe<Tenants_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tenants_Max_Fields>;
  min?: Maybe<Tenants_Min_Fields>;
  stddev?: Maybe<Tenants_Stddev_Fields>;
  stddev_pop?: Maybe<Tenants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenants_Stddev_Samp_Fields>;
  sum?: Maybe<Tenants_Sum_Fields>;
  var_pop?: Maybe<Tenants_Var_Pop_Fields>;
  var_samp?: Maybe<Tenants_Var_Samp_Fields>;
  variance?: Maybe<Tenants_Variance_Fields>;
};


/** aggregate fields of "tenants" */
export type Tenants_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tenants_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tenants" */
export type Tenants_Aggregate_Order_By = {
  avg?: Maybe<Tenants_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Tenants_Max_Order_By>;
  min?: Maybe<Tenants_Min_Order_By>;
  stddev?: Maybe<Tenants_Stddev_Order_By>;
  stddev_pop?: Maybe<Tenants_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Tenants_Stddev_Samp_Order_By>;
  sum?: Maybe<Tenants_Sum_Order_By>;
  var_pop?: Maybe<Tenants_Var_Pop_Order_By>;
  var_samp?: Maybe<Tenants_Var_Samp_Order_By>;
  variance?: Maybe<Tenants_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tenants" */
export type Tenants_Arr_Rel_Insert_Input = {
  data: Array<Tenants_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tenants_On_Conflict>;
};

/** aggregate avg on columns */
export type Tenants_Avg_Fields = {
  tenant_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tenants" */
export type Tenants_Avg_Order_By = {
  tenant_number?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type Tenants_Bool_Exp = {
  _and?: Maybe<Array<Tenants_Bool_Exp>>;
  _not?: Maybe<Tenants_Bool_Exp>;
  _or?: Maybe<Array<Tenants_Bool_Exp>>;
  address_line1?: Maybe<String_Comparison_Exp>;
  address_line2?: Maybe<String_Comparison_Exp>;
  agency?: Maybe<Tenants_Bool_Exp>;
  anniversary?: Maybe<Date_Comparison_Exp>;
  blackouts?: Maybe<Blackouts_Bool_Exp>;
  blackouts_aggregate?: Maybe<Blackouts_Aggregate_Bool_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  instagram?: Maybe<String_Comparison_Exp>;
  logo?: Maybe<String_Comparison_Exp>;
  message_attachments?: Maybe<Message_Attachments_Bool_Exp>;
  message_attachments_aggregate?: Maybe<Message_Attachments_Aggregate_Bool_Exp>;
  messages?: Maybe<Messages_Bool_Exp>;
  messages_aggregate?: Maybe<Messages_Aggregate_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  parent_id?: Maybe<Uuid_Comparison_Exp>;
  phone?: Maybe<String_Comparison_Exp>;
  poc?: Maybe<String_Comparison_Exp>;
  postal_code?: Maybe<String_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  status?: Maybe<Tenant_Status_Enum_Comparison_Exp>;
  tenant_areas?: Maybe<Areas_Bool_Exp>;
  tenant_areas_aggregate?: Maybe<Areas_Aggregate_Bool_Exp>;
  tenant_bookings?: Maybe<Bookings_Bool_Exp>;
  tenant_bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  tenant_documents?: Maybe<Documents_Bool_Exp>;
  tenant_documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  tenant_guidelines?: Maybe<Guidelines_Bool_Exp>;
  tenant_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  tenant_number?: Maybe<Int_Comparison_Exp>;
  tenant_status?: Maybe<Tenant_Status_Bool_Exp>;
  tenant_threads?: Maybe<Threads_Bool_Exp>;
  tenant_threads_aggregate?: Maybe<Threads_Aggregate_Bool_Exp>;
  tenant_type?: Maybe<Tenant_Type_Bool_Exp>;
  thread_departments?: Maybe<Thread_Departments_Bool_Exp>;
  thread_departments_aggregate?: Maybe<Thread_Departments_Aggregate_Bool_Exp>;
  thread_members?: Maybe<Thread_Members_Bool_Exp>;
  thread_members_aggregate?: Maybe<Thread_Members_Aggregate_Bool_Exp>;
  timezone?: Maybe<String_Comparison_Exp>;
  type?: Maybe<Tenant_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
  users?: Maybe<Users_Bool_Exp>;
  users_aggregate?: Maybe<Users_Aggregate_Bool_Exp>;
  venue_areas?: Maybe<Areas_Bool_Exp>;
  venue_areas_aggregate?: Maybe<Areas_Aggregate_Bool_Exp>;
  venue_bookings?: Maybe<Bookings_Bool_Exp>;
  venue_bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  venue_documents?: Maybe<Documents_Bool_Exp>;
  venue_documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  venue_guidelines?: Maybe<Guidelines_Bool_Exp>;
  venue_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  venue_threads?: Maybe<Threads_Bool_Exp>;
  venue_threads_aggregate?: Maybe<Threads_Aggregate_Bool_Exp>;
  venues?: Maybe<Tenants_Bool_Exp>;
  venues_aggregate?: Maybe<Tenants_Aggregate_Bool_Exp>;
  website?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenants" */
export enum Tenants_Constraint {
  /** unique or primary key constraint on columns "id" */
  TenantsPkey = 'tenants_pkey'
}

/** input type for incrementing numeric columns in table "tenants" */
export type Tenants_Inc_Input = {
  tenant_number?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "tenants" */
export type Tenants_Insert_Input = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  agency?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  anniversary?: Maybe<Scalars['date']>;
  blackouts?: Maybe<Blackouts_Arr_Rel_Insert_Input>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  message_attachments?: Maybe<Message_Attachments_Arr_Rel_Insert_Input>;
  messages?: Maybe<Messages_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Tenant_Status_Enum>;
  tenant_areas?: Maybe<Areas_Arr_Rel_Insert_Input>;
  tenant_bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  tenant_documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  tenant_guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  tenant_number?: Maybe<Scalars['Int']>;
  tenant_status?: Maybe<Tenant_Status_Obj_Rel_Insert_Input>;
  tenant_threads?: Maybe<Threads_Arr_Rel_Insert_Input>;
  tenant_type?: Maybe<Tenant_Type_Obj_Rel_Insert_Input>;
  thread_departments?: Maybe<Thread_Departments_Arr_Rel_Insert_Input>;
  thread_members?: Maybe<Thread_Members_Arr_Rel_Insert_Input>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Tenant_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
  venue_areas?: Maybe<Areas_Arr_Rel_Insert_Input>;
  venue_bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  venue_documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  venue_guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  venue_threads?: Maybe<Threads_Arr_Rel_Insert_Input>;
  venues?: Maybe<Tenants_Arr_Rel_Insert_Input>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tenants_Max_Fields = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  anniversary?: Maybe<Scalars['date']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenant_number?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "tenants" */
export type Tenants_Max_Order_By = {
  address_line1?: Maybe<Order_By>;
  address_line2?: Maybe<Order_By>;
  anniversary?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  logo?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  tenant_number?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tenants_Min_Fields = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  anniversary?: Maybe<Scalars['date']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenant_number?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "tenants" */
export type Tenants_Min_Order_By = {
  address_line1?: Maybe<Order_By>;
  address_line2?: Maybe<Order_By>;
  anniversary?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  logo?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  tenant_number?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** response of any mutation on the table "tenants" */
export type Tenants_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenants>;
};

/** input type for inserting object relation for remote table "tenants" */
export type Tenants_Obj_Rel_Insert_Input = {
  data: Tenants_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Tenants_On_Conflict>;
};

/** on_conflict condition type for table "tenants" */
export type Tenants_On_Conflict = {
  constraint: Tenants_Constraint;
  update_columns?: Array<Tenants_Update_Column>;
  where?: Maybe<Tenants_Bool_Exp>;
};

/** Ordering options when selecting data from "tenants". */
export type Tenants_Order_By = {
  address_line1?: Maybe<Order_By>;
  address_line2?: Maybe<Order_By>;
  agency?: Maybe<Tenants_Order_By>;
  anniversary?: Maybe<Order_By>;
  blackouts_aggregate?: Maybe<Blackouts_Aggregate_Order_By>;
  city?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  deleted?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  logo?: Maybe<Order_By>;
  message_attachments_aggregate?: Maybe<Message_Attachments_Aggregate_Order_By>;
  messages_aggregate?: Maybe<Messages_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  poc?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tenant_areas_aggregate?: Maybe<Areas_Aggregate_Order_By>;
  tenant_bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  tenant_documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  tenant_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  tenant_number?: Maybe<Order_By>;
  tenant_status?: Maybe<Tenant_Status_Order_By>;
  tenant_threads_aggregate?: Maybe<Threads_Aggregate_Order_By>;
  tenant_type?: Maybe<Tenant_Type_Order_By>;
  thread_departments_aggregate?: Maybe<Thread_Departments_Aggregate_Order_By>;
  thread_members_aggregate?: Maybe<Thread_Members_Aggregate_Order_By>;
  timezone?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
  venue_areas_aggregate?: Maybe<Areas_Aggregate_Order_By>;
  venue_bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  venue_documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  venue_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  venue_threads_aggregate?: Maybe<Threads_Aggregate_Order_By>;
  venues_aggregate?: Maybe<Tenants_Aggregate_Order_By>;
  website?: Maybe<Order_By>;
};

/** primary key columns input for table: tenants */
export type Tenants_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tenants" */
export enum Tenants_Select_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  Anniversary = 'anniversary',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Poc = 'poc',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  TenantNumber = 'tenant_number',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Website = 'website'
}

/** select "tenants_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenants" */
export enum Tenants_Select_Column_Tenants_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "tenants_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenants" */
export enum Tenants_Select_Column_Tenants_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "tenants" */
export type Tenants_Set_Input = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  anniversary?: Maybe<Scalars['date']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Tenant_Status_Enum>;
  tenant_number?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Tenant_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tenants_Stddev_Fields = {
  tenant_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tenants" */
export type Tenants_Stddev_Order_By = {
  tenant_number?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tenants_Stddev_Pop_Fields = {
  tenant_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tenants" */
export type Tenants_Stddev_Pop_Order_By = {
  tenant_number?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tenants_Stddev_Samp_Fields = {
  tenant_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tenants" */
export type Tenants_Stddev_Samp_Order_By = {
  tenant_number?: Maybe<Order_By>;
};

/** Streaming cursor of the table "tenants" */
export type Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenants_Stream_Cursor_Value_Input = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  anniversary?: Maybe<Scalars['date']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Tenant_Status_Enum>;
  tenant_number?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Tenant_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tenants_Sum_Fields = {
  tenant_number?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "tenants" */
export type Tenants_Sum_Order_By = {
  tenant_number?: Maybe<Order_By>;
};

/** update columns of table "tenants" */
export enum Tenants_Update_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  Anniversary = 'anniversary',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Poc = 'poc',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  TenantNumber = 'tenant_number',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Website = 'website'
}

export type Tenants_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Tenants_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tenants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenants_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenants_Var_Pop_Fields = {
  tenant_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tenants" */
export type Tenants_Var_Pop_Order_By = {
  tenant_number?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tenants_Var_Samp_Fields = {
  tenant_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tenants" */
export type Tenants_Var_Samp_Order_By = {
  tenant_number?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Tenants_Variance_Fields = {
  tenant_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tenants" */
export type Tenants_Variance_Order_By = {
  tenant_number?: Maybe<Order_By>;
};

/** columns and relationships of "thread_departments" */
export type Thread_Departments = {
  department: User_Type_Enum;
  /** An object relationship */
  department_type: User_Type;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  thread: Threads;
  thread_id: Scalars['uuid'];
};

/** aggregated selection of "thread_departments" */
export type Thread_Departments_Aggregate = {
  aggregate?: Maybe<Thread_Departments_Aggregate_Fields>;
  nodes: Array<Thread_Departments>;
};

export type Thread_Departments_Aggregate_Bool_Exp = {
  count?: Maybe<Thread_Departments_Aggregate_Bool_Exp_Count>;
};

export type Thread_Departments_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Thread_Departments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Thread_Departments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "thread_departments" */
export type Thread_Departments_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Thread_Departments_Max_Fields>;
  min?: Maybe<Thread_Departments_Min_Fields>;
};


/** aggregate fields of "thread_departments" */
export type Thread_Departments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Thread_Departments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "thread_departments" */
export type Thread_Departments_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Thread_Departments_Max_Order_By>;
  min?: Maybe<Thread_Departments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "thread_departments" */
export type Thread_Departments_Arr_Rel_Insert_Input = {
  data: Array<Thread_Departments_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Thread_Departments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "thread_departments". All fields are combined with a logical 'AND'. */
export type Thread_Departments_Bool_Exp = {
  _and?: Maybe<Array<Thread_Departments_Bool_Exp>>;
  _not?: Maybe<Thread_Departments_Bool_Exp>;
  _or?: Maybe<Array<Thread_Departments_Bool_Exp>>;
  department?: Maybe<User_Type_Enum_Comparison_Exp>;
  department_type?: Maybe<User_Type_Bool_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  thread?: Maybe<Threads_Bool_Exp>;
  thread_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "thread_departments" */
export enum Thread_Departments_Constraint {
  /** unique or primary key constraint on columns "department", "thread_id" */
  ThreadDepartmentsPkey = 'thread_departments_pkey'
}

/** input type for inserting data into table "thread_departments" */
export type Thread_Departments_Insert_Input = {
  department?: Maybe<User_Type_Enum>;
  department_type?: Maybe<User_Type_Obj_Rel_Insert_Input>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread?: Maybe<Threads_Obj_Rel_Insert_Input>;
  thread_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Thread_Departments_Max_Fields = {
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "thread_departments" */
export type Thread_Departments_Max_Order_By = {
  tenant_id?: Maybe<Order_By>;
  thread_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Thread_Departments_Min_Fields = {
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "thread_departments" */
export type Thread_Departments_Min_Order_By = {
  tenant_id?: Maybe<Order_By>;
  thread_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "thread_departments" */
export type Thread_Departments_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Thread_Departments>;
};

/** on_conflict condition type for table "thread_departments" */
export type Thread_Departments_On_Conflict = {
  constraint: Thread_Departments_Constraint;
  update_columns?: Array<Thread_Departments_Update_Column>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};

/** Ordering options when selecting data from "thread_departments". */
export type Thread_Departments_Order_By = {
  department?: Maybe<Order_By>;
  department_type?: Maybe<User_Type_Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  thread?: Maybe<Threads_Order_By>;
  thread_id?: Maybe<Order_By>;
};

/** primary key columns input for table: thread_departments */
export type Thread_Departments_Pk_Columns_Input = {
  department: User_Type_Enum;
  thread_id: Scalars['uuid'];
};

/** select columns of table "thread_departments" */
export enum Thread_Departments_Select_Column {
  /** column name */
  Department = 'department',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id'
}

/** input type for updating data in table "thread_departments" */
export type Thread_Departments_Set_Input = {
  department?: Maybe<User_Type_Enum>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "thread_departments" */
export type Thread_Departments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Thread_Departments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Thread_Departments_Stream_Cursor_Value_Input = {
  department?: Maybe<User_Type_Enum>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "thread_departments" */
export enum Thread_Departments_Update_Column {
  /** column name */
  Department = 'department',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id'
}

export type Thread_Departments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Thread_Departments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Thread_Departments_Bool_Exp;
};

/** columns and relationships of "thread_members" */
export type Thread_Members = {
  joined_at: Scalars['timestamptz'];
  last_read_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  thread: Threads;
  thread_id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "thread_members" */
export type Thread_Members_Aggregate = {
  aggregate?: Maybe<Thread_Members_Aggregate_Fields>;
  nodes: Array<Thread_Members>;
};

export type Thread_Members_Aggregate_Bool_Exp = {
  count?: Maybe<Thread_Members_Aggregate_Bool_Exp_Count>;
};

export type Thread_Members_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Thread_Members_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Thread_Members_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "thread_members" */
export type Thread_Members_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Thread_Members_Max_Fields>;
  min?: Maybe<Thread_Members_Min_Fields>;
};


/** aggregate fields of "thread_members" */
export type Thread_Members_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Thread_Members_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "thread_members" */
export type Thread_Members_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Thread_Members_Max_Order_By>;
  min?: Maybe<Thread_Members_Min_Order_By>;
};

/** input type for inserting array relation for remote table "thread_members" */
export type Thread_Members_Arr_Rel_Insert_Input = {
  data: Array<Thread_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Thread_Members_On_Conflict>;
};

/** Boolean expression to filter rows from the table "thread_members". All fields are combined with a logical 'AND'. */
export type Thread_Members_Bool_Exp = {
  _and?: Maybe<Array<Thread_Members_Bool_Exp>>;
  _not?: Maybe<Thread_Members_Bool_Exp>;
  _or?: Maybe<Array<Thread_Members_Bool_Exp>>;
  joined_at?: Maybe<Timestamptz_Comparison_Exp>;
  last_read_at?: Maybe<Timestamptz_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  thread?: Maybe<Threads_Bool_Exp>;
  thread_id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "thread_members" */
export enum Thread_Members_Constraint {
  /** unique or primary key constraint on columns "user_id", "thread_id" */
  ThreadMembersPkey = 'thread_members_pkey'
}

/** input type for inserting data into table "thread_members" */
export type Thread_Members_Insert_Input = {
  joined_at?: Maybe<Scalars['timestamptz']>;
  last_read_at?: Maybe<Scalars['timestamptz']>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread?: Maybe<Threads_Obj_Rel_Insert_Input>;
  thread_id?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Thread_Members_Max_Fields = {
  joined_at?: Maybe<Scalars['timestamptz']>;
  last_read_at?: Maybe<Scalars['timestamptz']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "thread_members" */
export type Thread_Members_Max_Order_By = {
  joined_at?: Maybe<Order_By>;
  last_read_at?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  thread_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Thread_Members_Min_Fields = {
  joined_at?: Maybe<Scalars['timestamptz']>;
  last_read_at?: Maybe<Scalars['timestamptz']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "thread_members" */
export type Thread_Members_Min_Order_By = {
  joined_at?: Maybe<Order_By>;
  last_read_at?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  thread_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "thread_members" */
export type Thread_Members_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Thread_Members>;
};

/** on_conflict condition type for table "thread_members" */
export type Thread_Members_On_Conflict = {
  constraint: Thread_Members_Constraint;
  update_columns?: Array<Thread_Members_Update_Column>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "thread_members". */
export type Thread_Members_Order_By = {
  joined_at?: Maybe<Order_By>;
  last_read_at?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  thread?: Maybe<Threads_Order_By>;
  thread_id?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: thread_members */
export type Thread_Members_Pk_Columns_Input = {
  thread_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

/** select columns of table "thread_members" */
export enum Thread_Members_Select_Column {
  /** column name */
  JoinedAt = 'joined_at',
  /** column name */
  LastReadAt = 'last_read_at',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "thread_members" */
export type Thread_Members_Set_Input = {
  joined_at?: Maybe<Scalars['timestamptz']>;
  last_read_at?: Maybe<Scalars['timestamptz']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "thread_members" */
export type Thread_Members_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Thread_Members_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Thread_Members_Stream_Cursor_Value_Input = {
  joined_at?: Maybe<Scalars['timestamptz']>;
  last_read_at?: Maybe<Scalars['timestamptz']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "thread_members" */
export enum Thread_Members_Update_Column {
  /** column name */
  JoinedAt = 'joined_at',
  /** column name */
  LastReadAt = 'last_read_at',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UserId = 'user_id'
}

export type Thread_Members_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Thread_Members_Set_Input>;
  /** filter the rows which have to be updated */
  where: Thread_Members_Bool_Exp;
};

/** columns and relationships of "thread_status" */
export type Thread_Status = {
  display: Scalars['String'];
  /** An array relationship */
  threads: Array<Threads>;
  /** An aggregate relationship */
  threads_aggregate: Threads_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "thread_status" */
export type Thread_StatusThreadsArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "thread_status" */
export type Thread_StatusThreads_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};

/** aggregated selection of "thread_status" */
export type Thread_Status_Aggregate = {
  aggregate?: Maybe<Thread_Status_Aggregate_Fields>;
  nodes: Array<Thread_Status>;
};

/** aggregate fields of "thread_status" */
export type Thread_Status_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Thread_Status_Max_Fields>;
  min?: Maybe<Thread_Status_Min_Fields>;
};


/** aggregate fields of "thread_status" */
export type Thread_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Thread_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "thread_status". All fields are combined with a logical 'AND'. */
export type Thread_Status_Bool_Exp = {
  _and?: Maybe<Array<Thread_Status_Bool_Exp>>;
  _not?: Maybe<Thread_Status_Bool_Exp>;
  _or?: Maybe<Array<Thread_Status_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  threads?: Maybe<Threads_Bool_Exp>;
  threads_aggregate?: Maybe<Threads_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "thread_status" */
export enum Thread_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  ThreadStatusPkey = 'thread_status_pkey'
}

export enum Thread_Status_Enum {
  /** Closed */
  Closed = 'closed',
  /** Open */
  Open = 'open'
}

/** Boolean expression to compare columns of type "thread_status_enum". All fields are combined with logical 'AND'. */
export type Thread_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Thread_Status_Enum>;
  _in?: Maybe<Array<Thread_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Thread_Status_Enum>;
  _nin?: Maybe<Array<Thread_Status_Enum>>;
};

/** input type for inserting data into table "thread_status" */
export type Thread_Status_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  threads?: Maybe<Threads_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Thread_Status_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Thread_Status_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "thread_status" */
export type Thread_Status_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Thread_Status>;
};

/** input type for inserting object relation for remote table "thread_status" */
export type Thread_Status_Obj_Rel_Insert_Input = {
  data: Thread_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Thread_Status_On_Conflict>;
};

/** on_conflict condition type for table "thread_status" */
export type Thread_Status_On_Conflict = {
  constraint: Thread_Status_Constraint;
  update_columns?: Array<Thread_Status_Update_Column>;
  where?: Maybe<Thread_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "thread_status". */
export type Thread_Status_Order_By = {
  display?: Maybe<Order_By>;
  threads_aggregate?: Maybe<Threads_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: thread_status */
export type Thread_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "thread_status" */
export enum Thread_Status_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "thread_status" */
export type Thread_Status_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "thread_status" */
export type Thread_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Thread_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Thread_Status_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "thread_status" */
export enum Thread_Status_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Thread_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Thread_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Thread_Status_Bool_Exp;
};

/** columns and relationships of "thread_type" */
export type Thread_Type = {
  display: Scalars['String'];
  /** An array relationship */
  threads: Array<Threads>;
  /** An aggregate relationship */
  threads_aggregate: Threads_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "thread_type" */
export type Thread_TypeThreadsArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "thread_type" */
export type Thread_TypeThreads_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};

/** aggregated selection of "thread_type" */
export type Thread_Type_Aggregate = {
  aggregate?: Maybe<Thread_Type_Aggregate_Fields>;
  nodes: Array<Thread_Type>;
};

/** aggregate fields of "thread_type" */
export type Thread_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Thread_Type_Max_Fields>;
  min?: Maybe<Thread_Type_Min_Fields>;
};


/** aggregate fields of "thread_type" */
export type Thread_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Thread_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "thread_type". All fields are combined with a logical 'AND'. */
export type Thread_Type_Bool_Exp = {
  _and?: Maybe<Array<Thread_Type_Bool_Exp>>;
  _not?: Maybe<Thread_Type_Bool_Exp>;
  _or?: Maybe<Array<Thread_Type_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  threads?: Maybe<Threads_Bool_Exp>;
  threads_aggregate?: Maybe<Threads_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "thread_type" */
export enum Thread_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ThreadTypePkey = 'thread_type_pkey'
}

export enum Thread_Type_Enum {
  /** Booking */
  Booking = 'booking',
  /** Discussion */
  Discussion = 'discussion',
  /** Direct Message */
  Dm = 'dm',
  /** Alerts & Notifications */
  System = 'system',
  /** Talent */
  Talent = 'talent',
  /** Venue */
  Venue = 'venue'
}

/** Boolean expression to compare columns of type "thread_type_enum". All fields are combined with logical 'AND'. */
export type Thread_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Thread_Type_Enum>;
  _in?: Maybe<Array<Thread_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Thread_Type_Enum>;
  _nin?: Maybe<Array<Thread_Type_Enum>>;
};

/** input type for inserting data into table "thread_type" */
export type Thread_Type_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  threads?: Maybe<Threads_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Thread_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Thread_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "thread_type" */
export type Thread_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Thread_Type>;
};

/** input type for inserting object relation for remote table "thread_type" */
export type Thread_Type_Obj_Rel_Insert_Input = {
  data: Thread_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Thread_Type_On_Conflict>;
};

/** on_conflict condition type for table "thread_type" */
export type Thread_Type_On_Conflict = {
  constraint: Thread_Type_Constraint;
  update_columns?: Array<Thread_Type_Update_Column>;
  where?: Maybe<Thread_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "thread_type". */
export type Thread_Type_Order_By = {
  display?: Maybe<Order_By>;
  threads_aggregate?: Maybe<Threads_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: thread_type */
export type Thread_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "thread_type" */
export enum Thread_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "thread_type" */
export type Thread_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "thread_type" */
export type Thread_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Thread_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Thread_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "thread_type" */
export enum Thread_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type Thread_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Thread_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Thread_Type_Bool_Exp;
};

/** columns and relationships of "threads" */
export type Threads = {
  /** An object relationship */
  booking?: Maybe<Bookings>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  status: Thread_Status_Enum;
  subject: Scalars['String'];
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  thread_departments: Array<Thread_Departments>;
  /** An aggregate relationship */
  thread_departments_aggregate: Thread_Departments_Aggregate;
  /** An array relationship */
  thread_members: Array<Thread_Members>;
  /** An aggregate relationship */
  thread_members_aggregate: Thread_Members_Aggregate;
  /** An object relationship */
  thread_status: Thread_Status;
  /** An object relationship */
  thread_type: Thread_Type;
  type: Thread_Type_Enum;
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  venue?: Maybe<Tenants>;
  venue_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "threads" */
export type ThreadsMessagesArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


/** columns and relationships of "threads" */
export type ThreadsMessages_AggregateArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


/** columns and relationships of "threads" */
export type ThreadsThread_DepartmentsArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


/** columns and relationships of "threads" */
export type ThreadsThread_Departments_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


/** columns and relationships of "threads" */
export type ThreadsThread_MembersArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


/** columns and relationships of "threads" */
export type ThreadsThread_Members_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};

/** aggregated selection of "threads" */
export type Threads_Aggregate = {
  aggregate?: Maybe<Threads_Aggregate_Fields>;
  nodes: Array<Threads>;
};

export type Threads_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Threads_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Threads_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Threads_Aggregate_Bool_Exp_Count>;
};

export type Threads_Aggregate_Bool_Exp_Bool_And = {
  arguments: Threads_Select_Column_Threads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Threads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Threads_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Threads_Select_Column_Threads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Threads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Threads_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Threads_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Threads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "threads" */
export type Threads_Aggregate_Fields = {
  avg?: Maybe<Threads_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Threads_Max_Fields>;
  min?: Maybe<Threads_Min_Fields>;
  stddev?: Maybe<Threads_Stddev_Fields>;
  stddev_pop?: Maybe<Threads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Threads_Stddev_Samp_Fields>;
  sum?: Maybe<Threads_Sum_Fields>;
  var_pop?: Maybe<Threads_Var_Pop_Fields>;
  var_samp?: Maybe<Threads_Var_Samp_Fields>;
  variance?: Maybe<Threads_Variance_Fields>;
};


/** aggregate fields of "threads" */
export type Threads_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Threads_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "threads" */
export type Threads_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Threads_Max_Order_By>;
  min?: Maybe<Threads_Min_Order_By>;
};

/** input type for inserting array relation for remote table "threads" */
export type Threads_Arr_Rel_Insert_Input = {
  data: Array<Threads_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Threads_On_Conflict>;
};

/** aggregate avg on columns */
export type Threads_Avg_Fields = {
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
};

/** Boolean expression to filter rows from the table "threads". All fields are combined with a logical 'AND'. */
export type Threads_Bool_Exp = {
  _and?: Maybe<Array<Threads_Bool_Exp>>;
  _not?: Maybe<Threads_Bool_Exp>;
  _or?: Maybe<Array<Threads_Bool_Exp>>;
  booking?: Maybe<Bookings_Bool_Exp>;
  booking_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  messages?: Maybe<Messages_Bool_Exp>;
  messages_aggregate?: Maybe<Messages_Aggregate_Bool_Exp>;
  status?: Maybe<Thread_Status_Enum_Comparison_Exp>;
  subject?: Maybe<String_Comparison_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  thread_departments?: Maybe<Thread_Departments_Bool_Exp>;
  thread_departments_aggregate?: Maybe<Thread_Departments_Aggregate_Bool_Exp>;
  thread_members?: Maybe<Thread_Members_Bool_Exp>;
  thread_members_aggregate?: Maybe<Thread_Members_Aggregate_Bool_Exp>;
  thread_status?: Maybe<Thread_Status_Bool_Exp>;
  thread_type?: Maybe<Thread_Type_Bool_Exp>;
  type?: Maybe<Thread_Type_Enum_Comparison_Exp>;
  unread_count?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
  venue?: Maybe<Tenants_Bool_Exp>;
  venue_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "threads" */
export enum Threads_Constraint {
  /** unique or primary key constraint on columns "id" */
  ThreadsPkey = 'threads_pkey',
  /** unique or primary key constraint on columns "booking_id", "tenant_id" */
  ThreadsUniqueOpenByBooking = 'threads_unique_open_by_booking'
}

/** input type for inserting data into table "threads" */
export type Threads_Insert_Input = {
  booking?: Maybe<Bookings_Obj_Rel_Insert_Input>;
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  messages?: Maybe<Messages_Arr_Rel_Insert_Input>;
  status?: Maybe<Thread_Status_Enum>;
  subject?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  thread_departments?: Maybe<Thread_Departments_Arr_Rel_Insert_Input>;
  thread_members?: Maybe<Thread_Members_Arr_Rel_Insert_Input>;
  thread_status?: Maybe<Thread_Status_Obj_Rel_Insert_Input>;
  thread_type?: Maybe<Thread_Type_Obj_Rel_Insert_Input>;
  type?: Maybe<Thread_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  venue?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Threads_Max_Fields = {
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "threads" */
export type Threads_Max_Order_By = {
  booking_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Threads_Min_Fields = {
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "threads" */
export type Threads_Min_Order_By = {
  booking_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "threads" */
export type Threads_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Threads>;
};

/** input type for inserting object relation for remote table "threads" */
export type Threads_Obj_Rel_Insert_Input = {
  data: Threads_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Threads_On_Conflict>;
};

/** on_conflict condition type for table "threads" */
export type Threads_On_Conflict = {
  constraint: Threads_Constraint;
  update_columns?: Array<Threads_Update_Column>;
  where?: Maybe<Threads_Bool_Exp>;
};

/** Ordering options when selecting data from "threads". */
export type Threads_Order_By = {
  booking?: Maybe<Bookings_Order_By>;
  booking_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  deleted?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  messages_aggregate?: Maybe<Messages_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  thread_departments_aggregate?: Maybe<Thread_Departments_Aggregate_Order_By>;
  thread_members_aggregate?: Maybe<Thread_Members_Aggregate_Order_By>;
  thread_status?: Maybe<Thread_Status_Order_By>;
  thread_type?: Maybe<Thread_Type_Order_By>;
  type?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
  venue?: Maybe<Tenants_Order_By>;
  venue_id?: Maybe<Order_By>;
};

/** primary key columns input for table: threads */
export type Threads_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "threads" */
export enum Threads_Select_Column {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueId = 'venue_id'
}

/** select "threads_aggregate_bool_exp_bool_and_arguments_columns" columns of table "threads" */
export enum Threads_Select_Column_Threads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "threads_aggregate_bool_exp_bool_or_arguments_columns" columns of table "threads" */
export enum Threads_Select_Column_Threads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "threads" */
export type Threads_Set_Input = {
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Thread_Status_Enum>;
  subject?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Thread_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Threads_Stddev_Fields = {
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
};

/** aggregate stddev_pop on columns */
export type Threads_Stddev_Pop_Fields = {
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
};

/** aggregate stddev_samp on columns */
export type Threads_Stddev_Samp_Fields = {
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
};

/** Streaming cursor of the table "threads" */
export type Threads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Threads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Threads_Stream_Cursor_Value_Input = {
  booking_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Thread_Status_Enum>;
  subject?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Thread_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Threads_Sum_Fields = {
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
};

/** update columns of table "threads" */
export enum Threads_Update_Column {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueId = 'venue_id'
}

export type Threads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Threads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Threads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Threads_Var_Pop_Fields = {
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
};

/** aggregate var_samp on columns */
export type Threads_Var_Samp_Fields = {
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
};

/** aggregate variance on columns */
export type Threads_Variance_Fields = {
  /** A computed field, executes function "thread_unread_count" */
  unread_count?: Maybe<Scalars['Int']>;
};


/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: Maybe<Scalars['time']>;
  _gt?: Maybe<Scalars['time']>;
  _gte?: Maybe<Scalars['time']>;
  _in?: Maybe<Array<Scalars['time']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['time']>;
  _lte?: Maybe<Scalars['time']>;
  _neq?: Maybe<Scalars['time']>;
  _nin?: Maybe<Array<Scalars['time']>>;
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user_roles" */
export type User_Roles = {
  display: Scalars['String'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "user_roles" */
export type User_RolesUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "user_roles" */
export type User_RolesUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "user_roles" */
export type User_Roles_Aggregate = {
  aggregate?: Maybe<User_Roles_Aggregate_Fields>;
  nodes: Array<User_Roles>;
};

/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<User_Roles_Max_Fields>;
  min?: Maybe<User_Roles_Min_Fields>;
};


/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Roles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type User_Roles_Bool_Exp = {
  _and?: Maybe<Array<User_Roles_Bool_Exp>>;
  _not?: Maybe<User_Roles_Bool_Exp>;
  _or?: Maybe<Array<User_Roles_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  users?: Maybe<Users_Bool_Exp>;
  users_aggregate?: Maybe<Users_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_roles" */
export enum User_Roles_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserRolesPkey = 'user_roles_pkey'
}

export enum User_Roles_Enum {
  /** Admin */
  Administrator = 'administrator',
  /** Admin */
  AgencyAccountingAdministrator = 'agency_accounting_administrator',
  /** User */
  AgencyAccountingUser = 'agency_accounting_user',
  /** Admin */
  AgencyBookerAdministrator = 'agency_booker_administrator',
  /** User */
  AgencyBookerUser = 'agency_booker_user',
  /** Admin */
  AgencyDoorAdministrator = 'agency_door_administrator',
  /** User */
  AgencyDoorUser = 'agency_door_user',
  /** Admin */
  AgencyMarketingAdministrator = 'agency_marketing_administrator',
  /** User */
  AgencyMarketingUser = 'agency_marketing_user',
  /** Admin */
  AgencyOperationsAdministrator = 'agency_operations_administrator',
  /** User */
  AgencyOperationsUser = 'agency_operations_user',
  /** Admin */
  AgencyTalentAdministrator = 'agency_talent_administrator',
  /** User */
  AgencyTalentUser = 'agency_talent_user',
  /** Guest */
  Guest = 'guest',
  /** Superadmin */
  Superadmin = 'superadmin',
  /** User */
  User = 'user',
  /** Admin */
  VenueAccountingAdministrator = 'venue_accounting_administrator',
  /** User */
  VenueAccountingUser = 'venue_accounting_user',
  /** Admin */
  VenueBookerAdministrator = 'venue_booker_administrator',
  /** User */
  VenueBookerUser = 'venue_booker_user',
  /** Admin */
  VenueDoorAdministrator = 'venue_door_administrator',
  /** User */
  VenueDoorUser = 'venue_door_user',
  /** Admin */
  VenueMarketingAdministrator = 'venue_marketing_administrator',
  /** User */
  VenueMarketingUser = 'venue_marketing_user',
  /** Admin */
  VenueOperationsAdministrator = 'venue_operations_administrator',
  /** User */
  VenueOperationsUser = 'venue_operations_user',
  /** Admin */
  VenueTalentAdministrator = 'venue_talent_administrator',
  /** User */
  VenueTalentUser = 'venue_talent_user'
}

/** Boolean expression to compare columns of type "user_roles_enum". All fields are combined with logical 'AND'. */
export type User_Roles_Enum_Comparison_Exp = {
  _eq?: Maybe<User_Roles_Enum>;
  _in?: Maybe<Array<User_Roles_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<User_Roles_Enum>;
  _nin?: Maybe<Array<User_Roles_Enum>>;
};

/** input type for inserting data into table "user_roles" */
export type User_Roles_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Roles_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Roles_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_roles" */
export type User_Roles_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Roles>;
};

/** input type for inserting object relation for remote table "user_roles" */
export type User_Roles_Obj_Rel_Insert_Input = {
  data: User_Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_Roles_On_Conflict>;
};

/** on_conflict condition type for table "user_roles" */
export type User_Roles_On_Conflict = {
  constraint: User_Roles_Constraint;
  update_columns?: Array<User_Roles_Update_Column>;
  where?: Maybe<User_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_roles". */
export type User_Roles_Order_By = {
  display?: Maybe<Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: user_roles */
export type User_Roles_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_roles" */
export enum User_Roles_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_roles" */
export type User_Roles_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_roles" */
export type User_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Roles_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "user_roles" */
export enum User_Roles_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type User_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Roles_Bool_Exp;
};

/** columns and relationships of "user_status" */
export type User_Status = {
  display: Scalars['String'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "user_status" */
export type User_StatusUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "user_status" */
export type User_StatusUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "user_status" */
export type User_Status_Aggregate = {
  aggregate?: Maybe<User_Status_Aggregate_Fields>;
  nodes: Array<User_Status>;
};

/** aggregate fields of "user_status" */
export type User_Status_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<User_Status_Max_Fields>;
  min?: Maybe<User_Status_Min_Fields>;
};


/** aggregate fields of "user_status" */
export type User_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_status". All fields are combined with a logical 'AND'. */
export type User_Status_Bool_Exp = {
  _and?: Maybe<Array<User_Status_Bool_Exp>>;
  _not?: Maybe<User_Status_Bool_Exp>;
  _or?: Maybe<Array<User_Status_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  users?: Maybe<Users_Bool_Exp>;
  users_aggregate?: Maybe<Users_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_status" */
export enum User_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserStatusPkey = 'user_status_pkey'
}

export enum User_Status_Enum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive',
  /** Invited */
  Invited = 'invited'
}

/** Boolean expression to compare columns of type "user_status_enum". All fields are combined with logical 'AND'. */
export type User_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<User_Status_Enum>;
  _in?: Maybe<Array<User_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<User_Status_Enum>;
  _nin?: Maybe<Array<User_Status_Enum>>;
};

/** input type for inserting data into table "user_status" */
export type User_Status_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Status_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Status_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_status" */
export type User_Status_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Status>;
};

/** input type for inserting object relation for remote table "user_status" */
export type User_Status_Obj_Rel_Insert_Input = {
  data: User_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_Status_On_Conflict>;
};

/** on_conflict condition type for table "user_status" */
export type User_Status_On_Conflict = {
  constraint: User_Status_Constraint;
  update_columns?: Array<User_Status_Update_Column>;
  where?: Maybe<User_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "user_status". */
export type User_Status_Order_By = {
  display?: Maybe<Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: user_status */
export type User_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_status" */
export enum User_Status_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_status" */
export type User_Status_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_status" */
export type User_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Status_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "user_status" */
export enum User_Status_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type User_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Status_Bool_Exp;
};

/** columns and relationships of "user_type" */
export type User_Type = {
  display: Scalars['String'];
  /** An array relationship */
  thread_departments: Array<Thread_Departments>;
  /** An aggregate relationship */
  thread_departments_aggregate: Thread_Departments_Aggregate;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "user_type" */
export type User_TypeThread_DepartmentsArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


/** columns and relationships of "user_type" */
export type User_TypeThread_Departments_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Departments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Departments_Order_By>>;
  where?: Maybe<Thread_Departments_Bool_Exp>;
};


/** columns and relationships of "user_type" */
export type User_TypeUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "user_type" */
export type User_TypeUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "user_type" */
export type User_Type_Aggregate = {
  aggregate?: Maybe<User_Type_Aggregate_Fields>;
  nodes: Array<User_Type>;
};

/** aggregate fields of "user_type" */
export type User_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<User_Type_Max_Fields>;
  min?: Maybe<User_Type_Min_Fields>;
};


/** aggregate fields of "user_type" */
export type User_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_type". All fields are combined with a logical 'AND'. */
export type User_Type_Bool_Exp = {
  _and?: Maybe<Array<User_Type_Bool_Exp>>;
  _not?: Maybe<User_Type_Bool_Exp>;
  _or?: Maybe<Array<User_Type_Bool_Exp>>;
  display?: Maybe<String_Comparison_Exp>;
  thread_departments?: Maybe<Thread_Departments_Bool_Exp>;
  thread_departments_aggregate?: Maybe<Thread_Departments_Aggregate_Bool_Exp>;
  users?: Maybe<Users_Bool_Exp>;
  users_aggregate?: Maybe<Users_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_type" */
export enum User_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserTypePkey = 'user_type_pkey'
}

export enum User_Type_Enum {
  /** Accounting */
  Accounting = 'accounting',
  /** Booker */
  Booker = 'booker',
  /** Door */
  Door = 'door',
  /** Marketing */
  Marketing = 'marketing',
  /** Operations */
  Operations = 'operations',
  /** Talent */
  Talent = 'talent'
}

/** Boolean expression to compare columns of type "user_type_enum". All fields are combined with logical 'AND'. */
export type User_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<User_Type_Enum>;
  _in?: Maybe<Array<User_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<User_Type_Enum>;
  _nin?: Maybe<Array<User_Type_Enum>>;
};

/** input type for inserting data into table "user_type" */
export type User_Type_Insert_Input = {
  display?: Maybe<Scalars['String']>;
  thread_departments?: Maybe<Thread_Departments_Arr_Rel_Insert_Input>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Type_Max_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Type_Min_Fields = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_type" */
export type User_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Type>;
};

/** input type for inserting object relation for remote table "user_type" */
export type User_Type_Obj_Rel_Insert_Input = {
  data: User_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_Type_On_Conflict>;
};

/** on_conflict condition type for table "user_type" */
export type User_Type_On_Conflict = {
  constraint: User_Type_Constraint;
  update_columns?: Array<User_Type_Update_Column>;
  where?: Maybe<User_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "user_type". */
export type User_Type_Order_By = {
  display?: Maybe<Order_By>;
  thread_departments_aggregate?: Maybe<Thread_Departments_Aggregate_Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: user_type */
export type User_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_type" */
export enum User_Type_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_type" */
export type User_Type_Set_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_type" */
export type User_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Type_Stream_Cursor_Value_Input = {
  display?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "user_type" */
export enum User_Type_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Value = 'value'
}

export type User_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Type_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  /** An array relationship */
  areas_created: Array<Areas>;
  /** An aggregate relationship */
  areas_created_aggregate: Areas_Aggregate;
  /** An array relationship */
  areas_updated: Array<Areas>;
  /** An aggregate relationship */
  areas_updated_aggregate: Areas_Aggregate;
  bday?: Maybe<Scalars['date']>;
  bio?: Maybe<Scalars['String']>;
  /** An array relationship */
  blackouts: Array<Blackouts>;
  /** An aggregate relationship */
  blackouts_aggregate: Blackouts_Aggregate;
  /** An array relationship */
  blackouts_created: Array<Blackouts>;
  /** An aggregate relationship */
  blackouts_created_aggregate: Blackouts_Aggregate;
  /** An array relationship */
  blackouts_updated: Array<Blackouts>;
  /** An aggregate relationship */
  blackouts_updated_aggregate: Blackouts_Aggregate;
  /** An array relationship */
  booking_series_created: Array<Booking_Series>;
  /** An aggregate relationship */
  booking_series_created_aggregate: Booking_Series_Aggregate;
  /** An array relationship */
  booking_series_updated: Array<Booking_Series>;
  /** An aggregate relationship */
  booking_series_updated_aggregate: Booking_Series_Aggregate;
  /** An array relationship */
  bookings_created: Array<Bookings>;
  /** An aggregate relationship */
  bookings_created_aggregate: Bookings_Aggregate;
  /** An array relationship */
  bookings_updates: Array<Bookings>;
  /** An aggregate relationship */
  bookings_updates_aggregate: Bookings_Aggregate;
  city?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** A computed field, executes function "user_dj_display" */
  dj_display?: Maybe<Scalars['String']>;
  /** An array relationship */
  documents_created: Array<Documents>;
  /** An aggregate relationship */
  documents_created_aggregate: Documents_Aggregate;
  /** An array relationship */
  documents_updated: Array<Documents>;
  /** An aggregate relationship */
  documents_updated_aggregate: Documents_Aggregate;
  email: Scalars['String'];
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  genres?: Maybe<Scalars['String']>;
  /** An array relationship */
  guidelines_created: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_created_aggregate: Guidelines_Aggregate;
  /** An array relationship */
  guidelines_updated: Array<Guidelines>;
  /** An aggregate relationship */
  guidelines_updated_aggregate: Guidelines_Aggregate;
  id: Scalars['uuid'];
  instagram?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** A computed field, executes function "user_full_name" */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  role: User_Roles_Enum;
  state?: Maybe<Scalars['String']>;
  status: User_Status_Enum;
  /** An array relationship */
  talent_bookings: Array<Bookings>;
  /** An aggregate relationship */
  talent_bookings_aggregate: Bookings_Aggregate;
  /** An array relationship */
  talent_documents: Array<Documents>;
  /** An aggregate relationship */
  talent_documents_aggregate: Documents_Aggregate;
  /** An array relationship */
  talent_guidelines: Array<Guidelines>;
  /** An aggregate relationship */
  talent_guidelines_aggregate: Guidelines_Aggregate;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  tenants_created: Array<Tenants>;
  /** An aggregate relationship */
  tenants_created_aggregate: Tenants_Aggregate;
  /** An array relationship */
  tenants_updated: Array<Tenants>;
  /** An aggregate relationship */
  tenants_updated_aggregate: Tenants_Aggregate;
  /** An array relationship */
  threads: Array<Thread_Members>;
  /** An aggregate relationship */
  threads_aggregate: Thread_Members_Aggregate;
  /** An array relationship */
  threads_created: Array<Threads>;
  /** An aggregate relationship */
  threads_created_aggregate: Threads_Aggregate;
  /** An array relationship */
  threads_updated: Array<Threads>;
  /** An aggregate relationship */
  threads_updated_aggregate: Threads_Aggregate;
  tiktok?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type: User_Type_Enum;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  user_number?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user_role: User_Roles;
  /** An object relationship */
  user_status: User_Status;
  /** An object relationship */
  user_type: User_Type;
  /** An array relationship */
  users_created: Array<Users>;
  /** An aggregate relationship */
  users_created_aggregate: Users_Aggregate;
  /** An array relationship */
  users_updated: Array<Users>;
  /** An aggregate relationship */
  users_updated_aggregate: Users_Aggregate;
  website?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersAreas_CreatedArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAreas_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAreas_UpdatedArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAreas_Updated_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBlackoutsArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBlackouts_AggregateArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBlackouts_CreatedArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBlackouts_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBlackouts_UpdatedArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBlackouts_Updated_AggregateArgs = {
  distinct_on?: Maybe<Array<Blackouts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By>>;
  where?: Maybe<Blackouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBooking_Series_CreatedArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBooking_Series_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBooking_Series_UpdatedArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBooking_Series_Updated_AggregateArgs = {
  distinct_on?: Maybe<Array<Booking_Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Booking_Series_Order_By>>;
  where?: Maybe<Booking_Series_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBookings_CreatedArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBookings_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBookings_UpdatesArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBookings_Updates_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDocuments_CreatedArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDocuments_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDocuments_UpdatedArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDocuments_Updated_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGuidelines_CreatedArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGuidelines_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGuidelines_UpdatedArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGuidelines_Updated_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMessagesArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMessages_AggregateArgs = {
  distinct_on?: Maybe<Array<Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By>>;
  where?: Maybe<Messages_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTalent_BookingsArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTalent_Bookings_AggregateArgs = {
  distinct_on?: Maybe<Array<Bookings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By>>;
  where?: Maybe<Bookings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTalent_DocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTalent_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTalent_GuidelinesArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTalent_Guidelines_AggregateArgs = {
  distinct_on?: Maybe<Array<Guidelines_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By>>;
  where?: Maybe<Guidelines_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTenants_CreatedArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTenants_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTenants_UpdatedArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTenants_Updated_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersThreadsArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersThreads_AggregateArgs = {
  distinct_on?: Maybe<Array<Thread_Members_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Thread_Members_Order_By>>;
  where?: Maybe<Thread_Members_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersThreads_CreatedArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersThreads_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersThreads_UpdatedArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersThreads_Updated_AggregateArgs = {
  distinct_on?: Maybe<Array<Threads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By>>;
  where?: Maybe<Threads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_CreatedArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Created_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_UpdatedArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Updated_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: Maybe<Users_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Max_Order_By>;
  min?: Maybe<Users_Min_Order_By>;
  stddev?: Maybe<Users_Stddev_Order_By>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Order_By>;
  sum?: Maybe<Users_Sum_Order_By>;
  var_pop?: Maybe<Users_Var_Pop_Order_By>;
  var_samp?: Maybe<Users_Var_Samp_Order_By>;
  variance?: Maybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  user_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  user_number?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Users_Bool_Exp>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Users_Bool_Exp>>;
  address_line1?: Maybe<String_Comparison_Exp>;
  address_line2?: Maybe<String_Comparison_Exp>;
  alias?: Maybe<String_Comparison_Exp>;
  areas_created?: Maybe<Areas_Bool_Exp>;
  areas_created_aggregate?: Maybe<Areas_Aggregate_Bool_Exp>;
  areas_updated?: Maybe<Areas_Bool_Exp>;
  areas_updated_aggregate?: Maybe<Areas_Aggregate_Bool_Exp>;
  bday?: Maybe<Date_Comparison_Exp>;
  bio?: Maybe<String_Comparison_Exp>;
  blackouts?: Maybe<Blackouts_Bool_Exp>;
  blackouts_aggregate?: Maybe<Blackouts_Aggregate_Bool_Exp>;
  blackouts_created?: Maybe<Blackouts_Bool_Exp>;
  blackouts_created_aggregate?: Maybe<Blackouts_Aggregate_Bool_Exp>;
  blackouts_updated?: Maybe<Blackouts_Bool_Exp>;
  blackouts_updated_aggregate?: Maybe<Blackouts_Aggregate_Bool_Exp>;
  booking_series_created?: Maybe<Booking_Series_Bool_Exp>;
  booking_series_created_aggregate?: Maybe<Booking_Series_Aggregate_Bool_Exp>;
  booking_series_updated?: Maybe<Booking_Series_Bool_Exp>;
  booking_series_updated_aggregate?: Maybe<Booking_Series_Aggregate_Bool_Exp>;
  bookings_created?: Maybe<Bookings_Bool_Exp>;
  bookings_created_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  bookings_updates?: Maybe<Bookings_Bool_Exp>;
  bookings_updates_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  color?: Maybe<String_Comparison_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<Users_Bool_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  dj_display?: Maybe<String_Comparison_Exp>;
  documents_created?: Maybe<Documents_Bool_Exp>;
  documents_created_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  documents_updated?: Maybe<Documents_Bool_Exp>;
  documents_updated_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  facebook?: Maybe<String_Comparison_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  genres?: Maybe<String_Comparison_Exp>;
  guidelines_created?: Maybe<Guidelines_Bool_Exp>;
  guidelines_created_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  guidelines_updated?: Maybe<Guidelines_Bool_Exp>;
  guidelines_updated_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  instagram?: Maybe<String_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  messages?: Maybe<Messages_Bool_Exp>;
  messages_aggregate?: Maybe<Messages_Aggregate_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<String_Comparison_Exp>;
  postal_code?: Maybe<String_Comparison_Exp>;
  role?: Maybe<User_Roles_Enum_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  status?: Maybe<User_Status_Enum_Comparison_Exp>;
  talent_bookings?: Maybe<Bookings_Bool_Exp>;
  talent_bookings_aggregate?: Maybe<Bookings_Aggregate_Bool_Exp>;
  talent_documents?: Maybe<Documents_Bool_Exp>;
  talent_documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  talent_guidelines?: Maybe<Guidelines_Bool_Exp>;
  talent_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Bool_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  tenants_created?: Maybe<Tenants_Bool_Exp>;
  tenants_created_aggregate?: Maybe<Tenants_Aggregate_Bool_Exp>;
  tenants_updated?: Maybe<Tenants_Bool_Exp>;
  tenants_updated_aggregate?: Maybe<Tenants_Aggregate_Bool_Exp>;
  threads?: Maybe<Thread_Members_Bool_Exp>;
  threads_aggregate?: Maybe<Thread_Members_Aggregate_Bool_Exp>;
  threads_created?: Maybe<Threads_Bool_Exp>;
  threads_created_aggregate?: Maybe<Threads_Aggregate_Bool_Exp>;
  threads_updated?: Maybe<Threads_Bool_Exp>;
  threads_updated_aggregate?: Maybe<Threads_Aggregate_Bool_Exp>;
  tiktok?: Maybe<String_Comparison_Exp>;
  timezone?: Maybe<String_Comparison_Exp>;
  type?: Maybe<User_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Uuid_Comparison_Exp>;
  updated_by_user?: Maybe<Users_Bool_Exp>;
  user_number?: Maybe<Int_Comparison_Exp>;
  user_role?: Maybe<User_Roles_Bool_Exp>;
  user_status?: Maybe<User_Status_Bool_Exp>;
  user_type?: Maybe<User_Type_Bool_Exp>;
  users_created?: Maybe<Users_Bool_Exp>;
  users_created_aggregate?: Maybe<Users_Aggregate_Bool_Exp>;
  users_updated?: Maybe<Users_Bool_Exp>;
  users_updated_aggregate?: Maybe<Users_Aggregate_Bool_Exp>;
  website?: Maybe<String_Comparison_Exp>;
  x?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  user_number?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  areas_created?: Maybe<Areas_Arr_Rel_Insert_Input>;
  areas_updated?: Maybe<Areas_Arr_Rel_Insert_Input>;
  bday?: Maybe<Scalars['date']>;
  bio?: Maybe<Scalars['String']>;
  blackouts?: Maybe<Blackouts_Arr_Rel_Insert_Input>;
  blackouts_created?: Maybe<Blackouts_Arr_Rel_Insert_Input>;
  blackouts_updated?: Maybe<Blackouts_Arr_Rel_Insert_Input>;
  booking_series_created?: Maybe<Booking_Series_Arr_Rel_Insert_Input>;
  booking_series_updated?: Maybe<Booking_Series_Arr_Rel_Insert_Input>;
  bookings_created?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  bookings_updates?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  city?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  deleted?: Maybe<Scalars['Boolean']>;
  documents_created?: Maybe<Documents_Arr_Rel_Insert_Input>;
  documents_updated?: Maybe<Documents_Arr_Rel_Insert_Input>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  genres?: Maybe<Scalars['String']>;
  guidelines_created?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  guidelines_updated?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  messages?: Maybe<Messages_Arr_Rel_Insert_Input>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  role?: Maybe<User_Roles_Enum>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<User_Status_Enum>;
  talent_bookings?: Maybe<Bookings_Arr_Rel_Insert_Input>;
  talent_documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  talent_guidelines?: Maybe<Guidelines_Arr_Rel_Insert_Input>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  tenants_created?: Maybe<Tenants_Arr_Rel_Insert_Input>;
  tenants_updated?: Maybe<Tenants_Arr_Rel_Insert_Input>;
  threads?: Maybe<Thread_Members_Arr_Rel_Insert_Input>;
  threads_created?: Maybe<Threads_Arr_Rel_Insert_Input>;
  threads_updated?: Maybe<Threads_Arr_Rel_Insert_Input>;
  tiktok?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<User_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  updated_by_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_number?: Maybe<Scalars['Int']>;
  user_role?: Maybe<User_Roles_Obj_Rel_Insert_Input>;
  user_status?: Maybe<User_Status_Obj_Rel_Insert_Input>;
  user_type?: Maybe<User_Type_Obj_Rel_Insert_Input>;
  users_created?: Maybe<Users_Arr_Rel_Insert_Input>;
  users_updated?: Maybe<Users_Arr_Rel_Insert_Input>;
  website?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  bday?: Maybe<Scalars['date']>;
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "user_dj_display" */
  dj_display?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  genres?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  /** A computed field, executes function "user_full_name" */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  tiktok?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  user_number?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  address_line1?: Maybe<Order_By>;
  address_line2?: Maybe<Order_By>;
  alias?: Maybe<Order_By>;
  bday?: Maybe<Order_By>;
  bio?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  color?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  facebook?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  genres?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  tiktok?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  user_number?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
  x?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  bday?: Maybe<Scalars['date']>;
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "user_dj_display" */
  dj_display?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  genres?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  /** A computed field, executes function "user_full_name" */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  tiktok?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  user_number?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  address_line1?: Maybe<Order_By>;
  address_line2?: Maybe<Order_By>;
  alias?: Maybe<Order_By>;
  bday?: Maybe<Order_By>;
  bio?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  color?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  facebook?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  genres?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  tiktok?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  user_number?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
  x?: Maybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  address_line1?: Maybe<Order_By>;
  address_line2?: Maybe<Order_By>;
  alias?: Maybe<Order_By>;
  areas_created_aggregate?: Maybe<Areas_Aggregate_Order_By>;
  areas_updated_aggregate?: Maybe<Areas_Aggregate_Order_By>;
  bday?: Maybe<Order_By>;
  bio?: Maybe<Order_By>;
  blackouts_aggregate?: Maybe<Blackouts_Aggregate_Order_By>;
  blackouts_created_aggregate?: Maybe<Blackouts_Aggregate_Order_By>;
  blackouts_updated_aggregate?: Maybe<Blackouts_Aggregate_Order_By>;
  booking_series_created_aggregate?: Maybe<Booking_Series_Aggregate_Order_By>;
  booking_series_updated_aggregate?: Maybe<Booking_Series_Aggregate_Order_By>;
  bookings_created_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  bookings_updates_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  city?: Maybe<Order_By>;
  color?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<Users_Order_By>;
  deleted?: Maybe<Order_By>;
  dj_display?: Maybe<Order_By>;
  documents_created_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  documents_updated_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  email?: Maybe<Order_By>;
  facebook?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  genres?: Maybe<Order_By>;
  guidelines_created_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  guidelines_updated_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  instagram?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  messages_aggregate?: Maybe<Messages_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  talent_bookings_aggregate?: Maybe<Bookings_Aggregate_Order_By>;
  talent_documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  talent_guidelines_aggregate?: Maybe<Guidelines_Aggregate_Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  tenants_created_aggregate?: Maybe<Tenants_Aggregate_Order_By>;
  tenants_updated_aggregate?: Maybe<Tenants_Aggregate_Order_By>;
  threads_aggregate?: Maybe<Thread_Members_Aggregate_Order_By>;
  threads_created_aggregate?: Maybe<Threads_Aggregate_Order_By>;
  threads_updated_aggregate?: Maybe<Threads_Aggregate_Order_By>;
  tiktok?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  updated_by_user?: Maybe<Users_Order_By>;
  user_number?: Maybe<Order_By>;
  user_role?: Maybe<User_Roles_Order_By>;
  user_status?: Maybe<User_Status_Order_By>;
  user_type?: Maybe<User_Type_Order_By>;
  users_created_aggregate?: Maybe<Users_Aggregate_Order_By>;
  users_updated_aggregate?: Maybe<Users_Aggregate_Order_By>;
  website?: Maybe<Order_By>;
  x?: Maybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  Alias = 'alias',
  /** column name */
  Bday = 'bday',
  /** column name */
  Bio = 'bio',
  /** column name */
  City = 'city',
  /** column name */
  Color = 'color',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Email = 'email',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Genres = 'genres',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tiktok = 'tiktok',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserNumber = 'user_number',
  /** column name */
  Website = 'website',
  /** column name */
  X = 'x'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  bday?: Maybe<Scalars['date']>;
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  genres?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  role?: Maybe<User_Roles_Enum>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<User_Status_Enum>;
  tenant_id?: Maybe<Scalars['uuid']>;
  tiktok?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<User_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  user_number?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  user_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  user_number?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  user_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  user_number?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  user_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  user_number?: Maybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  bday?: Maybe<Scalars['date']>;
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  deleted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  genres?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  role?: Maybe<User_Roles_Enum>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<User_Status_Enum>;
  tenant_id?: Maybe<Scalars['uuid']>;
  tiktok?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<User_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['uuid']>;
  user_number?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  user_number?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  user_number?: Maybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  Alias = 'alias',
  /** column name */
  Bday = 'bday',
  /** column name */
  Bio = 'bio',
  /** column name */
  City = 'city',
  /** column name */
  Color = 'color',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Email = 'email',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Genres = 'genres',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tiktok = 'tiktok',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserNumber = 'user_number',
  /** column name */
  Website = 'website',
  /** column name */
  X = 'x'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  user_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  user_number?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  user_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  user_number?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  user_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  user_number?: Maybe<Order_By>;
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

export type AreaFragment = (
  Pick<Areas, 'id' | 'tenant_id' | 'venue_id' | 'status' | 'type' | 'area_number' | 'name' | 'description' | 'poc' | 'website' | 'instagram' | 'deleted' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'>
  & { area_status: Pick<Area_Status, 'value' | 'display'>, area_type: Pick<Area_Type, 'value' | 'display'>, tenant?: Maybe<Pick<Tenants, 'id' | 'name' | 'type' | 'timezone'>>, venue?: Maybe<Pick<Tenants, 'id' | 'name' | 'type'>>, created_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'last_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, updated_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )> }
);

export type GetAreasQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Areas_Select_Column> | Areas_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By> | Areas_Order_By>;
  where?: Maybe<Areas_Bool_Exp>;
}>;


export type GetAreasQuery = { meta: { aggregate?: Maybe<Pick<Areas_Aggregate_Fields, 'count'>> }, items: Array<AreaFragment> };

export type GetAreaQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAreaQuery = { item?: Maybe<AreaFragment> };

export type CreateAreaMutationVariables = Exact<{
  object: Areas_Insert_Input;
}>;


export type CreateAreaMutation = { item?: Maybe<Pick<Areas, 'id'>> };

export type UpdateAreaMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Areas_Set_Input;
}>;


export type UpdateAreaMutation = { item?: Maybe<AreaFragment> };

export type DeleteAreaMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteAreaMutation = { item?: Maybe<Pick<Areas, 'id'>> };

export type SyncGetAreasMetaSubscriptionVariables = Exact<{
  where?: Maybe<Areas_Bool_Exp>;
}>;


export type SyncGetAreasMetaSubscription = { meta: { aggregate?: Maybe<Pick<Areas_Aggregate_Fields, 'count'>> } };

export type SyncGetAreasSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Areas_Select_Column> | Areas_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By> | Areas_Order_By>;
  where?: Maybe<Areas_Bool_Exp>;
}>;


export type SyncGetAreasSubscription = { items: Array<AreaFragment> };

export type SyncGetAreaSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetAreaSubscription = { item?: Maybe<AreaFragment> };

export type BlackoutFragment = (
  Pick<Blackouts, 'id' | 'talent_id' | 'start_at' | 'end_at' | 'description' | 'deleted' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'>
  & { talent: Pick<Users, 'tenant_id' | 'role' | 'status' | 'type' | 'email' | 'alias' | 'user_number' | 'name' | 'first_name' | 'last_name' | 'address_line1' | 'address_line2' | 'city' | 'state' | 'country' | 'postal_code' | 'phone' | 'genres' | 'color' | 'timezone'>, created_by_user?: Maybe<Pick<Users, 'email' | 'first_name' | 'last_name' | 'type' | 'role' | 'color' | 'timezone'>>, updated_by_user?: Maybe<Pick<Users, 'email' | 'first_name' | 'type' | 'role' | 'color' | 'timezone'>> }
);

export type GetBlackoutsQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Blackouts_Select_Column> | Blackouts_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By> | Blackouts_Order_By>;
  where?: Maybe<Blackouts_Bool_Exp>;
}>;


export type GetBlackoutsQuery = { meta: { aggregate?: Maybe<Pick<Blackouts_Aggregate_Fields, 'count'>> }, items: Array<BlackoutFragment> };

export type GetBlackoutQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetBlackoutQuery = { item?: Maybe<BlackoutFragment> };

export type CreateBlackoutMutationVariables = Exact<{
  object: Blackouts_Insert_Input;
}>;


export type CreateBlackoutMutation = { item?: Maybe<Pick<Blackouts, 'id'>> };

export type UpdateBlackoutMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Blackouts_Set_Input;
}>;


export type UpdateBlackoutMutation = { item?: Maybe<BlackoutFragment> };

export type DeleteBlackoutMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteBlackoutMutation = { item?: Maybe<Pick<Blackouts, 'id'>> };

export type SyncGetBlackoutsMetaSubscriptionVariables = Exact<{
  where?: Maybe<Blackouts_Bool_Exp>;
}>;


export type SyncGetBlackoutsMetaSubscription = { meta: { aggregate?: Maybe<Pick<Blackouts_Aggregate_Fields, 'count'>> } };

export type SyncGetBlackoutsSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Blackouts_Select_Column> | Blackouts_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Blackouts_Order_By> | Blackouts_Order_By>;
  where?: Maybe<Blackouts_Bool_Exp>;
}>;


export type SyncGetBlackoutsSubscription = { items: Array<BlackoutFragment> };

export type SyncGetAllBlackoutsSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Blackouts_Select_Column> | Blackouts_Select_Column>;
  order_by?: Maybe<Array<Blackouts_Order_By> | Blackouts_Order_By>;
  where?: Maybe<Blackouts_Bool_Exp>;
}>;


export type SyncGetAllBlackoutsSubscription = { items: Array<BlackoutFragment> };

export type SyncGetBlackoutSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetBlackoutSubscription = { item?: Maybe<BlackoutFragment> };

export type BookingFragment = (
  Pick<Bookings, 'id' | 'status' | 'series_id' | 'recurring' | 'is_master' | 'tenant_id' | 'venue_id' | 'area_id' | 'talent_id' | 'date' | 'event_start_time' | 'event_end_time' | 'set_start_time' | 'set_end_time' | 'notes' | 'rate' | 'rate_type' | 'rate_margin' | 'type' | 'invoice_target' | 'poc' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'>
  & { booking_type?: Maybe<Pick<Booking_Type, 'value' | 'display'>>, booking_rate_type?: Maybe<Pick<Rate_Type, 'value' | 'display'>>, booking_invoice_target?: Maybe<Pick<Invoice_Target, 'value' | 'display'>>, booking_status: Pick<Booking_Status, 'value' | 'display'>, tenant?: Maybe<(
    Pick<Tenants, 'type' | 'tenant_number' | 'name' | 'timezone'>
    & { tenant_type: Pick<Tenant_Type, 'value' | 'display'> }
  )>, venue?: Maybe<(
    Pick<Tenants, 'type' | 'tenant_number' | 'name' | 'address_line1' | 'address_line2' | 'city' | 'state' | 'country' | 'postal_code' | 'phone' | 'timezone'>
    & { tenant_type: Pick<Tenant_Type, 'value' | 'display'> }
  )>, area?: Maybe<(
    Pick<Areas, 'type' | 'area_number' | 'name' | 'description'>
    & { area_type: Pick<Area_Type, 'value' | 'display'> }
  )>, talent?: Maybe<(
    Pick<Users, 'tenant_id' | 'role' | 'status' | 'type' | 'email' | 'alias' | 'dj_display' | 'user_number' | 'name' | 'first_name' | 'last_name' | 'address_line1' | 'address_line2' | 'city' | 'state' | 'country' | 'postal_code' | 'phone' | 'genres' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, created_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'last_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, updated_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, series?: Maybe<BookingSeriesFragment>, guidelines: Array<GuidelineFragment> }
);

export type BookingSeriesFragment = Pick<Booking_Series, 'id' | 'master_booking_id' | 'tenant_id' | 'start_date' | 'end_date' | 'frequency' | 'interval' | 'count' | 'by_day' | 'by_month_day' | 'rrule' | 'timezone' | 'next_expansion' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'>;

export type GetBookingsQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Bookings_Select_Column> | Bookings_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By> | Bookings_Order_By>;
  where?: Maybe<Bookings_Bool_Exp>;
}>;


export type GetBookingsQuery = { meta: { aggregate?: Maybe<Pick<Bookings_Aggregate_Fields, 'count'>> }, items: Array<BookingFragment> };

export type GetBookingQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetBookingQuery = { item?: Maybe<BookingFragment> };

export type CreateBookingMutationVariables = Exact<{
  object: Bookings_Insert_Input;
}>;


export type CreateBookingMutation = { item?: Maybe<Pick<Bookings, 'id'>> };

export type UpdateBookingMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Bookings_Set_Input;
}>;


export type UpdateBookingMutation = { item?: Maybe<BookingFragment> };

export type DeleteBookingMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteBookingMutation = { item?: Maybe<Pick<Bookings, 'id'>> };

export type SyncGetBookingsMetaSubscriptionVariables = Exact<{
  where?: Maybe<Bookings_Bool_Exp>;
}>;


export type SyncGetBookingsMetaSubscription = { meta: { aggregate?: Maybe<Pick<Bookings_Aggregate_Fields, 'count'>> } };

export type SyncGetBookingsSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Bookings_Select_Column> | Bookings_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bookings_Order_By> | Bookings_Order_By>;
  where?: Maybe<Bookings_Bool_Exp>;
}>;


export type SyncGetBookingsSubscription = { items: Array<BookingFragment> };

export type SyncGetAllBookingsSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Bookings_Select_Column> | Bookings_Select_Column>;
  order_by?: Maybe<Array<Bookings_Order_By> | Bookings_Order_By>;
  where?: Maybe<Bookings_Bool_Exp>;
}>;


export type SyncGetAllBookingsSubscription = { items: Array<BookingFragment> };

export type SyncGetBookingSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetBookingSubscription = { item?: Maybe<BookingFragment> };

export type CreateBookingWithSeriesMutationVariables = Exact<{
  date: Scalars['date'];
  set_start_time: Scalars['time'];
  set_end_time: Scalars['time'];
  talent_id?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
  area_id?: Maybe<Scalars['uuid']>;
  event_start_time?: Maybe<Scalars['time']>;
  event_end_time?: Maybe<Scalars['time']>;
  notes?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  recurring?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  interval?: Maybe<Scalars['Int']>;
  poc?: Maybe<Scalars['String']>;
  rate_type?: Maybe<Scalars['String']>;
  rate_margin?: Maybe<Scalars['numeric']>;
  invoice_target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  by_day?: Maybe<Scalars['_text']>;
  by_month_day?: Maybe<Scalars['_int4']>;
  rrule?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
}>;


export type CreateBookingWithSeriesMutation = { item?: Maybe<Pick<Bookings, 'id'>> };

export type DocumentFragment = (
  Pick<Documents, 'id' | 'tenant_id' | 'venue_id' | 'area_id' | 'talent_id' | 'booking_id' | 'status' | 'type' | 'role' | 'url' | 'filename' | 'size' | 'filetype' | 'deleted' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'>
  & { document_status: Pick<Document_Status, 'value' | 'display'>, document_type: Pick<Document_Type, 'value' | 'display'>, talent?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'last_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, created_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'last_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, updated_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )> }
);

export type GetDocumentsQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Documents_Select_Column> | Documents_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By> | Documents_Order_By>;
  where?: Maybe<Documents_Bool_Exp>;
}>;


export type GetDocumentsQuery = { meta: { aggregate?: Maybe<Pick<Documents_Aggregate_Fields, 'count'>> }, items: Array<DocumentFragment> };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetDocumentQuery = { item?: Maybe<DocumentFragment> };

export type CreateDocumentMutationVariables = Exact<{
  object: Documents_Insert_Input;
}>;


export type CreateDocumentMutation = { item?: Maybe<Pick<Documents, 'id'>> };

export type CreateDocumentsMutationVariables = Exact<{
  objects: Array<Documents_Insert_Input> | Documents_Insert_Input;
}>;


export type CreateDocumentsMutation = { items?: Maybe<{ returning: Array<DocumentFragment> }> };

export type UpdateDocumentMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Documents_Set_Input;
}>;


export type UpdateDocumentMutation = { item?: Maybe<DocumentFragment> };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteDocumentMutation = { item?: Maybe<Pick<Documents, 'id'>> };

export type SyncGetDocumentsMetaSubscriptionVariables = Exact<{
  where?: Maybe<Documents_Bool_Exp>;
}>;


export type SyncGetDocumentsMetaSubscription = { meta: { aggregate?: Maybe<Pick<Documents_Aggregate_Fields, 'count'>> } };

export type SyncGetDocumentsSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Documents_Select_Column> | Documents_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By> | Documents_Order_By>;
  where?: Maybe<Documents_Bool_Exp>;
}>;


export type SyncGetDocumentsSubscription = { items: Array<DocumentFragment> };

export type SyncGetDocumentSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetDocumentSubscription = { item?: Maybe<DocumentFragment> };

export type GuidelineFragment = (
  Pick<Guidelines, 'id' | 'tenant_id' | 'venue_id' | 'area_id' | 'talent_id' | 'booking_id' | 'status' | 'type' | 'role' | 'name' | 'description' | 'information' | 'document_id' | 'parent_guideline_id' | 'parent_guideline_type' | 'target_booking_status' | 'target_booking_type' | 'tenant_required' | 'venue_required' | 'talent_required' | 'tenant_confirmed' | 'venue_confirmed' | 'talent_confirmed' | 'tenant_completed' | 'venue_completed' | 'talent_completed' | 'deleted' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by' | 'metadata'>
  & { guideline_status: Pick<Guideline_Status, 'value' | 'display'>, guideline_type: Pick<Guideline_Type, 'value' | 'display'>, guideline_role?: Maybe<Pick<Guideline_Role, 'value' | 'display'>>, document?: Maybe<Pick<Documents, 'id' | 'filename'>>, parent_guideline?: Maybe<Pick<Guidelines, 'id' | 'name'>>, parent_guideline_type_enum?: Maybe<Pick<Guideline_Type, 'value' | 'display'>>, target_booking_status_enum?: Maybe<Pick<Booking_Status, 'value' | 'display'>>, target_booking_type_enum?: Maybe<Pick<Booking_Type, 'value' | 'display'>>, tenant?: Maybe<Pick<Tenants, 'type' | 'tenant_number' | 'name' | 'timezone'>>, venue?: Maybe<Pick<Tenants, 'type' | 'tenant_number' | 'name' | 'timezone'>>, talent?: Maybe<(
    Pick<Users, 'name' | 'tenant_id' | 'role' | 'status' | 'type' | 'email' | 'user_number' | 'first_name' | 'last_name' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, booking?: Maybe<Pick<Bookings, 'status' | 'date'>>, created_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'last_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, updated_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )> }
);

export type GetGuidelinesQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Guidelines_Select_Column> | Guidelines_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By> | Guidelines_Order_By>;
  where?: Maybe<Guidelines_Bool_Exp>;
}>;


export type GetGuidelinesQuery = { meta: { aggregate?: Maybe<Pick<Guidelines_Aggregate_Fields, 'count'>> }, items: Array<GuidelineFragment> };

export type GetGuidelineQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetGuidelineQuery = { item?: Maybe<GuidelineFragment> };

export type CreateGuidelineMutationVariables = Exact<{
  object: Guidelines_Insert_Input;
}>;


export type CreateGuidelineMutation = { item?: Maybe<Pick<Guidelines, 'id'>> };

export type UpdateGuidelineMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Guidelines_Set_Input;
}>;


export type UpdateGuidelineMutation = { item?: Maybe<GuidelineFragment> };

export type DeleteGuidelineMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteGuidelineMutation = { item?: Maybe<Pick<Guidelines, 'id'>> };

export type SyncGetGuidelinesMetaSubscriptionVariables = Exact<{
  where?: Maybe<Guidelines_Bool_Exp>;
}>;


export type SyncGetGuidelinesMetaSubscription = { meta: { aggregate?: Maybe<Pick<Guidelines_Aggregate_Fields, 'count'>> } };

export type SyncGetGuidelinesSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Guidelines_Select_Column> | Guidelines_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Guidelines_Order_By> | Guidelines_Order_By>;
  where?: Maybe<Guidelines_Bool_Exp>;
}>;


export type SyncGetGuidelinesSubscription = { items: Array<GuidelineFragment> };

export type SyncGetGuidelineSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetGuidelineSubscription = { item?: Maybe<GuidelineFragment> };

export type MessageFragment = (
  Pick<Messages, 'id' | 'tenant_id' | 'thread_id' | 'author_id' | 'type' | 'body' | 'meta' | 'created_at' | 'updated_at' | 'idem_key'>
  & { author?: Maybe<(
    Pick<Users, 'name' | 'email' | 'role' | 'type' | 'color'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, message_type: Pick<Message_Type, 'value' | 'display'>, thread: Pick<Threads, 'created_by'> }
);

export type GetMessagesQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Messages_Select_Column> | Messages_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By> | Messages_Order_By>;
  where?: Maybe<Messages_Bool_Exp>;
}>;


export type GetMessagesQuery = { meta: { aggregate?: Maybe<Pick<Messages_Aggregate_Fields, 'count'>> }, items: Array<MessageFragment> };

export type GetMessageQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetMessageQuery = { item?: Maybe<MessageFragment> };

export type CreateMessageMutationVariables = Exact<{
  object: Messages_Insert_Input;
}>;


export type CreateMessageMutation = { item?: Maybe<Pick<Messages, 'id'>> };

export type UpdateMessageMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Messages_Set_Input;
}>;


export type UpdateMessageMutation = { item?: Maybe<MessageFragment> };

export type DeleteMessageMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteMessageMutation = { item?: Maybe<Pick<Messages, 'id'>> };

export type SyncGetMessagesMetaSubscriptionVariables = Exact<{
  where?: Maybe<Messages_Bool_Exp>;
}>;


export type SyncGetMessagesMetaSubscription = { meta: { aggregate?: Maybe<Pick<Messages_Aggregate_Fields, 'count'>> } };

export type SyncGetMessagesSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Messages_Select_Column> | Messages_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Messages_Order_By> | Messages_Order_By>;
  where?: Maybe<Messages_Bool_Exp>;
}>;


export type SyncGetMessagesSubscription = { items: Array<MessageFragment> };

export type SyncGetMessageSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetMessageSubscription = { item?: Maybe<MessageFragment> };

export type TenantFragment = (
  Pick<Tenants, 'id' | 'status' | 'type' | 'tenant_number' | 'name' | 'address_line1' | 'address_line2' | 'city' | 'state' | 'country' | 'postal_code' | 'phone' | 'instagram' | 'website' | 'logo' | 'anniversary' | 'deleted' | 'poc' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by' | 'timezone'>
  & { created_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'last_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, updated_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, tenant_status: Pick<Tenant_Status, 'value' | 'display'>, tenant_type: Pick<Tenant_Type, 'value' | 'display'> }
);

export type GetTenantsQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Tenants_Select_Column> | Tenants_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By> | Tenants_Order_By>;
  where?: Maybe<Tenants_Bool_Exp>;
}>;


export type GetTenantsQuery = { meta: { aggregate?: Maybe<Pick<Tenants_Aggregate_Fields, 'count'>> }, items: Array<TenantFragment> };

export type GetTenantQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetTenantQuery = { item?: Maybe<TenantFragment> };

export type CreateTenantMutationVariables = Exact<{
  object: Tenants_Insert_Input;
}>;


export type CreateTenantMutation = { item?: Maybe<Pick<Tenants, 'id'>> };

export type UpdateTenantMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Tenants_Set_Input;
}>;


export type UpdateTenantMutation = { item?: Maybe<TenantFragment> };

export type DeleteTenantMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteTenantMutation = { item?: Maybe<Pick<Tenants, 'id'>> };

export type SyncGetTenantsMetaSubscriptionVariables = Exact<{
  where?: Maybe<Tenants_Bool_Exp>;
}>;


export type SyncGetTenantsMetaSubscription = { meta: { aggregate?: Maybe<Pick<Tenants_Aggregate_Fields, 'count'>> } };

export type SyncGetTenantsSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Tenants_Select_Column> | Tenants_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By> | Tenants_Order_By>;
  where?: Maybe<Tenants_Bool_Exp>;
}>;


export type SyncGetTenantsSubscription = { items: Array<TenantFragment> };

export type SyncGetTenantSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetTenantSubscription = { item?: Maybe<TenantFragment> };

export type ThreadFragment = (
  Pick<Threads, 'id' | 'status' | 'type' | 'tenant_id' | 'venue_id' | 'booking_id' | 'subject' | 'deleted' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by' | 'unread_count'>
  & { created_by_user?: Maybe<(
    Pick<Users, 'first_name' | 'last_name' | 'email' | 'name' | 'color'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, thread_status: Pick<Thread_Status, 'value' | 'display'>, thread_type: Pick<Thread_Type, 'value' | 'display'>, thread_members: Array<{ user: (
      Pick<Users, 'name' | 'first_name' | 'color'>
      & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
    ) }>, thread_departments: Array<{ department_type: Pick<User_Type, 'value' | 'display'> }> }
);

export type GetThreadsQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Threads_Select_Column> | Threads_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By> | Threads_Order_By>;
  where?: Maybe<Threads_Bool_Exp>;
}>;


export type GetThreadsQuery = { meta: { aggregate?: Maybe<Pick<Threads_Aggregate_Fields, 'count'>> }, items: Array<ThreadFragment> };

export type GetThreadQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetThreadQuery = { item?: Maybe<ThreadFragment> };

export type CreateThreadMutationVariables = Exact<{
  object: Threads_Insert_Input;
}>;


export type CreateThreadMutation = { item?: Maybe<Pick<Threads, 'id'>> };

export type UpdateThreadMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Threads_Set_Input;
}>;


export type UpdateThreadMutation = { item?: Maybe<ThreadFragment> };

export type DeleteThreadMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteThreadMutation = { item?: Maybe<Pick<Threads, 'id'>> };

export type SyncGetThreadsMetaSubscriptionVariables = Exact<{
  where?: Maybe<Threads_Bool_Exp>;
}>;


export type SyncGetThreadsMetaSubscription = { meta: { aggregate?: Maybe<Pick<Threads_Aggregate_Fields, 'count'>> } };

export type SyncGetThreadsSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Threads_Select_Column> | Threads_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Threads_Order_By> | Threads_Order_By>;
  where?: Maybe<Threads_Bool_Exp>;
}>;


export type SyncGetThreadsSubscription = { items: Array<ThreadFragment> };

export type SyncGetThreadSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetThreadSubscription = { item?: Maybe<ThreadFragment> };

export type CreateThreadWithMessageMutationVariables = Exact<{
  body: Scalars['String'];
  departments?: Maybe<Scalars['_text']>;
  idempotency_key?: Maybe<Scalars['uuid']>;
  message_type?: Maybe<Scalars['String']>;
  recipient_ids?: Maybe<Scalars['_uuid']>;
  subject: Scalars['String'];
  thread_type?: Maybe<Scalars['String']>;
}>;


export type CreateThreadWithMessageMutation = { item?: Maybe<Pick<Threads, 'id'>> };

export type MarkThreadReadMutationVariables = Exact<{
  thread_id?: Maybe<Scalars['uuid']>;
  to_message_id?: Maybe<Scalars['uuid']>;
}>;


export type MarkThreadReadMutation = { item?: Maybe<Pick<Thread_Members, 'user_id' | 'thread_id' | 'last_read_at' | 'joined_at'>> };

export type UserFragment = (
  Pick<Users, 'id' | 'tenant_id' | 'role' | 'status' | 'type' | 'email' | 'name' | 'dj_display' | 'user_number' | 'first_name' | 'last_name' | 'alias' | 'address_line1' | 'address_line2' | 'city' | 'state' | 'country' | 'postal_code' | 'phone' | 'bday' | 'website' | 'instagram' | 'facebook' | 'x' | 'tiktok' | 'genres' | 'bio' | 'color' | 'timezone' | 'deleted' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'>
  & { tenant?: Maybe<Pick<Tenants, 'id' | 'name' | 'type' | 'timezone'>>, created_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'last_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, updated_by_user?: Maybe<(
    Pick<Users, 'name' | 'email' | 'first_name' | 'type' | 'role' | 'color' | 'timezone'>
    & { user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
  )>, user_role: Pick<User_Roles, 'value' | 'display'>, user_type: Pick<User_Type, 'value' | 'display'>, user_status: Pick<User_Status, 'value' | 'display'> }
);

export type GetUsersQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Users_Select_Column> | Users_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By> | Users_Order_By>;
  where?: Maybe<Users_Bool_Exp>;
}>;


export type GetUsersQuery = { meta: { aggregate?: Maybe<Pick<Users_Aggregate_Fields, 'count'>> }, items: Array<UserFragment> };

export type FindUsersQueryVariables = Exact<{
  distinct_on?: Maybe<Array<Users_Select_Column> | Users_Select_Column>;
  order_by?: Maybe<Array<Users_Order_By> | Users_Order_By>;
  where?: Maybe<Users_Bool_Exp>;
}>;


export type FindUsersQuery = { meta: { aggregate?: Maybe<Pick<Users_Aggregate_Fields, 'count'>> }, items: Array<UserFragment> };

export type GetUserQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserQuery = { item?: Maybe<UserFragment> };

export type CreateUserMutationVariables = Exact<{
  object: Users_Insert_Input;
}>;


export type CreateUserMutation = { item?: Maybe<Pick<Users, 'id'>> };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Users_Set_Input;
}>;


export type UpdateUserMutation = { item?: Maybe<UserFragment> };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteUserMutation = { item?: Maybe<Pick<Users, 'id'>> };

export type SyncGetUsersMetaSubscriptionVariables = Exact<{
  where?: Maybe<Users_Bool_Exp>;
}>;


export type SyncGetUsersMetaSubscription = { meta: { aggregate?: Maybe<Pick<Users_Aggregate_Fields, 'count'>> } };

export type SyncGetUsersSubscriptionVariables = Exact<{
  distinct_on?: Maybe<Array<Users_Select_Column> | Users_Select_Column>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By> | Users_Order_By>;
  where?: Maybe<Users_Bool_Exp>;
}>;


export type SyncGetUsersSubscription = { items: Array<UserFragment> };

export type SyncGetUserSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SyncGetUserSubscription = { item?: Maybe<UserFragment> };

export type CheckUserEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckUserEmailQuery = { items: Array<UserFragment> };
